/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NolayoutRouteImport } from './routes/_nolayout'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NolayoutPublicPageRouteImport } from './routes/_nolayout/public-page'
import { Route as LayoutUnauthorisedRouteImport } from './routes/_layout/unauthorised'
import { Route as LayoutTimetablesRouteImport } from './routes/_layout/timetables'
import { Route as LayoutTicketsRouteImport } from './routes/_layout/tickets'
import { Route as LayoutTeacherPortalRouteImport } from './routes/_layout/teacher-portal'
import { Route as LayoutTabsRouteImport } from './routes/_layout/tabs'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutRoomsRouteImport } from './routes/_layout/rooms'
import { Route as LayoutReportHubRouteImport } from './routes/_layout/report-hub'
import { Route as LayoutParentShopRouteImport } from './routes/_layout/parent-shop'
import { Route as LayoutNotificationsRouteImport } from './routes/_layout/notifications'
import { Route as LayoutNoticesRouteImport } from './routes/_layout/notices'
import { Route as LayoutMapRouteImport } from './routes/_layout/map'
import { Route as LayoutHomeRouteImport } from './routes/_layout/home'
import { Route as LayoutFeedRouteImport } from './routes/_layout/feed'
import { Route as LayoutBookARoomRouteImport } from './routes/_layout/book-a-room'
import { Route as NolayoutAuthRouteRouteImport } from './routes/_nolayout/_auth/route'
import { Route as LayoutToolsRouteRouteImport } from './routes/_layout/tools/route'
import { Route as LayoutStudentsRouteRouteImport } from './routes/_layout/students/route'
import { Route as LayoutStaffRouteRouteImport } from './routes/_layout/staff/route'
import { Route as LayoutReportsRouteRouteImport } from './routes/_layout/reports/route'
import { Route as LayoutReferralsRouteRouteImport } from './routes/_layout/referrals/route'
import { Route as LayoutParentsRouteRouteImport } from './routes/_layout/parents/route'
import { Route as LayoutMeRouteRouteImport } from './routes/_layout/me/route'
import { Route as LayoutCommunicationRouteRouteImport } from './routes/_layout/communication/route'
import { Route as LayoutCarsRouteRouteImport } from './routes/_layout/cars/route'
import { Route as LayoutCalendarRouteRouteImport } from './routes/_layout/calendar/route'
import { Route as LayoutAssetsRouteRouteImport } from './routes/_layout/assets/route'
import { Route as LayoutAdminRouteRouteImport } from './routes/_layout/admin/route'
import { Route as LayoutTeacherPortalRouteRouteImport } from './routes/_layout/_teacher-portal/route'
import { Route as NolayoutInductionIndexRouteImport } from './routes/_nolayout/induction/index'
import { Route as LayoutToolsIndexRouteImport } from './routes/_layout/tools/index'
import { Route as LayoutStudentsIndexRouteImport } from './routes/_layout/students/index'
import { Route as LayoutStaffIndexRouteImport } from './routes/_layout/staff/index'
import { Route as LayoutReferralsIndexRouteImport } from './routes/_layout/referrals/index'
import { Route as LayoutParentsEveningIndexRouteImport } from './routes/_layout/parents-evening/index'
import { Route as LayoutMeIndexRouteImport } from './routes/_layout/me/index'
import { Route as LayoutCommunicationIndexRouteImport } from './routes/_layout/communication/index'
import { Route as LayoutCalendarIndexRouteImport } from './routes/_layout/calendar/index'
import { Route as LayoutAssetsIndexRouteImport } from './routes/_layout/assets/index'
import { Route as LayoutAdminIndexRouteImport } from './routes/_layout/admin/index'
import { Route as NolayoutAuthSignInRouteImport } from './routes/_nolayout/_auth/sign-in'
import { Route as NolayoutAuthRegisterRouteImport } from './routes/_nolayout/_auth/register'
import { Route as LayoutToolsSoundboardRouteImport } from './routes/_layout/tools/soundboard'
import { Route as LayoutToolsSortathonRouteImport } from './routes/_layout/tools/sortathon'
import { Route as LayoutToolsSendTeamsMessageRouteImport } from './routes/_layout/tools/send-teams-message'
import { Route as LayoutToolsQrCodeMakerRouteImport } from './routes/_layout/tools/qr-code-maker'
import { Route as LayoutTimetablesTypeRouteImport } from './routes/_layout/timetables.$type'
import { Route as LayoutStudentsMyRouteImport } from './routes/_layout/students/my'
import { Route as LayoutStudentsListsRouteImport } from './routes/_layout/students/lists'
import { Route as LayoutStudentsFinderRouteImport } from './routes/_layout/students/finder'
import { Route as LayoutStudentFuturesDestinationsRouteImport } from './routes/_layout/student-futures/destinations'
import { Route as LayoutStaffStaffDirectoryRouteImport } from './routes/_layout/staff/staff-directory'
import { Route as LayoutStaffOnSiteRouteImport } from './routes/_layout/staff/on-site'
import { Route as LayoutStaffFinderRouteImport } from './routes/_layout/staff/finder'
import { Route as LayoutReportsDestinationsRouteImport } from './routes/_layout/reports/destinations'
import { Route as LayoutReferralsStudySupportRouteImport } from './routes/_layout/referrals/study-support'
import { Route as LayoutReferralsExamAccessArrangementsRouteImport } from './routes/_layout/referrals/exam-access-arrangements'
import { Route as LayoutParentsAllRouteImport } from './routes/_layout/parents/all'
import { Route as LayoutParentsEveningMeetRouteImport } from './routes/_layout/parents-evening/meet'
import { Route as LayoutParentsEveningBookRouteImport } from './routes/_layout/parents-evening/book'
import { Route as LayoutMeTabRouteImport } from './routes/_layout/me/$tab'
import { Route as LayoutDocumentsChar123FolderIdChar125RouteImport } from './routes/_layout/documents/{-$folderId}'
import { Route as LayoutCommunicationFeedRouteImport } from './routes/_layout/communication/feed'
import { Route as LayoutCommunicationEmailRouteImport } from './routes/_layout/communication/email'
import { Route as LayoutCommunicationCampaignsRouteImport } from './routes/_layout/communication/campaigns'
import { Route as LayoutCarsSearchRouteImport } from './routes/_layout/cars/search'
import { Route as LayoutCarsAllRouteImport } from './routes/_layout/cars/all'
import { Route as LayoutCalendarViewRouteImport } from './routes/_layout/calendar/_view'
import { Route as LayoutAssetsProjectorTypesRouteImport } from './routes/_layout/assets/projector-types'
import { Route as LayoutAssetsPrintersRouteImport } from './routes/_layout/assets/printers'
import { Route as LayoutAssetsMonitorsRouteImport } from './routes/_layout/assets/monitors'
import { Route as LayoutAssetsComputersRouteImport } from './routes/_layout/assets/computers'
import { Route as LayoutAssetsCardPrinterRouteImport } from './routes/_layout/assets/card-printer'
import { Route as LayoutAdminTeamsAppInstallationsRouteImport } from './routes/_layout/admin/teams-app-installations'
import { Route as LayoutAdminStudentListsRouteImport } from './routes/_layout/admin/student-lists'
import { Route as LayoutAdminRolesRouteImport } from './routes/_layout/admin/roles'
import { Route as LayoutAdminPermissionsRouteImport } from './routes/_layout/admin/permissions'
import { Route as LayoutAdminConnectedUsersRouteImport } from './routes/_layout/admin/connected-users'
import { Route as LayoutAdminCalendarRouteImport } from './routes/_layout/admin/calendar'
import { Route as LayoutAdminBannersRouteImport } from './routes/_layout/admin/banners'
import { Route as LayoutTeacherPortalWatchlistsRouteImport } from './routes/_layout/_teacher-portal/watchlists'
import { Route as LayoutTeacherPortalCoursesRouteImport } from './routes/_layout/_teacher-portal/courses'
import { Route as LayoutTeacherPortalActionPlansRouteImport } from './routes/_layout/_teacher-portal/action-plans'
import { Route as LayoutToolsTeamsAdministrationRouteRouteImport } from './routes/_layout/tools/teams-administration/route'
import { Route as LayoutStudentsStudentNoRouteRouteImport } from './routes/_layout/students/$studentNo/route'
import { Route as LayoutStaffInitialsRouteRouteImport } from './routes/_layout/staff/$initials/route'
import { Route as LayoutReferralsWellbeingRouteRouteImport } from './routes/_layout/referrals/wellbeing/route'
import { Route as LayoutParentsParentIdRouteRouteImport } from './routes/_layout/parents/$parentId/route'
import { Route as LayoutCommunicationNotificationsRouteRouteImport } from './routes/_layout/communication/notifications/route'
import { Route as LayoutCalendarEventsRouteRouteImport } from './routes/_layout/calendar/events/route'
import { Route as LayoutTeacherPortalGroupsRouteRouteImport } from './routes/_layout/_teacher-portal/groups/route'
import { Route as LayoutToolsTeamsAdministrationIndexRouteImport } from './routes/_layout/tools/teams-administration/index'
import { Route as LayoutStudentsStudentNoIndexRouteImport } from './routes/_layout/students/$studentNo/index'
import { Route as LayoutStaffInitialsIndexRouteImport } from './routes/_layout/staff/$initials/index'
import { Route as LayoutReferralsWellbeingIndexRouteImport } from './routes/_layout/referrals/wellbeing/index'
import { Route as LayoutParentsParentIdIndexRouteImport } from './routes/_layout/parents/$parentId/index'
import { Route as LayoutAssetsCardPrinterIndexRouteImport } from './routes/_layout/assets/card-printer/index'
import { Route as LayoutTimetablesTypeIdentifierRouteImport } from './routes/_layout/timetables.$type.$identifier'
import { Route as LayoutStudentsStudentNoTimetableRouteImport } from './routes/_layout/students/$studentNo/timetable'
import { Route as LayoutStudentsStudentNoSupportRouteImport } from './routes/_layout/students/$studentNo/support'
import { Route as LayoutStudentsStudentNoSummaryRouteImport } from './routes/_layout/students/$studentNo/summary'
import { Route as LayoutStudentsStudentNoStudentAgreementsRouteImport } from './routes/_layout/students/$studentNo/student-agreements'
import { Route as LayoutStudentsStudentNoReviewsRouteImport } from './routes/_layout/students/$studentNo/reviews'
import { Route as LayoutStudentsStudentNoPhotoRouteImport } from './routes/_layout/students/$studentNo/photo'
import { Route as LayoutStudentsStudentNoParentsRouteImport } from './routes/_layout/students/$studentNo/parents'
import { Route as LayoutStudentsStudentNoMarkbookRouteImport } from './routes/_layout/students/$studentNo/markbook'
import { Route as LayoutStudentsStudentNoGcseRouteImport } from './routes/_layout/students/$studentNo/gcse'
import { Route as LayoutStudentsStudentNoDocumentsRouteImport } from './routes/_layout/students/$studentNo/documents'
import { Route as LayoutStudentsStudentNoDetailsRouteImport } from './routes/_layout/students/$studentNo/details'
import { Route as LayoutStaffInitialsTimetableRouteImport } from './routes/_layout/staff/$initials/timetable'
import { Route as LayoutStaffInitialsRolesRouteImport } from './routes/_layout/staff/$initials/roles'
import { Route as LayoutStaffInitialsPhotoRouteImport } from './routes/_layout/staff/$initials/photo'
import { Route as LayoutReportsSarPastoralRouteImport } from './routes/_layout/reports/sar.pastoral'
import { Route as LayoutReportsSarCurriculumRouteImport } from './routes/_layout/reports/sar.curriculum'
import { Route as LayoutReferralsWellbeingMyRouteImport } from './routes/_layout/referrals/wellbeing/my'
import { Route as LayoutReferralsWellbeingCreateRouteImport } from './routes/_layout/referrals/wellbeing/create'
import { Route as LayoutReferralsWellbeingAssignedRouteImport } from './routes/_layout/referrals/wellbeing/assigned'
import { Route as LayoutParentsParentIdContactInfoRouteImport } from './routes/_layout/parents/$parentId/contact-info'
import { Route as LayoutCommunicationNotificationsTeamsNotificationsRouteImport } from './routes/_layout/communication/notifications/teams-notifications'
import { Route as LayoutCommunicationNotificationsPortalNotificationsRouteImport } from './routes/_layout/communication/notifications/portal-notifications'
import { Route as LayoutCalendarEventsNewRouteImport } from './routes/_layout/calendar/events/new'
import { Route as LayoutCalendarEventsEventIdRouteImport } from './routes/_layout/calendar/events/$eventId'
import { Route as LayoutAssetsCardPrinterPrintersRouteImport } from './routes/_layout/assets/card-printer/printers'
import { Route as LayoutAssetsCardPrinterPrintedCardsRouteImport } from './routes/_layout/assets/card-printer/printed-cards'
import { Route as LayoutAssetsCardPrinterPrintJobsRouteImport } from './routes/_layout/assets/card-printer/print-jobs'
import { Route as LayoutToolsTeamsAdministrationTeamsRouteRouteImport } from './routes/_layout/tools/teams-administration/teams/route'
import { Route as LayoutStudentsStudentNoConversationsRouteRouteImport } from './routes/_layout/students/$studentNo/conversations/route'
import { Route as LayoutStudentsStudentNoAttendanceRouteRouteImport } from './routes/_layout/students/$studentNo/attendance/route'
import { Route as LayoutStudentsStudentNoActionPlansRouteRouteImport } from './routes/_layout/students/$studentNo/action-plans/route'
import { Route as LayoutReferralsWellbeingManageRouteRouteImport } from './routes/_layout/referrals/wellbeing/manage/route'
import { Route as LayoutCarsStudentCarIdRouteRouteImport } from './routes/_layout/cars/student.$carId/route'
import { Route as LayoutCarsStaffCarIdRouteRouteImport } from './routes/_layout/cars/staff.$carId/route'
import { Route as LayoutTeacherPortalGroupsClassesRouteRouteImport } from './routes/_layout/_teacher-portal/groups/classes/route'
import { Route as LayoutToolsTeamsAdministrationTeamsIndexRouteImport } from './routes/_layout/tools/teams-administration/teams/index'
import { Route as LayoutStudentsStudentNoConversationsIndexRouteImport } from './routes/_layout/students/$studentNo/conversations/index'
import { Route as LayoutStudentsStudentNoAttendanceIndexRouteImport } from './routes/_layout/students/$studentNo/attendance/index'
import { Route as LayoutStudentsStudentNoActionPlansIndexRouteImport } from './routes/_layout/students/$studentNo/action-plans/index'
import { Route as LayoutCarsStudentCarIdIndexRouteImport } from './routes/_layout/cars/student.$carId/index'
import { Route as LayoutCarsStaffCarIdIndexRouteImport } from './routes/_layout/cars/staff.$carId/index'
import { Route as LayoutStudentsStudentNoConversationsConversationIdRouteImport } from './routes/_layout/students/$studentNo/conversations/$conversationId'
import { Route as LayoutStudentsStudentNoAttendancePunctualityRouteImport } from './routes/_layout/students/$studentNo/attendance/punctuality'
import { Route as LayoutStudentsStudentNoAttendanceAbsencesRouteImport } from './routes/_layout/students/$studentNo/attendance/absences'
import { Route as LayoutStudentsStudentNoActionPlansReferralsRouteImport } from './routes/_layout/students/$studentNo/action-plans/referrals'
import { Route as LayoutReferralsWellbeingMyReferralIdRouteImport } from './routes/_layout/referrals/wellbeing/my.$referralId'
import { Route as LayoutReferralsWellbeingManageReferralIdRouteImport } from './routes/_layout/referrals/wellbeing/manage/$referralId'
import { Route as LayoutReferralsWellbeingAssignedCategoryRouteImport } from './routes/_layout/referrals/wellbeing/assigned.$category'
import { Route as LayoutCarsStudentCarIdDvlaRouteImport } from './routes/_layout/cars/student.$carId/dvla'
import { Route as LayoutCarsStaffCarIdDvlaRouteImport } from './routes/_layout/cars/staff.$carId/dvla'
import { Route as LayoutCalendarEventsEventIdEditRouteImport } from './routes/_layout/calendar/events_.$eventId.edit'
import { Route as LayoutTeacherPortalGroupsMyCollegeRouteImport } from './routes/_layout/_teacher-portal/groups/my/college'
import { Route as LayoutTeacherPortalGroupsMyClassesRouteImport } from './routes/_layout/_teacher-portal/groups/my/classes'
import { Route as LayoutTeacherPortalGroupsAllSubjectsRouteImport } from './routes/_layout/_teacher-portal/groups/all/subjects'
import { Route as LayoutTeacherPortalGroupsAllFacultiesRouteImport } from './routes/_layout/_teacher-portal/groups/all/faculties'
import { Route as LayoutTeacherPortalGroupsAllDepartmentsRouteImport } from './routes/_layout/_teacher-portal/groups/all/departments'
import { Route as LayoutTeacherPortalGroupsAllCoursesRouteImport } from './routes/_layout/_teacher-portal/groups/all/courses'
import { Route as LayoutTeacherPortalGroupsAllClassesRouteImport } from './routes/_layout/_teacher-portal/groups/all/classes'
import { Route as LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteImport } from './routes/_layout/tools/teams-administration/teams/$teamId/route'
import { Route as LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteImport } from './routes/_layout/students/$studentNo/action-plans/academic-support/route'
import { Route as LayoutStudentsStudentNoActionPlansTypeRouteRouteImport } from './routes/_layout/students/$studentNo/action-plans/$type/route'
import { Route as LayoutTeacherPortalGroupsMyFacultyRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/route'
import { Route as LayoutTeacherPortalGroupsMyDepartmentRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/department/route'
import { Route as LayoutTeacherPortalGroupsClassesClassIdRouteRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/route'
import { Route as LayoutToolsTeamsAdministrationTeamsTeamIdIndexRouteImport } from './routes/_layout/tools/teams-administration/teams/$teamId/index'
import { Route as LayoutStudentsStudentNoActionPlansAcademicSupportIndexRouteImport } from './routes/_layout/students/$studentNo/action-plans/academic-support/index'
import { Route as LayoutStudentsStudentNoActionPlansTypeIndexRouteImport } from './routes/_layout/students/$studentNo/action-plans/$type/index'
import { Route as LayoutTeacherPortalGroupsSubjectSubjectIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/subject/$subjectId/index'
import { Route as LayoutTeacherPortalGroupsMyFacultyIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/index'
import { Route as LayoutTeacherPortalGroupsMyDepartmentIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/department/index'
import { Route as LayoutTeacherPortalGroupsFacultyFacultyIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/faculty/$facultyId/index'
import { Route as LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/department/$departmentId/index'
import { Route as LayoutTeacherPortalGroupsCourseCourseIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/course/$courseId/index'
import { Route as LayoutTeacherPortalGroupsClassesClassIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/index'
import { Route as LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteImport } from './routes/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug'
import { Route as LayoutReferralsWellbeingAssignedCategoryAssignmentIdRouteImport } from './routes/_layout/referrals/wellbeing/assigned.$category.$assignmentId'
import { Route as LayoutTeacherPortalGroupsClassesClassIdSupportRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/support'
import { Route as LayoutTeacherPortalGroupsClassesClassIdReferencesRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/references'
import { Route as LayoutTeacherPortalGroupsClassesClassIdOrbitRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/orbit'
import { Route as LayoutTeacherPortalGroupsClassesClassIdGalleryRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/gallery'
import { Route as LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/classroom-adjustments'
import { Route as LayoutTeacherPortalGroupsClassesClassIdAttendanceRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/attendance'
import { Route as LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRouteImport } from './routes/_layout/_teacher-portal/groups/classes/$classId/access-arrangements'
import { Route as LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/$departmentId/route'
import { Route as LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/department/$subjectId/route'
import { Route as LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/$departmentId/index'
import { Route as LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/department/$subjectId/index'
import { Route as LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRouteImport } from './routes/_layout/tools/teams-administration/teams/$teamId/channels.$channelId'
import { Route as LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/route'
import { Route as LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId/route'
import { Route as LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/index'
import { Route as LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId/index'
import { Route as LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRouteImport } from './routes/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId'
import { Route as LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/route'
import { Route as LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRouteImport } from './routes/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/index'

const NolayoutRoute = NolayoutRouteImport.update({
  id: '/_nolayout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NolayoutPublicPageRoute = NolayoutPublicPageRouteImport.update({
  id: '/public-page',
  path: '/public-page',
  getParentRoute: () => NolayoutRoute,
} as any)
const LayoutUnauthorisedRoute = LayoutUnauthorisedRouteImport.update({
  id: '/unauthorised',
  path: '/unauthorised',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTimetablesRoute = LayoutTimetablesRouteImport.update({
  id: '/timetables',
  path: '/timetables',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTicketsRoute = LayoutTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeacherPortalRoute = LayoutTeacherPortalRouteImport.update({
  id: '/teacher-portal',
  path: '/teacher-portal',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTabsRoute = LayoutTabsRouteImport.update({
  id: '/tabs',
  path: '/tabs',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoomsRoute = LayoutRoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutReportHubRoute = LayoutReportHubRouteImport.update({
  id: '/report-hub',
  path: '/report-hub',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutParentShopRoute = LayoutParentShopRouteImport.update({
  id: '/parent-shop',
  path: '/parent-shop',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutNotificationsRoute = LayoutNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutNoticesRoute = LayoutNoticesRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMapRoute = LayoutMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHomeRoute = LayoutHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutFeedRoute = LayoutFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutBookARoomRoute = LayoutBookARoomRouteImport.update({
  id: '/book-a-room',
  path: '/book-a-room',
  getParentRoute: () => LayoutRoute,
} as any)
const NolayoutAuthRouteRoute = NolayoutAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => NolayoutRoute,
} as any)
const LayoutToolsRouteRoute = LayoutToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStudentsRouteRoute = LayoutStudentsRouteRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStaffRouteRoute = LayoutStaffRouteRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutReportsRouteRoute = LayoutReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutReferralsRouteRoute = LayoutReferralsRouteRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutParentsRouteRoute = LayoutParentsRouteRouteImport.update({
  id: '/parents',
  path: '/parents',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMeRouteRoute = LayoutMeRouteRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCommunicationRouteRoute =
  LayoutCommunicationRouteRouteImport.update({
    id: '/communication',
    path: '/communication',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCarsRouteRoute = LayoutCarsRouteRouteImport.update({
  id: '/cars',
  path: '/cars',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCalendarRouteRoute = LayoutCalendarRouteRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAssetsRouteRoute = LayoutAssetsRouteRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminRouteRoute = LayoutAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeacherPortalRouteRoute =
  LayoutTeacherPortalRouteRouteImport.update({
    id: '/_teacher-portal',
    getParentRoute: () => LayoutRoute,
  } as any)
const NolayoutInductionIndexRoute = NolayoutInductionIndexRouteImport.update({
  id: '/induction/',
  path: '/induction/',
  getParentRoute: () => NolayoutRoute,
} as any)
const LayoutToolsIndexRoute = LayoutToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutStudentsIndexRoute = LayoutStudentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutStudentsRouteRoute,
} as any)
const LayoutStaffIndexRoute = LayoutStaffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutStaffRouteRoute,
} as any)
const LayoutReferralsIndexRoute = LayoutReferralsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutReferralsRouteRoute,
} as any)
const LayoutParentsEveningIndexRoute =
  LayoutParentsEveningIndexRouteImport.update({
    id: '/parents-evening/',
    path: '/parents-evening/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutMeIndexRoute = LayoutMeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutMeRouteRoute,
} as any)
const LayoutCommunicationIndexRoute =
  LayoutCommunicationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutCommunicationRouteRoute,
  } as any)
const LayoutCalendarIndexRoute = LayoutCalendarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutCalendarRouteRoute,
} as any)
const LayoutAssetsIndexRoute = LayoutAssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutAssetsRouteRoute,
} as any)
const LayoutAdminIndexRoute = LayoutAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutAdminRouteRoute,
} as any)
const NolayoutAuthSignInRoute = NolayoutAuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => NolayoutAuthRouteRoute,
} as any)
const NolayoutAuthRegisterRoute = NolayoutAuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => NolayoutAuthRouteRoute,
} as any)
const LayoutToolsSoundboardRoute = LayoutToolsSoundboardRouteImport.update({
  id: '/soundboard',
  path: '/soundboard',
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutToolsSortathonRoute = LayoutToolsSortathonRouteImport.update({
  id: '/sortathon',
  path: '/sortathon',
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutToolsSendTeamsMessageRoute =
  LayoutToolsSendTeamsMessageRouteImport.update({
    id: '/send-teams-message',
    path: '/send-teams-message',
    getParentRoute: () => LayoutToolsRouteRoute,
  } as any)
const LayoutToolsQrCodeMakerRoute = LayoutToolsQrCodeMakerRouteImport.update({
  id: '/qr-code-maker',
  path: '/qr-code-maker',
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutTimetablesTypeRoute = LayoutTimetablesTypeRouteImport.update({
  id: '/$type',
  path: '/$type',
  getParentRoute: () => LayoutTimetablesRoute,
} as any)
const LayoutStudentsMyRoute = LayoutStudentsMyRouteImport.update({
  id: '/my',
  path: '/my',
  getParentRoute: () => LayoutStudentsRouteRoute,
} as any)
const LayoutStudentsListsRoute = LayoutStudentsListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => LayoutStudentsRouteRoute,
} as any)
const LayoutStudentsFinderRoute = LayoutStudentsFinderRouteImport.update({
  id: '/finder',
  path: '/finder',
  getParentRoute: () => LayoutStudentsRouteRoute,
} as any)
const LayoutStudentFuturesDestinationsRoute =
  LayoutStudentFuturesDestinationsRouteImport.update({
    id: '/student-futures/destinations',
    path: '/student-futures/destinations',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStaffStaffDirectoryRoute =
  LayoutStaffStaffDirectoryRouteImport.update({
    id: '/staff-directory',
    path: '/staff-directory',
    getParentRoute: () => LayoutStaffRouteRoute,
  } as any)
const LayoutStaffOnSiteRoute = LayoutStaffOnSiteRouteImport.update({
  id: '/on-site',
  path: '/on-site',
  getParentRoute: () => LayoutStaffRouteRoute,
} as any)
const LayoutStaffFinderRoute = LayoutStaffFinderRouteImport.update({
  id: '/finder',
  path: '/finder',
  getParentRoute: () => LayoutStaffRouteRoute,
} as any)
const LayoutReportsDestinationsRoute =
  LayoutReportsDestinationsRouteImport.update({
    id: '/destinations',
    path: '/destinations',
    getParentRoute: () => LayoutReportsRouteRoute,
  } as any)
const LayoutReferralsStudySupportRoute =
  LayoutReferralsStudySupportRouteImport.update({
    id: '/study-support',
    path: '/study-support',
    getParentRoute: () => LayoutReferralsRouteRoute,
  } as any)
const LayoutReferralsExamAccessArrangementsRoute =
  LayoutReferralsExamAccessArrangementsRouteImport.update({
    id: '/exam-access-arrangements',
    path: '/exam-access-arrangements',
    getParentRoute: () => LayoutReferralsRouteRoute,
  } as any)
const LayoutParentsAllRoute = LayoutParentsAllRouteImport.update({
  id: '/all',
  path: '/all',
  getParentRoute: () => LayoutParentsRouteRoute,
} as any)
const LayoutParentsEveningMeetRoute =
  LayoutParentsEveningMeetRouteImport.update({
    id: '/parents-evening/meet',
    path: '/parents-evening/meet',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutParentsEveningBookRoute =
  LayoutParentsEveningBookRouteImport.update({
    id: '/parents-evening/book',
    path: '/parents-evening/book',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutMeTabRoute = LayoutMeTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => LayoutMeRouteRoute,
} as any)
const LayoutDocumentsChar123FolderIdChar125Route =
  LayoutDocumentsChar123FolderIdChar125RouteImport.update({
    id: '/documents/{-$folderId}',
    path: '/documents/{-$folderId}',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCommunicationFeedRoute = LayoutCommunicationFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => LayoutCommunicationRouteRoute,
} as any)
const LayoutCommunicationEmailRoute =
  LayoutCommunicationEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => LayoutCommunicationRouteRoute,
  } as any)
const LayoutCommunicationCampaignsRoute =
  LayoutCommunicationCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => LayoutCommunicationRouteRoute,
  } as any)
const LayoutCarsSearchRoute = LayoutCarsSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => LayoutCarsRouteRoute,
} as any)
const LayoutCarsAllRoute = LayoutCarsAllRouteImport.update({
  id: '/all',
  path: '/all',
  getParentRoute: () => LayoutCarsRouteRoute,
} as any)
const LayoutCalendarViewRoute = LayoutCalendarViewRouteImport.update({
  id: '/_view',
  getParentRoute: () => LayoutCalendarRouteRoute,
} as any)
const LayoutAssetsProjectorTypesRoute =
  LayoutAssetsProjectorTypesRouteImport.update({
    id: '/projector-types',
    path: '/projector-types',
    getParentRoute: () => LayoutAssetsRouteRoute,
  } as any)
const LayoutAssetsPrintersRoute = LayoutAssetsPrintersRouteImport.update({
  id: '/printers',
  path: '/printers',
  getParentRoute: () => LayoutAssetsRouteRoute,
} as any)
const LayoutAssetsMonitorsRoute = LayoutAssetsMonitorsRouteImport.update({
  id: '/monitors',
  path: '/monitors',
  getParentRoute: () => LayoutAssetsRouteRoute,
} as any)
const LayoutAssetsComputersRoute = LayoutAssetsComputersRouteImport.update({
  id: '/computers',
  path: '/computers',
  getParentRoute: () => LayoutAssetsRouteRoute,
} as any)
const LayoutAssetsCardPrinterRoute = LayoutAssetsCardPrinterRouteImport.update({
  id: '/card-printer',
  path: '/card-printer',
  getParentRoute: () => LayoutAssetsRouteRoute,
} as any)
const LayoutAdminTeamsAppInstallationsRoute =
  LayoutAdminTeamsAppInstallationsRouteImport.update({
    id: '/teams-app-installations',
    path: '/teams-app-installations',
    getParentRoute: () => LayoutAdminRouteRoute,
  } as any)
const LayoutAdminStudentListsRoute = LayoutAdminStudentListsRouteImport.update({
  id: '/student-lists',
  path: '/student-lists',
  getParentRoute: () => LayoutAdminRouteRoute,
} as any)
const LayoutAdminRolesRoute = LayoutAdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => LayoutAdminRouteRoute,
} as any)
const LayoutAdminPermissionsRoute = LayoutAdminPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => LayoutAdminRouteRoute,
} as any)
const LayoutAdminConnectedUsersRoute =
  LayoutAdminConnectedUsersRouteImport.update({
    id: '/connected-users',
    path: '/connected-users',
    getParentRoute: () => LayoutAdminRouteRoute,
  } as any)
const LayoutAdminCalendarRoute = LayoutAdminCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => LayoutAdminRouteRoute,
} as any)
const LayoutAdminBannersRoute = LayoutAdminBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => LayoutAdminRouteRoute,
} as any)
const LayoutTeacherPortalWatchlistsRoute =
  LayoutTeacherPortalWatchlistsRouteImport.update({
    id: '/watchlists',
    path: '/watchlists',
    getParentRoute: () => LayoutTeacherPortalRouteRoute,
  } as any)
const LayoutTeacherPortalCoursesRoute =
  LayoutTeacherPortalCoursesRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => LayoutTeacherPortalRouteRoute,
  } as any)
const LayoutTeacherPortalActionPlansRoute =
  LayoutTeacherPortalActionPlansRouteImport.update({
    id: '/action-plans',
    path: '/action-plans',
    getParentRoute: () => LayoutTeacherPortalRouteRoute,
  } as any)
const LayoutToolsTeamsAdministrationRouteRoute =
  LayoutToolsTeamsAdministrationRouteRouteImport.update({
    id: '/teams-administration',
    path: '/teams-administration',
    getParentRoute: () => LayoutToolsRouteRoute,
  } as any)
const LayoutStudentsStudentNoRouteRoute =
  LayoutStudentsStudentNoRouteRouteImport.update({
    id: '/$studentNo',
    path: '/$studentNo',
    getParentRoute: () => LayoutStudentsRouteRoute,
  } as any)
const LayoutStaffInitialsRouteRoute =
  LayoutStaffInitialsRouteRouteImport.update({
    id: '/$initials',
    path: '/$initials',
    getParentRoute: () => LayoutStaffRouteRoute,
  } as any)
const LayoutReferralsWellbeingRouteRoute =
  LayoutReferralsWellbeingRouteRouteImport.update({
    id: '/wellbeing',
    path: '/wellbeing',
    getParentRoute: () => LayoutReferralsRouteRoute,
  } as any)
const LayoutParentsParentIdRouteRoute =
  LayoutParentsParentIdRouteRouteImport.update({
    id: '/$parentId',
    path: '/$parentId',
    getParentRoute: () => LayoutParentsRouteRoute,
  } as any)
const LayoutCommunicationNotificationsRouteRoute =
  LayoutCommunicationNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => LayoutCommunicationRouteRoute,
  } as any)
const LayoutCalendarEventsRouteRoute =
  LayoutCalendarEventsRouteRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => LayoutCalendarRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsRouteRoute =
  LayoutTeacherPortalGroupsRouteRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => LayoutTeacherPortalRouteRoute,
  } as any)
const LayoutToolsTeamsAdministrationIndexRoute =
  LayoutToolsTeamsAdministrationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutToolsTeamsAdministrationRouteRoute,
  } as any)
const LayoutStudentsStudentNoIndexRoute =
  LayoutStudentsStudentNoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStaffInitialsIndexRoute =
  LayoutStaffInitialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStaffInitialsRouteRoute,
  } as any)
const LayoutReferralsWellbeingIndexRoute =
  LayoutReferralsWellbeingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutReferralsWellbeingRouteRoute,
  } as any)
const LayoutParentsParentIdIndexRoute =
  LayoutParentsParentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutParentsParentIdRouteRoute,
  } as any)
const LayoutAssetsCardPrinterIndexRoute =
  LayoutAssetsCardPrinterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutAssetsCardPrinterRoute,
  } as any)
const LayoutTimetablesTypeIdentifierRoute =
  LayoutTimetablesTypeIdentifierRouteImport.update({
    id: '/$identifier',
    path: '/$identifier',
    getParentRoute: () => LayoutTimetablesTypeRoute,
  } as any)
const LayoutStudentsStudentNoTimetableRoute =
  LayoutStudentsStudentNoTimetableRouteImport.update({
    id: '/timetable',
    path: '/timetable',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoSupportRoute =
  LayoutStudentsStudentNoSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoSummaryRoute =
  LayoutStudentsStudentNoSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoStudentAgreementsRoute =
  LayoutStudentsStudentNoStudentAgreementsRouteImport.update({
    id: '/student-agreements',
    path: '/student-agreements',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoReviewsRoute =
  LayoutStudentsStudentNoReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoPhotoRoute =
  LayoutStudentsStudentNoPhotoRouteImport.update({
    id: '/photo',
    path: '/photo',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoParentsRoute =
  LayoutStudentsStudentNoParentsRouteImport.update({
    id: '/parents',
    path: '/parents',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoMarkbookRoute =
  LayoutStudentsStudentNoMarkbookRouteImport.update({
    id: '/markbook',
    path: '/markbook',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoGcseRoute =
  LayoutStudentsStudentNoGcseRouteImport.update({
    id: '/gcse',
    path: '/gcse',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoDocumentsRoute =
  LayoutStudentsStudentNoDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoDetailsRoute =
  LayoutStudentsStudentNoDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStaffInitialsTimetableRoute =
  LayoutStaffInitialsTimetableRouteImport.update({
    id: '/timetable',
    path: '/timetable',
    getParentRoute: () => LayoutStaffInitialsRouteRoute,
  } as any)
const LayoutStaffInitialsRolesRoute =
  LayoutStaffInitialsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => LayoutStaffInitialsRouteRoute,
  } as any)
const LayoutStaffInitialsPhotoRoute =
  LayoutStaffInitialsPhotoRouteImport.update({
    id: '/photo',
    path: '/photo',
    getParentRoute: () => LayoutStaffInitialsRouteRoute,
  } as any)
const LayoutReportsSarPastoralRoute =
  LayoutReportsSarPastoralRouteImport.update({
    id: '/sar/pastoral',
    path: '/sar/pastoral',
    getParentRoute: () => LayoutReportsRouteRoute,
  } as any)
const LayoutReportsSarCurriculumRoute =
  LayoutReportsSarCurriculumRouteImport.update({
    id: '/sar/curriculum',
    path: '/sar/curriculum',
    getParentRoute: () => LayoutReportsRouteRoute,
  } as any)
const LayoutReferralsWellbeingMyRoute =
  LayoutReferralsWellbeingMyRouteImport.update({
    id: '/my',
    path: '/my',
    getParentRoute: () => LayoutReferralsWellbeingRouteRoute,
  } as any)
const LayoutReferralsWellbeingCreateRoute =
  LayoutReferralsWellbeingCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => LayoutReferralsWellbeingRouteRoute,
  } as any)
const LayoutReferralsWellbeingAssignedRoute =
  LayoutReferralsWellbeingAssignedRouteImport.update({
    id: '/assigned',
    path: '/assigned',
    getParentRoute: () => LayoutReferralsWellbeingRouteRoute,
  } as any)
const LayoutParentsParentIdContactInfoRoute =
  LayoutParentsParentIdContactInfoRouteImport.update({
    id: '/contact-info',
    path: '/contact-info',
    getParentRoute: () => LayoutParentsParentIdRouteRoute,
  } as any)
const LayoutCommunicationNotificationsTeamsNotificationsRoute =
  LayoutCommunicationNotificationsTeamsNotificationsRouteImport.update({
    id: '/teams-notifications',
    path: '/teams-notifications',
    getParentRoute: () => LayoutCommunicationNotificationsRouteRoute,
  } as any)
const LayoutCommunicationNotificationsPortalNotificationsRoute =
  LayoutCommunicationNotificationsPortalNotificationsRouteImport.update({
    id: '/portal-notifications',
    path: '/portal-notifications',
    getParentRoute: () => LayoutCommunicationNotificationsRouteRoute,
  } as any)
const LayoutCalendarEventsNewRoute = LayoutCalendarEventsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LayoutCalendarEventsRouteRoute,
} as any)
const LayoutCalendarEventsEventIdRoute =
  LayoutCalendarEventsEventIdRouteImport.update({
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => LayoutCalendarEventsRouteRoute,
  } as any)
const LayoutAssetsCardPrinterPrintersRoute =
  LayoutAssetsCardPrinterPrintersRouteImport.update({
    id: '/printers',
    path: '/printers',
    getParentRoute: () => LayoutAssetsCardPrinterRoute,
  } as any)
const LayoutAssetsCardPrinterPrintedCardsRoute =
  LayoutAssetsCardPrinterPrintedCardsRouteImport.update({
    id: '/printed-cards',
    path: '/printed-cards',
    getParentRoute: () => LayoutAssetsCardPrinterRoute,
  } as any)
const LayoutAssetsCardPrinterPrintJobsRoute =
  LayoutAssetsCardPrinterPrintJobsRouteImport.update({
    id: '/print-jobs',
    path: '/print-jobs',
    getParentRoute: () => LayoutAssetsCardPrinterRoute,
  } as any)
const LayoutToolsTeamsAdministrationTeamsRouteRoute =
  LayoutToolsTeamsAdministrationTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => LayoutToolsTeamsAdministrationRouteRoute,
  } as any)
const LayoutStudentsStudentNoConversationsRouteRoute =
  LayoutStudentsStudentNoConversationsRouteRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoAttendanceRouteRoute =
  LayoutStudentsStudentNoAttendanceRouteRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansRouteRoute =
  LayoutStudentsStudentNoActionPlansRouteRouteImport.update({
    id: '/action-plans',
    path: '/action-plans',
    getParentRoute: () => LayoutStudentsStudentNoRouteRoute,
  } as any)
const LayoutReferralsWellbeingManageRouteRoute =
  LayoutReferralsWellbeingManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => LayoutReferralsWellbeingRouteRoute,
  } as any)
const LayoutCarsStudentCarIdRouteRoute =
  LayoutCarsStudentCarIdRouteRouteImport.update({
    id: '/student/$carId',
    path: '/student/$carId',
    getParentRoute: () => LayoutCarsRouteRoute,
  } as any)
const LayoutCarsStaffCarIdRouteRoute =
  LayoutCarsStaffCarIdRouteRouteImport.update({
    id: '/staff/$carId',
    path: '/staff/$carId',
    getParentRoute: () => LayoutCarsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesRouteRoute =
  LayoutTeacherPortalGroupsClassesRouteRouteImport.update({
    id: '/classes',
    path: '/classes',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutToolsTeamsAdministrationTeamsIndexRoute =
  LayoutToolsTeamsAdministrationTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutToolsTeamsAdministrationTeamsRouteRoute,
  } as any)
const LayoutStudentsStudentNoConversationsIndexRoute =
  LayoutStudentsStudentNoConversationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStudentsStudentNoConversationsRouteRoute,
  } as any)
const LayoutStudentsStudentNoAttendanceIndexRoute =
  LayoutStudentsStudentNoAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStudentsStudentNoAttendanceRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansIndexRoute =
  LayoutStudentsStudentNoActionPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStudentsStudentNoActionPlansRouteRoute,
  } as any)
const LayoutCarsStudentCarIdIndexRoute =
  LayoutCarsStudentCarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutCarsStudentCarIdRouteRoute,
  } as any)
const LayoutCarsStaffCarIdIndexRoute =
  LayoutCarsStaffCarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutCarsStaffCarIdRouteRoute,
  } as any)
const LayoutStudentsStudentNoConversationsConversationIdRoute =
  LayoutStudentsStudentNoConversationsConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => LayoutStudentsStudentNoConversationsRouteRoute,
  } as any)
const LayoutStudentsStudentNoAttendancePunctualityRoute =
  LayoutStudentsStudentNoAttendancePunctualityRouteImport.update({
    id: '/punctuality',
    path: '/punctuality',
    getParentRoute: () => LayoutStudentsStudentNoAttendanceRouteRoute,
  } as any)
const LayoutStudentsStudentNoAttendanceAbsencesRoute =
  LayoutStudentsStudentNoAttendanceAbsencesRouteImport.update({
    id: '/absences',
    path: '/absences',
    getParentRoute: () => LayoutStudentsStudentNoAttendanceRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansReferralsRoute =
  LayoutStudentsStudentNoActionPlansReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => LayoutStudentsStudentNoActionPlansRouteRoute,
  } as any)
const LayoutReferralsWellbeingMyReferralIdRoute =
  LayoutReferralsWellbeingMyReferralIdRouteImport.update({
    id: '/$referralId',
    path: '/$referralId',
    getParentRoute: () => LayoutReferralsWellbeingMyRoute,
  } as any)
const LayoutReferralsWellbeingManageReferralIdRoute =
  LayoutReferralsWellbeingManageReferralIdRouteImport.update({
    id: '/$referralId',
    path: '/$referralId',
    getParentRoute: () => LayoutReferralsWellbeingManageRouteRoute,
  } as any)
const LayoutReferralsWellbeingAssignedCategoryRoute =
  LayoutReferralsWellbeingAssignedCategoryRouteImport.update({
    id: '/$category',
    path: '/$category',
    getParentRoute: () => LayoutReferralsWellbeingAssignedRoute,
  } as any)
const LayoutCarsStudentCarIdDvlaRoute =
  LayoutCarsStudentCarIdDvlaRouteImport.update({
    id: '/dvla',
    path: '/dvla',
    getParentRoute: () => LayoutCarsStudentCarIdRouteRoute,
  } as any)
const LayoutCarsStaffCarIdDvlaRoute =
  LayoutCarsStaffCarIdDvlaRouteImport.update({
    id: '/dvla',
    path: '/dvla',
    getParentRoute: () => LayoutCarsStaffCarIdRouteRoute,
  } as any)
const LayoutCalendarEventsEventIdEditRoute =
  LayoutCalendarEventsEventIdEditRouteImport.update({
    id: '/events_/$eventId/edit',
    path: '/events/$eventId/edit',
    getParentRoute: () => LayoutCalendarRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyCollegeRoute =
  LayoutTeacherPortalGroupsMyCollegeRouteImport.update({
    id: '/my/college',
    path: '/my/college',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyClassesRoute =
  LayoutTeacherPortalGroupsMyClassesRouteImport.update({
    id: '/my/classes',
    path: '/my/classes',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsAllSubjectsRoute =
  LayoutTeacherPortalGroupsAllSubjectsRouteImport.update({
    id: '/all/subjects',
    path: '/all/subjects',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsAllFacultiesRoute =
  LayoutTeacherPortalGroupsAllFacultiesRouteImport.update({
    id: '/all/faculties',
    path: '/all/faculties',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsAllDepartmentsRoute =
  LayoutTeacherPortalGroupsAllDepartmentsRouteImport.update({
    id: '/all/departments',
    path: '/all/departments',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsAllCoursesRoute =
  LayoutTeacherPortalGroupsAllCoursesRouteImport.update({
    id: '/all/courses',
    path: '/all/courses',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsAllClassesRoute =
  LayoutTeacherPortalGroupsAllClassesRouteImport.update({
    id: '/all/classes',
    path: '/all/classes',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute =
  LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteImport.update({
    id: '/$teamId',
    path: '/$teamId',
    getParentRoute: () => LayoutToolsTeamsAdministrationTeamsRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute =
  LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteImport.update({
    id: '/academic-support',
    path: '/academic-support',
    getParentRoute: () => LayoutStudentsStudentNoActionPlansRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansTypeRouteRoute =
  LayoutStudentsStudentNoActionPlansTypeRouteRouteImport.update({
    id: '/$type',
    path: '/$type',
    getParentRoute: () => LayoutStudentsStudentNoActionPlansRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyFacultyRouteRoute =
  LayoutTeacherPortalGroupsMyFacultyRouteRouteImport.update({
    id: '/my/faculty',
    path: '/my/faculty',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyDepartmentRouteRoute =
  LayoutTeacherPortalGroupsMyDepartmentRouteRouteImport.update({
    id: '/my/department',
    path: '/my/department',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdRouteRoute =
  LayoutTeacherPortalGroupsClassesClassIdRouteRouteImport.update({
    id: '/$classId',
    path: '/$classId',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesRouteRoute,
  } as any)
const LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute =
  LayoutToolsTeamsAdministrationTeamsTeamIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute =
  LayoutStudentsStudentNoActionPlansAcademicSupportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansTypeIndexRoute =
  LayoutStudentsStudentNoActionPlansTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutStudentsStudentNoActionPlansTypeRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute =
  LayoutTeacherPortalGroupsSubjectSubjectIdIndexRouteImport.update({
    id: '/subject/$subjectId/',
    path: '/subject/$subjectId/',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyFacultyIndexRoute =
  LayoutTeacherPortalGroupsMyFacultyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTeacherPortalGroupsMyFacultyRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyDepartmentIndexRoute =
  LayoutTeacherPortalGroupsMyDepartmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTeacherPortalGroupsMyDepartmentRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute =
  LayoutTeacherPortalGroupsFacultyFacultyIdIndexRouteImport.update({
    id: '/faculty/$facultyId/',
    path: '/faculty/$facultyId/',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute =
  LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRouteImport.update({
    id: '/department/$departmentId/',
    path: '/department/$departmentId/',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsCourseCourseIdIndexRoute =
  LayoutTeacherPortalGroupsCourseCourseIdIndexRouteImport.update({
    id: '/course/$courseId/',
    path: '/course/$courseId/',
    getParentRoute: () => LayoutTeacherPortalGroupsRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdIndexRoute =
  LayoutTeacherPortalGroupsClassesClassIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRoute =
  LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteImport.update(
    {
      id: '/$subjectSlug',
      path: '/$subjectSlug',
      getParentRoute: () =>
        LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute,
    } as any,
  )
const LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute =
  LayoutReferralsWellbeingAssignedCategoryAssignmentIdRouteImport.update({
    id: '/$assignmentId',
    path: '/$assignmentId',
    getParentRoute: () => LayoutReferralsWellbeingAssignedCategoryRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdSupportRoute =
  LayoutTeacherPortalGroupsClassesClassIdSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdReferencesRoute =
  LayoutTeacherPortalGroupsClassesClassIdReferencesRouteImport.update({
    id: '/references',
    path: '/references',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdOrbitRoute =
  LayoutTeacherPortalGroupsClassesClassIdOrbitRouteImport.update({
    id: '/orbit',
    path: '/orbit',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdGalleryRoute =
  LayoutTeacherPortalGroupsClassesClassIdGalleryRouteImport.update({
    id: '/gallery',
    path: '/gallery',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute =
  LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRouteImport.update(
    {
      id: '/classroom-adjustments',
      path: '/classroom-adjustments',
      getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
    } as any,
  )
const LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute =
  LayoutTeacherPortalGroupsClassesClassIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute =
  LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRouteImport.update({
    id: '/access-arrangements',
    path: '/access-arrangements',
    getParentRoute: () => LayoutTeacherPortalGroupsClassesClassIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteImport.update({
    id: '/$departmentId',
    path: '/$departmentId',
    getParentRoute: () => LayoutTeacherPortalGroupsMyFacultyRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute =
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteImport.update({
    id: '/$subjectId',
    path: '/$subjectId',
    getParentRoute: () => LayoutTeacherPortalGroupsMyDepartmentRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute =
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute,
  } as any)
const LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute =
  LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRouteImport.update({
    id: '/channels/$channelId',
    path: '/channels/$channelId',
    getParentRoute: () => LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute,
  } as any)
const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteImport.update(
    {
      id: '/$subjectId',
      path: '/$subjectId',
      getParentRoute: () =>
        LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute,
    } as any,
  )
const LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRoute =
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteImport.update(
    {
      id: '/$courseId',
      path: '/$courseId',
      getParentRoute: () =>
        LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute,
    } as any,
  )
const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute,
    } as any,
  )
const LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute =
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRoute,
    } as any,
  )
const LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute =
  LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRouteImport.update(
    {
      id: '/target/$targetId',
      path: '/target/$targetId',
      getParentRoute: () =>
        LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRoute,
    } as any,
  )
const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRoute =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteImport.update(
    {
      id: '/$courseId',
      path: '/$courseId',
      getParentRoute: () =>
        LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute,
    } as any,
  )
const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof LayoutAdminRouteRouteWithChildren
  '/assets': typeof LayoutAssetsRouteRouteWithChildren
  '/calendar': typeof LayoutCalendarViewRoute
  '/cars': typeof LayoutCarsRouteRouteWithChildren
  '/communication': typeof LayoutCommunicationRouteRouteWithChildren
  '/me': typeof LayoutMeRouteRouteWithChildren
  '/parents': typeof LayoutParentsRouteRouteWithChildren
  '/referrals': typeof LayoutReferralsRouteRouteWithChildren
  '/reports': typeof LayoutReportsRouteRouteWithChildren
  '/staff': typeof LayoutStaffRouteRouteWithChildren
  '/students': typeof LayoutStudentsRouteRouteWithChildren
  '/tools': typeof LayoutToolsRouteRouteWithChildren
  '/book-a-room': typeof LayoutBookARoomRoute
  '/feed': typeof LayoutFeedRoute
  '/home': typeof LayoutHomeRoute
  '/map': typeof LayoutMapRoute
  '/notices': typeof LayoutNoticesRoute
  '/notifications': typeof LayoutNotificationsRoute
  '/parent-shop': typeof LayoutParentShopRoute
  '/report-hub': typeof LayoutReportHubRoute
  '/rooms': typeof LayoutRoomsRoute
  '/settings': typeof LayoutSettingsRoute
  '/tabs': typeof LayoutTabsRoute
  '/teacher-portal': typeof LayoutTeacherPortalRoute
  '/tickets': typeof LayoutTicketsRoute
  '/timetables': typeof LayoutTimetablesRouteWithChildren
  '/unauthorised': typeof LayoutUnauthorisedRoute
  '/public-page': typeof NolayoutPublicPageRoute
  '/groups': typeof LayoutTeacherPortalGroupsRouteRouteWithChildren
  '/calendar/events': typeof LayoutCalendarEventsRouteRouteWithChildren
  '/communication/notifications': typeof LayoutCommunicationNotificationsRouteRouteWithChildren
  '/parents/$parentId': typeof LayoutParentsParentIdRouteRouteWithChildren
  '/referrals/wellbeing': typeof LayoutReferralsWellbeingRouteRouteWithChildren
  '/staff/$initials': typeof LayoutStaffInitialsRouteRouteWithChildren
  '/students/$studentNo': typeof LayoutStudentsStudentNoRouteRouteWithChildren
  '/tools/teams-administration': typeof LayoutToolsTeamsAdministrationRouteRouteWithChildren
  '/action-plans': typeof LayoutTeacherPortalActionPlansRoute
  '/courses': typeof LayoutTeacherPortalCoursesRoute
  '/watchlists': typeof LayoutTeacherPortalWatchlistsRoute
  '/admin/banners': typeof LayoutAdminBannersRoute
  '/admin/calendar': typeof LayoutAdminCalendarRoute
  '/admin/connected-users': typeof LayoutAdminConnectedUsersRoute
  '/admin/permissions': typeof LayoutAdminPermissionsRoute
  '/admin/roles': typeof LayoutAdminRolesRoute
  '/admin/student-lists': typeof LayoutAdminStudentListsRoute
  '/admin/teams-app-installations': typeof LayoutAdminTeamsAppInstallationsRoute
  '/assets/card-printer': typeof LayoutAssetsCardPrinterRouteWithChildren
  '/assets/computers': typeof LayoutAssetsComputersRoute
  '/assets/monitors': typeof LayoutAssetsMonitorsRoute
  '/assets/printers': typeof LayoutAssetsPrintersRoute
  '/assets/projector-types': typeof LayoutAssetsProjectorTypesRoute
  '/cars/all': typeof LayoutCarsAllRoute
  '/cars/search': typeof LayoutCarsSearchRoute
  '/communication/campaigns': typeof LayoutCommunicationCampaignsRoute
  '/communication/email': typeof LayoutCommunicationEmailRoute
  '/communication/feed': typeof LayoutCommunicationFeedRoute
  '/documents/{-$folderId}': typeof LayoutDocumentsChar123FolderIdChar125Route
  '/me/$tab': typeof LayoutMeTabRoute
  '/parents-evening/book': typeof LayoutParentsEveningBookRoute
  '/parents-evening/meet': typeof LayoutParentsEveningMeetRoute
  '/parents/all': typeof LayoutParentsAllRoute
  '/referrals/exam-access-arrangements': typeof LayoutReferralsExamAccessArrangementsRoute
  '/referrals/study-support': typeof LayoutReferralsStudySupportRoute
  '/reports/destinations': typeof LayoutReportsDestinationsRoute
  '/staff/finder': typeof LayoutStaffFinderRoute
  '/staff/on-site': typeof LayoutStaffOnSiteRoute
  '/staff/staff-directory': typeof LayoutStaffStaffDirectoryRoute
  '/student-futures/destinations': typeof LayoutStudentFuturesDestinationsRoute
  '/students/finder': typeof LayoutStudentsFinderRoute
  '/students/lists': typeof LayoutStudentsListsRoute
  '/students/my': typeof LayoutStudentsMyRoute
  '/timetables/$type': typeof LayoutTimetablesTypeRouteWithChildren
  '/tools/qr-code-maker': typeof LayoutToolsQrCodeMakerRoute
  '/tools/send-teams-message': typeof LayoutToolsSendTeamsMessageRoute
  '/tools/sortathon': typeof LayoutToolsSortathonRoute
  '/tools/soundboard': typeof LayoutToolsSoundboardRoute
  '/register': typeof NolayoutAuthRegisterRoute
  '/sign-in': typeof NolayoutAuthSignInRoute
  '/admin/': typeof LayoutAdminIndexRoute
  '/assets/': typeof LayoutAssetsIndexRoute
  '/calendar/': typeof LayoutCalendarIndexRoute
  '/communication/': typeof LayoutCommunicationIndexRoute
  '/me/': typeof LayoutMeIndexRoute
  '/parents-evening/': typeof LayoutParentsEveningIndexRoute
  '/referrals/': typeof LayoutReferralsIndexRoute
  '/staff/': typeof LayoutStaffIndexRoute
  '/students/': typeof LayoutStudentsIndexRoute
  '/tools/': typeof LayoutToolsIndexRoute
  '/induction/': typeof NolayoutInductionIndexRoute
  '/groups/classes': typeof LayoutTeacherPortalGroupsClassesRouteRouteWithChildren
  '/cars/staff/$carId': typeof LayoutCarsStaffCarIdRouteRouteWithChildren
  '/cars/student/$carId': typeof LayoutCarsStudentCarIdRouteRouteWithChildren
  '/referrals/wellbeing/manage': typeof LayoutReferralsWellbeingManageRouteRouteWithChildren
  '/students/$studentNo/action-plans': typeof LayoutStudentsStudentNoActionPlansRouteRouteWithChildren
  '/students/$studentNo/attendance': typeof LayoutStudentsStudentNoAttendanceRouteRouteWithChildren
  '/students/$studentNo/conversations': typeof LayoutStudentsStudentNoConversationsRouteRouteWithChildren
  '/tools/teams-administration/teams': typeof LayoutToolsTeamsAdministrationTeamsRouteRouteWithChildren
  '/assets/card-printer/print-jobs': typeof LayoutAssetsCardPrinterPrintJobsRoute
  '/assets/card-printer/printed-cards': typeof LayoutAssetsCardPrinterPrintedCardsRoute
  '/assets/card-printer/printers': typeof LayoutAssetsCardPrinterPrintersRoute
  '/calendar/events/$eventId': typeof LayoutCalendarEventsEventIdRoute
  '/calendar/events/new': typeof LayoutCalendarEventsNewRoute
  '/communication/notifications/portal-notifications': typeof LayoutCommunicationNotificationsPortalNotificationsRoute
  '/communication/notifications/teams-notifications': typeof LayoutCommunicationNotificationsTeamsNotificationsRoute
  '/parents/$parentId/contact-info': typeof LayoutParentsParentIdContactInfoRoute
  '/referrals/wellbeing/assigned': typeof LayoutReferralsWellbeingAssignedRouteWithChildren
  '/referrals/wellbeing/create': typeof LayoutReferralsWellbeingCreateRoute
  '/referrals/wellbeing/my': typeof LayoutReferralsWellbeingMyRouteWithChildren
  '/reports/sar/curriculum': typeof LayoutReportsSarCurriculumRoute
  '/reports/sar/pastoral': typeof LayoutReportsSarPastoralRoute
  '/staff/$initials/photo': typeof LayoutStaffInitialsPhotoRoute
  '/staff/$initials/roles': typeof LayoutStaffInitialsRolesRoute
  '/staff/$initials/timetable': typeof LayoutStaffInitialsTimetableRoute
  '/students/$studentNo/details': typeof LayoutStudentsStudentNoDetailsRoute
  '/students/$studentNo/documents': typeof LayoutStudentsStudentNoDocumentsRoute
  '/students/$studentNo/gcse': typeof LayoutStudentsStudentNoGcseRoute
  '/students/$studentNo/markbook': typeof LayoutStudentsStudentNoMarkbookRoute
  '/students/$studentNo/parents': typeof LayoutStudentsStudentNoParentsRoute
  '/students/$studentNo/photo': typeof LayoutStudentsStudentNoPhotoRoute
  '/students/$studentNo/reviews': typeof LayoutStudentsStudentNoReviewsRoute
  '/students/$studentNo/student-agreements': typeof LayoutStudentsStudentNoStudentAgreementsRoute
  '/students/$studentNo/summary': typeof LayoutStudentsStudentNoSummaryRoute
  '/students/$studentNo/support': typeof LayoutStudentsStudentNoSupportRoute
  '/students/$studentNo/timetable': typeof LayoutStudentsStudentNoTimetableRoute
  '/timetables/$type/$identifier': typeof LayoutTimetablesTypeIdentifierRoute
  '/assets/card-printer/': typeof LayoutAssetsCardPrinterIndexRoute
  '/parents/$parentId/': typeof LayoutParentsParentIdIndexRoute
  '/referrals/wellbeing/': typeof LayoutReferralsWellbeingIndexRoute
  '/staff/$initials/': typeof LayoutStaffInitialsIndexRoute
  '/students/$studentNo/': typeof LayoutStudentsStudentNoIndexRoute
  '/tools/teams-administration/': typeof LayoutToolsTeamsAdministrationIndexRoute
  '/groups/classes/$classId': typeof LayoutTeacherPortalGroupsClassesClassIdRouteRouteWithChildren
  '/groups/my/department': typeof LayoutTeacherPortalGroupsMyDepartmentRouteRouteWithChildren
  '/groups/my/faculty': typeof LayoutTeacherPortalGroupsMyFacultyRouteRouteWithChildren
  '/students/$studentNo/action-plans/$type': typeof LayoutStudentsStudentNoActionPlansTypeRouteRouteWithChildren
  '/students/$studentNo/action-plans/academic-support': typeof LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteWithChildren
  '/tools/teams-administration/teams/$teamId': typeof LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteWithChildren
  '/groups/all/classes': typeof LayoutTeacherPortalGroupsAllClassesRoute
  '/groups/all/courses': typeof LayoutTeacherPortalGroupsAllCoursesRoute
  '/groups/all/departments': typeof LayoutTeacherPortalGroupsAllDepartmentsRoute
  '/groups/all/faculties': typeof LayoutTeacherPortalGroupsAllFacultiesRoute
  '/groups/all/subjects': typeof LayoutTeacherPortalGroupsAllSubjectsRoute
  '/groups/my/classes': typeof LayoutTeacherPortalGroupsMyClassesRoute
  '/groups/my/college': typeof LayoutTeacherPortalGroupsMyCollegeRoute
  '/calendar/events/$eventId/edit': typeof LayoutCalendarEventsEventIdEditRoute
  '/cars/staff/$carId/dvla': typeof LayoutCarsStaffCarIdDvlaRoute
  '/cars/student/$carId/dvla': typeof LayoutCarsStudentCarIdDvlaRoute
  '/referrals/wellbeing/assigned/$category': typeof LayoutReferralsWellbeingAssignedCategoryRouteWithChildren
  '/referrals/wellbeing/manage/$referralId': typeof LayoutReferralsWellbeingManageReferralIdRoute
  '/referrals/wellbeing/my/$referralId': typeof LayoutReferralsWellbeingMyReferralIdRoute
  '/students/$studentNo/action-plans/referrals': typeof LayoutStudentsStudentNoActionPlansReferralsRoute
  '/students/$studentNo/attendance/absences': typeof LayoutStudentsStudentNoAttendanceAbsencesRoute
  '/students/$studentNo/attendance/punctuality': typeof LayoutStudentsStudentNoAttendancePunctualityRoute
  '/students/$studentNo/conversations/$conversationId': typeof LayoutStudentsStudentNoConversationsConversationIdRoute
  '/cars/staff/$carId/': typeof LayoutCarsStaffCarIdIndexRoute
  '/cars/student/$carId/': typeof LayoutCarsStudentCarIdIndexRoute
  '/students/$studentNo/action-plans/': typeof LayoutStudentsStudentNoActionPlansIndexRoute
  '/students/$studentNo/attendance/': typeof LayoutStudentsStudentNoAttendanceIndexRoute
  '/students/$studentNo/conversations/': typeof LayoutStudentsStudentNoConversationsIndexRoute
  '/tools/teams-administration/teams/': typeof LayoutToolsTeamsAdministrationTeamsIndexRoute
  '/groups/my/department/$subjectId': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteWithChildren
  '/groups/my/faculty/$departmentId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteWithChildren
  '/groups/classes/$classId/access-arrangements': typeof LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute
  '/groups/classes/$classId/attendance': typeof LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute
  '/groups/classes/$classId/classroom-adjustments': typeof LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute
  '/groups/classes/$classId/gallery': typeof LayoutTeacherPortalGroupsClassesClassIdGalleryRoute
  '/groups/classes/$classId/orbit': typeof LayoutTeacherPortalGroupsClassesClassIdOrbitRoute
  '/groups/classes/$classId/references': typeof LayoutTeacherPortalGroupsClassesClassIdReferencesRoute
  '/groups/classes/$classId/support': typeof LayoutTeacherPortalGroupsClassesClassIdSupportRoute
  '/referrals/wellbeing/assigned/$category/$assignmentId': typeof LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute
  '/students/$studentNo/action-plans/academic-support/$subjectSlug': typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteWithChildren
  '/groups/classes/$classId/': typeof LayoutTeacherPortalGroupsClassesClassIdIndexRoute
  '/groups/course/$courseId/': typeof LayoutTeacherPortalGroupsCourseCourseIdIndexRoute
  '/groups/department/$departmentId/': typeof LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute
  '/groups/faculty/$facultyId/': typeof LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute
  '/groups/my/department/': typeof LayoutTeacherPortalGroupsMyDepartmentIndexRoute
  '/groups/my/faculty/': typeof LayoutTeacherPortalGroupsMyFacultyIndexRoute
  '/groups/subject/$subjectId/': typeof LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute
  '/students/$studentNo/action-plans/$type/': typeof LayoutStudentsStudentNoActionPlansTypeIndexRoute
  '/students/$studentNo/action-plans/academic-support/': typeof LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute
  '/tools/teams-administration/teams/$teamId/': typeof LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute
  '/groups/my/department/$subjectId/$courseId': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteWithChildren
  '/groups/my/faculty/$departmentId/$subjectId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteWithChildren
  '/tools/teams-administration/teams/$teamId/channels/$channelId': typeof LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute
  '/groups/my/department/$subjectId/': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute
  '/groups/my/faculty/$departmentId/': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute
  '/groups/my/faculty/$departmentId/$subjectId/$courseId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteWithChildren
  '/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId': typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute
  '/groups/my/department/$subjectId/$courseId/': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute
  '/groups/my/faculty/$departmentId/$subjectId/': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute
  '/groups/my/faculty/$departmentId/$subjectId/$courseId/': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cars': typeof LayoutCarsRouteRouteWithChildren
  '/parents': typeof LayoutParentsRouteRouteWithChildren
  '/reports': typeof LayoutReportsRouteRouteWithChildren
  '/book-a-room': typeof LayoutBookARoomRoute
  '/feed': typeof LayoutFeedRoute
  '/home': typeof LayoutHomeRoute
  '/map': typeof LayoutMapRoute
  '/notices': typeof LayoutNoticesRoute
  '/notifications': typeof LayoutNotificationsRoute
  '/parent-shop': typeof LayoutParentShopRoute
  '/report-hub': typeof LayoutReportHubRoute
  '/rooms': typeof LayoutRoomsRoute
  '/settings': typeof LayoutSettingsRoute
  '/tabs': typeof LayoutTabsRoute
  '/teacher-portal': typeof LayoutTeacherPortalRoute
  '/tickets': typeof LayoutTicketsRoute
  '/timetables': typeof LayoutTimetablesRouteWithChildren
  '/unauthorised': typeof LayoutUnauthorisedRoute
  '/public-page': typeof NolayoutPublicPageRoute
  '/groups': typeof LayoutTeacherPortalGroupsRouteRouteWithChildren
  '/calendar/events': typeof LayoutCalendarEventsRouteRouteWithChildren
  '/communication/notifications': typeof LayoutCommunicationNotificationsRouteRouteWithChildren
  '/action-plans': typeof LayoutTeacherPortalActionPlansRoute
  '/courses': typeof LayoutTeacherPortalCoursesRoute
  '/watchlists': typeof LayoutTeacherPortalWatchlistsRoute
  '/admin/banners': typeof LayoutAdminBannersRoute
  '/admin/calendar': typeof LayoutAdminCalendarRoute
  '/admin/connected-users': typeof LayoutAdminConnectedUsersRoute
  '/admin/permissions': typeof LayoutAdminPermissionsRoute
  '/admin/roles': typeof LayoutAdminRolesRoute
  '/admin/student-lists': typeof LayoutAdminStudentListsRoute
  '/admin/teams-app-installations': typeof LayoutAdminTeamsAppInstallationsRoute
  '/assets/computers': typeof LayoutAssetsComputersRoute
  '/assets/monitors': typeof LayoutAssetsMonitorsRoute
  '/assets/printers': typeof LayoutAssetsPrintersRoute
  '/assets/projector-types': typeof LayoutAssetsProjectorTypesRoute
  '/calendar': typeof LayoutCalendarIndexRoute
  '/cars/all': typeof LayoutCarsAllRoute
  '/cars/search': typeof LayoutCarsSearchRoute
  '/communication/campaigns': typeof LayoutCommunicationCampaignsRoute
  '/communication/email': typeof LayoutCommunicationEmailRoute
  '/communication/feed': typeof LayoutCommunicationFeedRoute
  '/documents/{-$folderId}': typeof LayoutDocumentsChar123FolderIdChar125Route
  '/me/$tab': typeof LayoutMeTabRoute
  '/parents-evening/book': typeof LayoutParentsEveningBookRoute
  '/parents-evening/meet': typeof LayoutParentsEveningMeetRoute
  '/parents/all': typeof LayoutParentsAllRoute
  '/referrals/exam-access-arrangements': typeof LayoutReferralsExamAccessArrangementsRoute
  '/referrals/study-support': typeof LayoutReferralsStudySupportRoute
  '/reports/destinations': typeof LayoutReportsDestinationsRoute
  '/staff/finder': typeof LayoutStaffFinderRoute
  '/staff/on-site': typeof LayoutStaffOnSiteRoute
  '/staff/staff-directory': typeof LayoutStaffStaffDirectoryRoute
  '/student-futures/destinations': typeof LayoutStudentFuturesDestinationsRoute
  '/students/finder': typeof LayoutStudentsFinderRoute
  '/students/lists': typeof LayoutStudentsListsRoute
  '/students/my': typeof LayoutStudentsMyRoute
  '/timetables/$type': typeof LayoutTimetablesTypeRouteWithChildren
  '/tools/qr-code-maker': typeof LayoutToolsQrCodeMakerRoute
  '/tools/send-teams-message': typeof LayoutToolsSendTeamsMessageRoute
  '/tools/sortathon': typeof LayoutToolsSortathonRoute
  '/tools/soundboard': typeof LayoutToolsSoundboardRoute
  '/register': typeof NolayoutAuthRegisterRoute
  '/sign-in': typeof NolayoutAuthSignInRoute
  '/admin': typeof LayoutAdminIndexRoute
  '/assets': typeof LayoutAssetsIndexRoute
  '/communication': typeof LayoutCommunicationIndexRoute
  '/me': typeof LayoutMeIndexRoute
  '/parents-evening': typeof LayoutParentsEveningIndexRoute
  '/referrals': typeof LayoutReferralsIndexRoute
  '/staff': typeof LayoutStaffIndexRoute
  '/students': typeof LayoutStudentsIndexRoute
  '/tools': typeof LayoutToolsIndexRoute
  '/induction': typeof NolayoutInductionIndexRoute
  '/groups/classes': typeof LayoutTeacherPortalGroupsClassesRouteRouteWithChildren
  '/referrals/wellbeing/manage': typeof LayoutReferralsWellbeingManageRouteRouteWithChildren
  '/assets/card-printer/print-jobs': typeof LayoutAssetsCardPrinterPrintJobsRoute
  '/assets/card-printer/printed-cards': typeof LayoutAssetsCardPrinterPrintedCardsRoute
  '/assets/card-printer/printers': typeof LayoutAssetsCardPrinterPrintersRoute
  '/calendar/events/$eventId': typeof LayoutCalendarEventsEventIdRoute
  '/calendar/events/new': typeof LayoutCalendarEventsNewRoute
  '/communication/notifications/portal-notifications': typeof LayoutCommunicationNotificationsPortalNotificationsRoute
  '/communication/notifications/teams-notifications': typeof LayoutCommunicationNotificationsTeamsNotificationsRoute
  '/parents/$parentId/contact-info': typeof LayoutParentsParentIdContactInfoRoute
  '/referrals/wellbeing/assigned': typeof LayoutReferralsWellbeingAssignedRouteWithChildren
  '/referrals/wellbeing/create': typeof LayoutReferralsWellbeingCreateRoute
  '/referrals/wellbeing/my': typeof LayoutReferralsWellbeingMyRouteWithChildren
  '/reports/sar/curriculum': typeof LayoutReportsSarCurriculumRoute
  '/reports/sar/pastoral': typeof LayoutReportsSarPastoralRoute
  '/staff/$initials/photo': typeof LayoutStaffInitialsPhotoRoute
  '/staff/$initials/roles': typeof LayoutStaffInitialsRolesRoute
  '/staff/$initials/timetable': typeof LayoutStaffInitialsTimetableRoute
  '/students/$studentNo/details': typeof LayoutStudentsStudentNoDetailsRoute
  '/students/$studentNo/documents': typeof LayoutStudentsStudentNoDocumentsRoute
  '/students/$studentNo/gcse': typeof LayoutStudentsStudentNoGcseRoute
  '/students/$studentNo/markbook': typeof LayoutStudentsStudentNoMarkbookRoute
  '/students/$studentNo/parents': typeof LayoutStudentsStudentNoParentsRoute
  '/students/$studentNo/photo': typeof LayoutStudentsStudentNoPhotoRoute
  '/students/$studentNo/reviews': typeof LayoutStudentsStudentNoReviewsRoute
  '/students/$studentNo/student-agreements': typeof LayoutStudentsStudentNoStudentAgreementsRoute
  '/students/$studentNo/summary': typeof LayoutStudentsStudentNoSummaryRoute
  '/students/$studentNo/support': typeof LayoutStudentsStudentNoSupportRoute
  '/students/$studentNo/timetable': typeof LayoutStudentsStudentNoTimetableRoute
  '/timetables/$type/$identifier': typeof LayoutTimetablesTypeIdentifierRoute
  '/assets/card-printer': typeof LayoutAssetsCardPrinterIndexRoute
  '/parents/$parentId': typeof LayoutParentsParentIdIndexRoute
  '/referrals/wellbeing': typeof LayoutReferralsWellbeingIndexRoute
  '/staff/$initials': typeof LayoutStaffInitialsIndexRoute
  '/students/$studentNo': typeof LayoutStudentsStudentNoIndexRoute
  '/tools/teams-administration': typeof LayoutToolsTeamsAdministrationIndexRoute
  '/groups/all/classes': typeof LayoutTeacherPortalGroupsAllClassesRoute
  '/groups/all/courses': typeof LayoutTeacherPortalGroupsAllCoursesRoute
  '/groups/all/departments': typeof LayoutTeacherPortalGroupsAllDepartmentsRoute
  '/groups/all/faculties': typeof LayoutTeacherPortalGroupsAllFacultiesRoute
  '/groups/all/subjects': typeof LayoutTeacherPortalGroupsAllSubjectsRoute
  '/groups/my/classes': typeof LayoutTeacherPortalGroupsMyClassesRoute
  '/groups/my/college': typeof LayoutTeacherPortalGroupsMyCollegeRoute
  '/calendar/events/$eventId/edit': typeof LayoutCalendarEventsEventIdEditRoute
  '/cars/staff/$carId/dvla': typeof LayoutCarsStaffCarIdDvlaRoute
  '/cars/student/$carId/dvla': typeof LayoutCarsStudentCarIdDvlaRoute
  '/referrals/wellbeing/assigned/$category': typeof LayoutReferralsWellbeingAssignedCategoryRouteWithChildren
  '/referrals/wellbeing/manage/$referralId': typeof LayoutReferralsWellbeingManageReferralIdRoute
  '/referrals/wellbeing/my/$referralId': typeof LayoutReferralsWellbeingMyReferralIdRoute
  '/students/$studentNo/action-plans/referrals': typeof LayoutStudentsStudentNoActionPlansReferralsRoute
  '/students/$studentNo/attendance/absences': typeof LayoutStudentsStudentNoAttendanceAbsencesRoute
  '/students/$studentNo/attendance/punctuality': typeof LayoutStudentsStudentNoAttendancePunctualityRoute
  '/students/$studentNo/conversations/$conversationId': typeof LayoutStudentsStudentNoConversationsConversationIdRoute
  '/cars/staff/$carId': typeof LayoutCarsStaffCarIdIndexRoute
  '/cars/student/$carId': typeof LayoutCarsStudentCarIdIndexRoute
  '/students/$studentNo/action-plans': typeof LayoutStudentsStudentNoActionPlansIndexRoute
  '/students/$studentNo/attendance': typeof LayoutStudentsStudentNoAttendanceIndexRoute
  '/students/$studentNo/conversations': typeof LayoutStudentsStudentNoConversationsIndexRoute
  '/tools/teams-administration/teams': typeof LayoutToolsTeamsAdministrationTeamsIndexRoute
  '/groups/classes/$classId/access-arrangements': typeof LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute
  '/groups/classes/$classId/attendance': typeof LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute
  '/groups/classes/$classId/classroom-adjustments': typeof LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute
  '/groups/classes/$classId/gallery': typeof LayoutTeacherPortalGroupsClassesClassIdGalleryRoute
  '/groups/classes/$classId/orbit': typeof LayoutTeacherPortalGroupsClassesClassIdOrbitRoute
  '/groups/classes/$classId/references': typeof LayoutTeacherPortalGroupsClassesClassIdReferencesRoute
  '/groups/classes/$classId/support': typeof LayoutTeacherPortalGroupsClassesClassIdSupportRoute
  '/referrals/wellbeing/assigned/$category/$assignmentId': typeof LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute
  '/students/$studentNo/action-plans/academic-support/$subjectSlug': typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteWithChildren
  '/groups/classes/$classId': typeof LayoutTeacherPortalGroupsClassesClassIdIndexRoute
  '/groups/course/$courseId': typeof LayoutTeacherPortalGroupsCourseCourseIdIndexRoute
  '/groups/department/$departmentId': typeof LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute
  '/groups/faculty/$facultyId': typeof LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute
  '/groups/my/department': typeof LayoutTeacherPortalGroupsMyDepartmentIndexRoute
  '/groups/my/faculty': typeof LayoutTeacherPortalGroupsMyFacultyIndexRoute
  '/groups/subject/$subjectId': typeof LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute
  '/students/$studentNo/action-plans/$type': typeof LayoutStudentsStudentNoActionPlansTypeIndexRoute
  '/students/$studentNo/action-plans/academic-support': typeof LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute
  '/tools/teams-administration/teams/$teamId': typeof LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute
  '/tools/teams-administration/teams/$teamId/channels/$channelId': typeof LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute
  '/groups/my/department/$subjectId': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute
  '/groups/my/faculty/$departmentId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute
  '/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId': typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute
  '/groups/my/department/$subjectId/$courseId': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute
  '/groups/my/faculty/$departmentId/$subjectId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute
  '/groups/my/faculty/$departmentId/$subjectId/$courseId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/_nolayout': typeof NolayoutRouteWithChildren
  '/_layout/_teacher-portal': typeof LayoutTeacherPortalRouteRouteWithChildren
  '/_layout/admin': typeof LayoutAdminRouteRouteWithChildren
  '/_layout/assets': typeof LayoutAssetsRouteRouteWithChildren
  '/_layout/calendar': typeof LayoutCalendarRouteRouteWithChildren
  '/_layout/cars': typeof LayoutCarsRouteRouteWithChildren
  '/_layout/communication': typeof LayoutCommunicationRouteRouteWithChildren
  '/_layout/me': typeof LayoutMeRouteRouteWithChildren
  '/_layout/parents': typeof LayoutParentsRouteRouteWithChildren
  '/_layout/referrals': typeof LayoutReferralsRouteRouteWithChildren
  '/_layout/reports': typeof LayoutReportsRouteRouteWithChildren
  '/_layout/staff': typeof LayoutStaffRouteRouteWithChildren
  '/_layout/students': typeof LayoutStudentsRouteRouteWithChildren
  '/_layout/tools': typeof LayoutToolsRouteRouteWithChildren
  '/_nolayout/_auth': typeof NolayoutAuthRouteRouteWithChildren
  '/_layout/book-a-room': typeof LayoutBookARoomRoute
  '/_layout/feed': typeof LayoutFeedRoute
  '/_layout/home': typeof LayoutHomeRoute
  '/_layout/map': typeof LayoutMapRoute
  '/_layout/notices': typeof LayoutNoticesRoute
  '/_layout/notifications': typeof LayoutNotificationsRoute
  '/_layout/parent-shop': typeof LayoutParentShopRoute
  '/_layout/report-hub': typeof LayoutReportHubRoute
  '/_layout/rooms': typeof LayoutRoomsRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/tabs': typeof LayoutTabsRoute
  '/_layout/teacher-portal': typeof LayoutTeacherPortalRoute
  '/_layout/tickets': typeof LayoutTicketsRoute
  '/_layout/timetables': typeof LayoutTimetablesRouteWithChildren
  '/_layout/unauthorised': typeof LayoutUnauthorisedRoute
  '/_nolayout/public-page': typeof NolayoutPublicPageRoute
  '/_layout/_teacher-portal/groups': typeof LayoutTeacherPortalGroupsRouteRouteWithChildren
  '/_layout/calendar/events': typeof LayoutCalendarEventsRouteRouteWithChildren
  '/_layout/communication/notifications': typeof LayoutCommunicationNotificationsRouteRouteWithChildren
  '/_layout/parents/$parentId': typeof LayoutParentsParentIdRouteRouteWithChildren
  '/_layout/referrals/wellbeing': typeof LayoutReferralsWellbeingRouteRouteWithChildren
  '/_layout/staff/$initials': typeof LayoutStaffInitialsRouteRouteWithChildren
  '/_layout/students/$studentNo': typeof LayoutStudentsStudentNoRouteRouteWithChildren
  '/_layout/tools/teams-administration': typeof LayoutToolsTeamsAdministrationRouteRouteWithChildren
  '/_layout/_teacher-portal/action-plans': typeof LayoutTeacherPortalActionPlansRoute
  '/_layout/_teacher-portal/courses': typeof LayoutTeacherPortalCoursesRoute
  '/_layout/_teacher-portal/watchlists': typeof LayoutTeacherPortalWatchlistsRoute
  '/_layout/admin/banners': typeof LayoutAdminBannersRoute
  '/_layout/admin/calendar': typeof LayoutAdminCalendarRoute
  '/_layout/admin/connected-users': typeof LayoutAdminConnectedUsersRoute
  '/_layout/admin/permissions': typeof LayoutAdminPermissionsRoute
  '/_layout/admin/roles': typeof LayoutAdminRolesRoute
  '/_layout/admin/student-lists': typeof LayoutAdminStudentListsRoute
  '/_layout/admin/teams-app-installations': typeof LayoutAdminTeamsAppInstallationsRoute
  '/_layout/assets/card-printer': typeof LayoutAssetsCardPrinterRouteWithChildren
  '/_layout/assets/computers': typeof LayoutAssetsComputersRoute
  '/_layout/assets/monitors': typeof LayoutAssetsMonitorsRoute
  '/_layout/assets/printers': typeof LayoutAssetsPrintersRoute
  '/_layout/assets/projector-types': typeof LayoutAssetsProjectorTypesRoute
  '/_layout/calendar/_view': typeof LayoutCalendarViewRoute
  '/_layout/cars/all': typeof LayoutCarsAllRoute
  '/_layout/cars/search': typeof LayoutCarsSearchRoute
  '/_layout/communication/campaigns': typeof LayoutCommunicationCampaignsRoute
  '/_layout/communication/email': typeof LayoutCommunicationEmailRoute
  '/_layout/communication/feed': typeof LayoutCommunicationFeedRoute
  '/_layout/documents/{-$folderId}': typeof LayoutDocumentsChar123FolderIdChar125Route
  '/_layout/me/$tab': typeof LayoutMeTabRoute
  '/_layout/parents-evening/book': typeof LayoutParentsEveningBookRoute
  '/_layout/parents-evening/meet': typeof LayoutParentsEveningMeetRoute
  '/_layout/parents/all': typeof LayoutParentsAllRoute
  '/_layout/referrals/exam-access-arrangements': typeof LayoutReferralsExamAccessArrangementsRoute
  '/_layout/referrals/study-support': typeof LayoutReferralsStudySupportRoute
  '/_layout/reports/destinations': typeof LayoutReportsDestinationsRoute
  '/_layout/staff/finder': typeof LayoutStaffFinderRoute
  '/_layout/staff/on-site': typeof LayoutStaffOnSiteRoute
  '/_layout/staff/staff-directory': typeof LayoutStaffStaffDirectoryRoute
  '/_layout/student-futures/destinations': typeof LayoutStudentFuturesDestinationsRoute
  '/_layout/students/finder': typeof LayoutStudentsFinderRoute
  '/_layout/students/lists': typeof LayoutStudentsListsRoute
  '/_layout/students/my': typeof LayoutStudentsMyRoute
  '/_layout/timetables/$type': typeof LayoutTimetablesTypeRouteWithChildren
  '/_layout/tools/qr-code-maker': typeof LayoutToolsQrCodeMakerRoute
  '/_layout/tools/send-teams-message': typeof LayoutToolsSendTeamsMessageRoute
  '/_layout/tools/sortathon': typeof LayoutToolsSortathonRoute
  '/_layout/tools/soundboard': typeof LayoutToolsSoundboardRoute
  '/_nolayout/_auth/register': typeof NolayoutAuthRegisterRoute
  '/_nolayout/_auth/sign-in': typeof NolayoutAuthSignInRoute
  '/_layout/admin/': typeof LayoutAdminIndexRoute
  '/_layout/assets/': typeof LayoutAssetsIndexRoute
  '/_layout/calendar/': typeof LayoutCalendarIndexRoute
  '/_layout/communication/': typeof LayoutCommunicationIndexRoute
  '/_layout/me/': typeof LayoutMeIndexRoute
  '/_layout/parents-evening/': typeof LayoutParentsEveningIndexRoute
  '/_layout/referrals/': typeof LayoutReferralsIndexRoute
  '/_layout/staff/': typeof LayoutStaffIndexRoute
  '/_layout/students/': typeof LayoutStudentsIndexRoute
  '/_layout/tools/': typeof LayoutToolsIndexRoute
  '/_nolayout/induction/': typeof NolayoutInductionIndexRoute
  '/_layout/_teacher-portal/groups/classes': typeof LayoutTeacherPortalGroupsClassesRouteRouteWithChildren
  '/_layout/cars/staff/$carId': typeof LayoutCarsStaffCarIdRouteRouteWithChildren
  '/_layout/cars/student/$carId': typeof LayoutCarsStudentCarIdRouteRouteWithChildren
  '/_layout/referrals/wellbeing/manage': typeof LayoutReferralsWellbeingManageRouteRouteWithChildren
  '/_layout/students/$studentNo/action-plans': typeof LayoutStudentsStudentNoActionPlansRouteRouteWithChildren
  '/_layout/students/$studentNo/attendance': typeof LayoutStudentsStudentNoAttendanceRouteRouteWithChildren
  '/_layout/students/$studentNo/conversations': typeof LayoutStudentsStudentNoConversationsRouteRouteWithChildren
  '/_layout/tools/teams-administration/teams': typeof LayoutToolsTeamsAdministrationTeamsRouteRouteWithChildren
  '/_layout/assets/card-printer/print-jobs': typeof LayoutAssetsCardPrinterPrintJobsRoute
  '/_layout/assets/card-printer/printed-cards': typeof LayoutAssetsCardPrinterPrintedCardsRoute
  '/_layout/assets/card-printer/printers': typeof LayoutAssetsCardPrinterPrintersRoute
  '/_layout/calendar/events/$eventId': typeof LayoutCalendarEventsEventIdRoute
  '/_layout/calendar/events/new': typeof LayoutCalendarEventsNewRoute
  '/_layout/communication/notifications/portal-notifications': typeof LayoutCommunicationNotificationsPortalNotificationsRoute
  '/_layout/communication/notifications/teams-notifications': typeof LayoutCommunicationNotificationsTeamsNotificationsRoute
  '/_layout/parents/$parentId/contact-info': typeof LayoutParentsParentIdContactInfoRoute
  '/_layout/referrals/wellbeing/assigned': typeof LayoutReferralsWellbeingAssignedRouteWithChildren
  '/_layout/referrals/wellbeing/create': typeof LayoutReferralsWellbeingCreateRoute
  '/_layout/referrals/wellbeing/my': typeof LayoutReferralsWellbeingMyRouteWithChildren
  '/_layout/reports/sar/curriculum': typeof LayoutReportsSarCurriculumRoute
  '/_layout/reports/sar/pastoral': typeof LayoutReportsSarPastoralRoute
  '/_layout/staff/$initials/photo': typeof LayoutStaffInitialsPhotoRoute
  '/_layout/staff/$initials/roles': typeof LayoutStaffInitialsRolesRoute
  '/_layout/staff/$initials/timetable': typeof LayoutStaffInitialsTimetableRoute
  '/_layout/students/$studentNo/details': typeof LayoutStudentsStudentNoDetailsRoute
  '/_layout/students/$studentNo/documents': typeof LayoutStudentsStudentNoDocumentsRoute
  '/_layout/students/$studentNo/gcse': typeof LayoutStudentsStudentNoGcseRoute
  '/_layout/students/$studentNo/markbook': typeof LayoutStudentsStudentNoMarkbookRoute
  '/_layout/students/$studentNo/parents': typeof LayoutStudentsStudentNoParentsRoute
  '/_layout/students/$studentNo/photo': typeof LayoutStudentsStudentNoPhotoRoute
  '/_layout/students/$studentNo/reviews': typeof LayoutStudentsStudentNoReviewsRoute
  '/_layout/students/$studentNo/student-agreements': typeof LayoutStudentsStudentNoStudentAgreementsRoute
  '/_layout/students/$studentNo/summary': typeof LayoutStudentsStudentNoSummaryRoute
  '/_layout/students/$studentNo/support': typeof LayoutStudentsStudentNoSupportRoute
  '/_layout/students/$studentNo/timetable': typeof LayoutStudentsStudentNoTimetableRoute
  '/_layout/timetables/$type/$identifier': typeof LayoutTimetablesTypeIdentifierRoute
  '/_layout/assets/card-printer/': typeof LayoutAssetsCardPrinterIndexRoute
  '/_layout/parents/$parentId/': typeof LayoutParentsParentIdIndexRoute
  '/_layout/referrals/wellbeing/': typeof LayoutReferralsWellbeingIndexRoute
  '/_layout/staff/$initials/': typeof LayoutStaffInitialsIndexRoute
  '/_layout/students/$studentNo/': typeof LayoutStudentsStudentNoIndexRoute
  '/_layout/tools/teams-administration/': typeof LayoutToolsTeamsAdministrationIndexRoute
  '/_layout/_teacher-portal/groups/classes/$classId': typeof LayoutTeacherPortalGroupsClassesClassIdRouteRouteWithChildren
  '/_layout/_teacher-portal/groups/my/department': typeof LayoutTeacherPortalGroupsMyDepartmentRouteRouteWithChildren
  '/_layout/_teacher-portal/groups/my/faculty': typeof LayoutTeacherPortalGroupsMyFacultyRouteRouteWithChildren
  '/_layout/students/$studentNo/action-plans/$type': typeof LayoutStudentsStudentNoActionPlansTypeRouteRouteWithChildren
  '/_layout/students/$studentNo/action-plans/academic-support': typeof LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteWithChildren
  '/_layout/tools/teams-administration/teams/$teamId': typeof LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteWithChildren
  '/_layout/_teacher-portal/groups/all/classes': typeof LayoutTeacherPortalGroupsAllClassesRoute
  '/_layout/_teacher-portal/groups/all/courses': typeof LayoutTeacherPortalGroupsAllCoursesRoute
  '/_layout/_teacher-portal/groups/all/departments': typeof LayoutTeacherPortalGroupsAllDepartmentsRoute
  '/_layout/_teacher-portal/groups/all/faculties': typeof LayoutTeacherPortalGroupsAllFacultiesRoute
  '/_layout/_teacher-portal/groups/all/subjects': typeof LayoutTeacherPortalGroupsAllSubjectsRoute
  '/_layout/_teacher-portal/groups/my/classes': typeof LayoutTeacherPortalGroupsMyClassesRoute
  '/_layout/_teacher-portal/groups/my/college': typeof LayoutTeacherPortalGroupsMyCollegeRoute
  '/_layout/calendar/events_/$eventId/edit': typeof LayoutCalendarEventsEventIdEditRoute
  '/_layout/cars/staff/$carId/dvla': typeof LayoutCarsStaffCarIdDvlaRoute
  '/_layout/cars/student/$carId/dvla': typeof LayoutCarsStudentCarIdDvlaRoute
  '/_layout/referrals/wellbeing/assigned/$category': typeof LayoutReferralsWellbeingAssignedCategoryRouteWithChildren
  '/_layout/referrals/wellbeing/manage/$referralId': typeof LayoutReferralsWellbeingManageReferralIdRoute
  '/_layout/referrals/wellbeing/my/$referralId': typeof LayoutReferralsWellbeingMyReferralIdRoute
  '/_layout/students/$studentNo/action-plans/referrals': typeof LayoutStudentsStudentNoActionPlansReferralsRoute
  '/_layout/students/$studentNo/attendance/absences': typeof LayoutStudentsStudentNoAttendanceAbsencesRoute
  '/_layout/students/$studentNo/attendance/punctuality': typeof LayoutStudentsStudentNoAttendancePunctualityRoute
  '/_layout/students/$studentNo/conversations/$conversationId': typeof LayoutStudentsStudentNoConversationsConversationIdRoute
  '/_layout/cars/staff/$carId/': typeof LayoutCarsStaffCarIdIndexRoute
  '/_layout/cars/student/$carId/': typeof LayoutCarsStudentCarIdIndexRoute
  '/_layout/students/$studentNo/action-plans/': typeof LayoutStudentsStudentNoActionPlansIndexRoute
  '/_layout/students/$studentNo/attendance/': typeof LayoutStudentsStudentNoAttendanceIndexRoute
  '/_layout/students/$studentNo/conversations/': typeof LayoutStudentsStudentNoConversationsIndexRoute
  '/_layout/tools/teams-administration/teams/': typeof LayoutToolsTeamsAdministrationTeamsIndexRoute
  '/_layout/_teacher-portal/groups/my/department/$subjectId': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteWithChildren
  '/_layout/_teacher-portal/groups/my/faculty/$departmentId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteWithChildren
  '/_layout/_teacher-portal/groups/classes/$classId/access-arrangements': typeof LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute
  '/_layout/_teacher-portal/groups/classes/$classId/attendance': typeof LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute
  '/_layout/_teacher-portal/groups/classes/$classId/classroom-adjustments': typeof LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute
  '/_layout/_teacher-portal/groups/classes/$classId/gallery': typeof LayoutTeacherPortalGroupsClassesClassIdGalleryRoute
  '/_layout/_teacher-portal/groups/classes/$classId/orbit': typeof LayoutTeacherPortalGroupsClassesClassIdOrbitRoute
  '/_layout/_teacher-portal/groups/classes/$classId/references': typeof LayoutTeacherPortalGroupsClassesClassIdReferencesRoute
  '/_layout/_teacher-portal/groups/classes/$classId/support': typeof LayoutTeacherPortalGroupsClassesClassIdSupportRoute
  '/_layout/referrals/wellbeing/assigned/$category/$assignmentId': typeof LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute
  '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug': typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteWithChildren
  '/_layout/_teacher-portal/groups/classes/$classId/': typeof LayoutTeacherPortalGroupsClassesClassIdIndexRoute
  '/_layout/_teacher-portal/groups/course/$courseId/': typeof LayoutTeacherPortalGroupsCourseCourseIdIndexRoute
  '/_layout/_teacher-portal/groups/department/$departmentId/': typeof LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute
  '/_layout/_teacher-portal/groups/faculty/$facultyId/': typeof LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute
  '/_layout/_teacher-portal/groups/my/department/': typeof LayoutTeacherPortalGroupsMyDepartmentIndexRoute
  '/_layout/_teacher-portal/groups/my/faculty/': typeof LayoutTeacherPortalGroupsMyFacultyIndexRoute
  '/_layout/_teacher-portal/groups/subject/$subjectId/': typeof LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute
  '/_layout/students/$studentNo/action-plans/$type/': typeof LayoutStudentsStudentNoActionPlansTypeIndexRoute
  '/_layout/students/$studentNo/action-plans/academic-support/': typeof LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute
  '/_layout/tools/teams-administration/teams/$teamId/': typeof LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute
  '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteWithChildren
  '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteWithChildren
  '/_layout/tools/teams-administration/teams/$teamId/channels/$channelId': typeof LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute
  '/_layout/_teacher-portal/groups/my/department/$subjectId/': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute
  '/_layout/_teacher-portal/groups/my/faculty/$departmentId/': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute
  '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteWithChildren
  '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId': typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute
  '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId/': typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute
  '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute
  '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/': typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/assets'
    | '/calendar'
    | '/cars'
    | '/communication'
    | '/me'
    | '/parents'
    | '/referrals'
    | '/reports'
    | '/staff'
    | '/students'
    | '/tools'
    | '/book-a-room'
    | '/feed'
    | '/home'
    | '/map'
    | '/notices'
    | '/notifications'
    | '/parent-shop'
    | '/report-hub'
    | '/rooms'
    | '/settings'
    | '/tabs'
    | '/teacher-portal'
    | '/tickets'
    | '/timetables'
    | '/unauthorised'
    | '/public-page'
    | '/groups'
    | '/calendar/events'
    | '/communication/notifications'
    | '/parents/$parentId'
    | '/referrals/wellbeing'
    | '/staff/$initials'
    | '/students/$studentNo'
    | '/tools/teams-administration'
    | '/action-plans'
    | '/courses'
    | '/watchlists'
    | '/admin/banners'
    | '/admin/calendar'
    | '/admin/connected-users'
    | '/admin/permissions'
    | '/admin/roles'
    | '/admin/student-lists'
    | '/admin/teams-app-installations'
    | '/assets/card-printer'
    | '/assets/computers'
    | '/assets/monitors'
    | '/assets/printers'
    | '/assets/projector-types'
    | '/cars/all'
    | '/cars/search'
    | '/communication/campaigns'
    | '/communication/email'
    | '/communication/feed'
    | '/documents/{-$folderId}'
    | '/me/$tab'
    | '/parents-evening/book'
    | '/parents-evening/meet'
    | '/parents/all'
    | '/referrals/exam-access-arrangements'
    | '/referrals/study-support'
    | '/reports/destinations'
    | '/staff/finder'
    | '/staff/on-site'
    | '/staff/staff-directory'
    | '/student-futures/destinations'
    | '/students/finder'
    | '/students/lists'
    | '/students/my'
    | '/timetables/$type'
    | '/tools/qr-code-maker'
    | '/tools/send-teams-message'
    | '/tools/sortathon'
    | '/tools/soundboard'
    | '/register'
    | '/sign-in'
    | '/admin/'
    | '/assets/'
    | '/calendar/'
    | '/communication/'
    | '/me/'
    | '/parents-evening/'
    | '/referrals/'
    | '/staff/'
    | '/students/'
    | '/tools/'
    | '/induction/'
    | '/groups/classes'
    | '/cars/staff/$carId'
    | '/cars/student/$carId'
    | '/referrals/wellbeing/manage'
    | '/students/$studentNo/action-plans'
    | '/students/$studentNo/attendance'
    | '/students/$studentNo/conversations'
    | '/tools/teams-administration/teams'
    | '/assets/card-printer/print-jobs'
    | '/assets/card-printer/printed-cards'
    | '/assets/card-printer/printers'
    | '/calendar/events/$eventId'
    | '/calendar/events/new'
    | '/communication/notifications/portal-notifications'
    | '/communication/notifications/teams-notifications'
    | '/parents/$parentId/contact-info'
    | '/referrals/wellbeing/assigned'
    | '/referrals/wellbeing/create'
    | '/referrals/wellbeing/my'
    | '/reports/sar/curriculum'
    | '/reports/sar/pastoral'
    | '/staff/$initials/photo'
    | '/staff/$initials/roles'
    | '/staff/$initials/timetable'
    | '/students/$studentNo/details'
    | '/students/$studentNo/documents'
    | '/students/$studentNo/gcse'
    | '/students/$studentNo/markbook'
    | '/students/$studentNo/parents'
    | '/students/$studentNo/photo'
    | '/students/$studentNo/reviews'
    | '/students/$studentNo/student-agreements'
    | '/students/$studentNo/summary'
    | '/students/$studentNo/support'
    | '/students/$studentNo/timetable'
    | '/timetables/$type/$identifier'
    | '/assets/card-printer/'
    | '/parents/$parentId/'
    | '/referrals/wellbeing/'
    | '/staff/$initials/'
    | '/students/$studentNo/'
    | '/tools/teams-administration/'
    | '/groups/classes/$classId'
    | '/groups/my/department'
    | '/groups/my/faculty'
    | '/students/$studentNo/action-plans/$type'
    | '/students/$studentNo/action-plans/academic-support'
    | '/tools/teams-administration/teams/$teamId'
    | '/groups/all/classes'
    | '/groups/all/courses'
    | '/groups/all/departments'
    | '/groups/all/faculties'
    | '/groups/all/subjects'
    | '/groups/my/classes'
    | '/groups/my/college'
    | '/calendar/events/$eventId/edit'
    | '/cars/staff/$carId/dvla'
    | '/cars/student/$carId/dvla'
    | '/referrals/wellbeing/assigned/$category'
    | '/referrals/wellbeing/manage/$referralId'
    | '/referrals/wellbeing/my/$referralId'
    | '/students/$studentNo/action-plans/referrals'
    | '/students/$studentNo/attendance/absences'
    | '/students/$studentNo/attendance/punctuality'
    | '/students/$studentNo/conversations/$conversationId'
    | '/cars/staff/$carId/'
    | '/cars/student/$carId/'
    | '/students/$studentNo/action-plans/'
    | '/students/$studentNo/attendance/'
    | '/students/$studentNo/conversations/'
    | '/tools/teams-administration/teams/'
    | '/groups/my/department/$subjectId'
    | '/groups/my/faculty/$departmentId'
    | '/groups/classes/$classId/access-arrangements'
    | '/groups/classes/$classId/attendance'
    | '/groups/classes/$classId/classroom-adjustments'
    | '/groups/classes/$classId/gallery'
    | '/groups/classes/$classId/orbit'
    | '/groups/classes/$classId/references'
    | '/groups/classes/$classId/support'
    | '/referrals/wellbeing/assigned/$category/$assignmentId'
    | '/students/$studentNo/action-plans/academic-support/$subjectSlug'
    | '/groups/classes/$classId/'
    | '/groups/course/$courseId/'
    | '/groups/department/$departmentId/'
    | '/groups/faculty/$facultyId/'
    | '/groups/my/department/'
    | '/groups/my/faculty/'
    | '/groups/subject/$subjectId/'
    | '/students/$studentNo/action-plans/$type/'
    | '/students/$studentNo/action-plans/academic-support/'
    | '/tools/teams-administration/teams/$teamId/'
    | '/groups/my/department/$subjectId/$courseId'
    | '/groups/my/faculty/$departmentId/$subjectId'
    | '/tools/teams-administration/teams/$teamId/channels/$channelId'
    | '/groups/my/department/$subjectId/'
    | '/groups/my/faculty/$departmentId/'
    | '/groups/my/faculty/$departmentId/$subjectId/$courseId'
    | '/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId'
    | '/groups/my/department/$subjectId/$courseId/'
    | '/groups/my/faculty/$departmentId/$subjectId/'
    | '/groups/my/faculty/$departmentId/$subjectId/$courseId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cars'
    | '/parents'
    | '/reports'
    | '/book-a-room'
    | '/feed'
    | '/home'
    | '/map'
    | '/notices'
    | '/notifications'
    | '/parent-shop'
    | '/report-hub'
    | '/rooms'
    | '/settings'
    | '/tabs'
    | '/teacher-portal'
    | '/tickets'
    | '/timetables'
    | '/unauthorised'
    | '/public-page'
    | '/groups'
    | '/calendar/events'
    | '/communication/notifications'
    | '/action-plans'
    | '/courses'
    | '/watchlists'
    | '/admin/banners'
    | '/admin/calendar'
    | '/admin/connected-users'
    | '/admin/permissions'
    | '/admin/roles'
    | '/admin/student-lists'
    | '/admin/teams-app-installations'
    | '/assets/computers'
    | '/assets/monitors'
    | '/assets/printers'
    | '/assets/projector-types'
    | '/calendar'
    | '/cars/all'
    | '/cars/search'
    | '/communication/campaigns'
    | '/communication/email'
    | '/communication/feed'
    | '/documents/{-$folderId}'
    | '/me/$tab'
    | '/parents-evening/book'
    | '/parents-evening/meet'
    | '/parents/all'
    | '/referrals/exam-access-arrangements'
    | '/referrals/study-support'
    | '/reports/destinations'
    | '/staff/finder'
    | '/staff/on-site'
    | '/staff/staff-directory'
    | '/student-futures/destinations'
    | '/students/finder'
    | '/students/lists'
    | '/students/my'
    | '/timetables/$type'
    | '/tools/qr-code-maker'
    | '/tools/send-teams-message'
    | '/tools/sortathon'
    | '/tools/soundboard'
    | '/register'
    | '/sign-in'
    | '/admin'
    | '/assets'
    | '/communication'
    | '/me'
    | '/parents-evening'
    | '/referrals'
    | '/staff'
    | '/students'
    | '/tools'
    | '/induction'
    | '/groups/classes'
    | '/referrals/wellbeing/manage'
    | '/assets/card-printer/print-jobs'
    | '/assets/card-printer/printed-cards'
    | '/assets/card-printer/printers'
    | '/calendar/events/$eventId'
    | '/calendar/events/new'
    | '/communication/notifications/portal-notifications'
    | '/communication/notifications/teams-notifications'
    | '/parents/$parentId/contact-info'
    | '/referrals/wellbeing/assigned'
    | '/referrals/wellbeing/create'
    | '/referrals/wellbeing/my'
    | '/reports/sar/curriculum'
    | '/reports/sar/pastoral'
    | '/staff/$initials/photo'
    | '/staff/$initials/roles'
    | '/staff/$initials/timetable'
    | '/students/$studentNo/details'
    | '/students/$studentNo/documents'
    | '/students/$studentNo/gcse'
    | '/students/$studentNo/markbook'
    | '/students/$studentNo/parents'
    | '/students/$studentNo/photo'
    | '/students/$studentNo/reviews'
    | '/students/$studentNo/student-agreements'
    | '/students/$studentNo/summary'
    | '/students/$studentNo/support'
    | '/students/$studentNo/timetable'
    | '/timetables/$type/$identifier'
    | '/assets/card-printer'
    | '/parents/$parentId'
    | '/referrals/wellbeing'
    | '/staff/$initials'
    | '/students/$studentNo'
    | '/tools/teams-administration'
    | '/groups/all/classes'
    | '/groups/all/courses'
    | '/groups/all/departments'
    | '/groups/all/faculties'
    | '/groups/all/subjects'
    | '/groups/my/classes'
    | '/groups/my/college'
    | '/calendar/events/$eventId/edit'
    | '/cars/staff/$carId/dvla'
    | '/cars/student/$carId/dvla'
    | '/referrals/wellbeing/assigned/$category'
    | '/referrals/wellbeing/manage/$referralId'
    | '/referrals/wellbeing/my/$referralId'
    | '/students/$studentNo/action-plans/referrals'
    | '/students/$studentNo/attendance/absences'
    | '/students/$studentNo/attendance/punctuality'
    | '/students/$studentNo/conversations/$conversationId'
    | '/cars/staff/$carId'
    | '/cars/student/$carId'
    | '/students/$studentNo/action-plans'
    | '/students/$studentNo/attendance'
    | '/students/$studentNo/conversations'
    | '/tools/teams-administration/teams'
    | '/groups/classes/$classId/access-arrangements'
    | '/groups/classes/$classId/attendance'
    | '/groups/classes/$classId/classroom-adjustments'
    | '/groups/classes/$classId/gallery'
    | '/groups/classes/$classId/orbit'
    | '/groups/classes/$classId/references'
    | '/groups/classes/$classId/support'
    | '/referrals/wellbeing/assigned/$category/$assignmentId'
    | '/students/$studentNo/action-plans/academic-support/$subjectSlug'
    | '/groups/classes/$classId'
    | '/groups/course/$courseId'
    | '/groups/department/$departmentId'
    | '/groups/faculty/$facultyId'
    | '/groups/my/department'
    | '/groups/my/faculty'
    | '/groups/subject/$subjectId'
    | '/students/$studentNo/action-plans/$type'
    | '/students/$studentNo/action-plans/academic-support'
    | '/tools/teams-administration/teams/$teamId'
    | '/tools/teams-administration/teams/$teamId/channels/$channelId'
    | '/groups/my/department/$subjectId'
    | '/groups/my/faculty/$departmentId'
    | '/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId'
    | '/groups/my/department/$subjectId/$courseId'
    | '/groups/my/faculty/$departmentId/$subjectId'
    | '/groups/my/faculty/$departmentId/$subjectId/$courseId'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/_nolayout'
    | '/_layout/_teacher-portal'
    | '/_layout/admin'
    | '/_layout/assets'
    | '/_layout/calendar'
    | '/_layout/cars'
    | '/_layout/communication'
    | '/_layout/me'
    | '/_layout/parents'
    | '/_layout/referrals'
    | '/_layout/reports'
    | '/_layout/staff'
    | '/_layout/students'
    | '/_layout/tools'
    | '/_nolayout/_auth'
    | '/_layout/book-a-room'
    | '/_layout/feed'
    | '/_layout/home'
    | '/_layout/map'
    | '/_layout/notices'
    | '/_layout/notifications'
    | '/_layout/parent-shop'
    | '/_layout/report-hub'
    | '/_layout/rooms'
    | '/_layout/settings'
    | '/_layout/tabs'
    | '/_layout/teacher-portal'
    | '/_layout/tickets'
    | '/_layout/timetables'
    | '/_layout/unauthorised'
    | '/_nolayout/public-page'
    | '/_layout/_teacher-portal/groups'
    | '/_layout/calendar/events'
    | '/_layout/communication/notifications'
    | '/_layout/parents/$parentId'
    | '/_layout/referrals/wellbeing'
    | '/_layout/staff/$initials'
    | '/_layout/students/$studentNo'
    | '/_layout/tools/teams-administration'
    | '/_layout/_teacher-portal/action-plans'
    | '/_layout/_teacher-portal/courses'
    | '/_layout/_teacher-portal/watchlists'
    | '/_layout/admin/banners'
    | '/_layout/admin/calendar'
    | '/_layout/admin/connected-users'
    | '/_layout/admin/permissions'
    | '/_layout/admin/roles'
    | '/_layout/admin/student-lists'
    | '/_layout/admin/teams-app-installations'
    | '/_layout/assets/card-printer'
    | '/_layout/assets/computers'
    | '/_layout/assets/monitors'
    | '/_layout/assets/printers'
    | '/_layout/assets/projector-types'
    | '/_layout/calendar/_view'
    | '/_layout/cars/all'
    | '/_layout/cars/search'
    | '/_layout/communication/campaigns'
    | '/_layout/communication/email'
    | '/_layout/communication/feed'
    | '/_layout/documents/{-$folderId}'
    | '/_layout/me/$tab'
    | '/_layout/parents-evening/book'
    | '/_layout/parents-evening/meet'
    | '/_layout/parents/all'
    | '/_layout/referrals/exam-access-arrangements'
    | '/_layout/referrals/study-support'
    | '/_layout/reports/destinations'
    | '/_layout/staff/finder'
    | '/_layout/staff/on-site'
    | '/_layout/staff/staff-directory'
    | '/_layout/student-futures/destinations'
    | '/_layout/students/finder'
    | '/_layout/students/lists'
    | '/_layout/students/my'
    | '/_layout/timetables/$type'
    | '/_layout/tools/qr-code-maker'
    | '/_layout/tools/send-teams-message'
    | '/_layout/tools/sortathon'
    | '/_layout/tools/soundboard'
    | '/_nolayout/_auth/register'
    | '/_nolayout/_auth/sign-in'
    | '/_layout/admin/'
    | '/_layout/assets/'
    | '/_layout/calendar/'
    | '/_layout/communication/'
    | '/_layout/me/'
    | '/_layout/parents-evening/'
    | '/_layout/referrals/'
    | '/_layout/staff/'
    | '/_layout/students/'
    | '/_layout/tools/'
    | '/_nolayout/induction/'
    | '/_layout/_teacher-portal/groups/classes'
    | '/_layout/cars/staff/$carId'
    | '/_layout/cars/student/$carId'
    | '/_layout/referrals/wellbeing/manage'
    | '/_layout/students/$studentNo/action-plans'
    | '/_layout/students/$studentNo/attendance'
    | '/_layout/students/$studentNo/conversations'
    | '/_layout/tools/teams-administration/teams'
    | '/_layout/assets/card-printer/print-jobs'
    | '/_layout/assets/card-printer/printed-cards'
    | '/_layout/assets/card-printer/printers'
    | '/_layout/calendar/events/$eventId'
    | '/_layout/calendar/events/new'
    | '/_layout/communication/notifications/portal-notifications'
    | '/_layout/communication/notifications/teams-notifications'
    | '/_layout/parents/$parentId/contact-info'
    | '/_layout/referrals/wellbeing/assigned'
    | '/_layout/referrals/wellbeing/create'
    | '/_layout/referrals/wellbeing/my'
    | '/_layout/reports/sar/curriculum'
    | '/_layout/reports/sar/pastoral'
    | '/_layout/staff/$initials/photo'
    | '/_layout/staff/$initials/roles'
    | '/_layout/staff/$initials/timetable'
    | '/_layout/students/$studentNo/details'
    | '/_layout/students/$studentNo/documents'
    | '/_layout/students/$studentNo/gcse'
    | '/_layout/students/$studentNo/markbook'
    | '/_layout/students/$studentNo/parents'
    | '/_layout/students/$studentNo/photo'
    | '/_layout/students/$studentNo/reviews'
    | '/_layout/students/$studentNo/student-agreements'
    | '/_layout/students/$studentNo/summary'
    | '/_layout/students/$studentNo/support'
    | '/_layout/students/$studentNo/timetable'
    | '/_layout/timetables/$type/$identifier'
    | '/_layout/assets/card-printer/'
    | '/_layout/parents/$parentId/'
    | '/_layout/referrals/wellbeing/'
    | '/_layout/staff/$initials/'
    | '/_layout/students/$studentNo/'
    | '/_layout/tools/teams-administration/'
    | '/_layout/_teacher-portal/groups/classes/$classId'
    | '/_layout/_teacher-portal/groups/my/department'
    | '/_layout/_teacher-portal/groups/my/faculty'
    | '/_layout/students/$studentNo/action-plans/$type'
    | '/_layout/students/$studentNo/action-plans/academic-support'
    | '/_layout/tools/teams-administration/teams/$teamId'
    | '/_layout/_teacher-portal/groups/all/classes'
    | '/_layout/_teacher-portal/groups/all/courses'
    | '/_layout/_teacher-portal/groups/all/departments'
    | '/_layout/_teacher-portal/groups/all/faculties'
    | '/_layout/_teacher-portal/groups/all/subjects'
    | '/_layout/_teacher-portal/groups/my/classes'
    | '/_layout/_teacher-portal/groups/my/college'
    | '/_layout/calendar/events_/$eventId/edit'
    | '/_layout/cars/staff/$carId/dvla'
    | '/_layout/cars/student/$carId/dvla'
    | '/_layout/referrals/wellbeing/assigned/$category'
    | '/_layout/referrals/wellbeing/manage/$referralId'
    | '/_layout/referrals/wellbeing/my/$referralId'
    | '/_layout/students/$studentNo/action-plans/referrals'
    | '/_layout/students/$studentNo/attendance/absences'
    | '/_layout/students/$studentNo/attendance/punctuality'
    | '/_layout/students/$studentNo/conversations/$conversationId'
    | '/_layout/cars/staff/$carId/'
    | '/_layout/cars/student/$carId/'
    | '/_layout/students/$studentNo/action-plans/'
    | '/_layout/students/$studentNo/attendance/'
    | '/_layout/students/$studentNo/conversations/'
    | '/_layout/tools/teams-administration/teams/'
    | '/_layout/_teacher-portal/groups/my/department/$subjectId'
    | '/_layout/_teacher-portal/groups/my/faculty/$departmentId'
    | '/_layout/_teacher-portal/groups/classes/$classId/access-arrangements'
    | '/_layout/_teacher-portal/groups/classes/$classId/attendance'
    | '/_layout/_teacher-portal/groups/classes/$classId/classroom-adjustments'
    | '/_layout/_teacher-portal/groups/classes/$classId/gallery'
    | '/_layout/_teacher-portal/groups/classes/$classId/orbit'
    | '/_layout/_teacher-portal/groups/classes/$classId/references'
    | '/_layout/_teacher-portal/groups/classes/$classId/support'
    | '/_layout/referrals/wellbeing/assigned/$category/$assignmentId'
    | '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug'
    | '/_layout/_teacher-portal/groups/classes/$classId/'
    | '/_layout/_teacher-portal/groups/course/$courseId/'
    | '/_layout/_teacher-portal/groups/department/$departmentId/'
    | '/_layout/_teacher-portal/groups/faculty/$facultyId/'
    | '/_layout/_teacher-portal/groups/my/department/'
    | '/_layout/_teacher-portal/groups/my/faculty/'
    | '/_layout/_teacher-portal/groups/subject/$subjectId/'
    | '/_layout/students/$studentNo/action-plans/$type/'
    | '/_layout/students/$studentNo/action-plans/academic-support/'
    | '/_layout/tools/teams-administration/teams/$teamId/'
    | '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId'
    | '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId'
    | '/_layout/tools/teams-administration/teams/$teamId/channels/$channelId'
    | '/_layout/_teacher-portal/groups/my/department/$subjectId/'
    | '/_layout/_teacher-portal/groups/my/faculty/$departmentId/'
    | '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId'
    | '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId'
    | '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId/'
    | '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/'
    | '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  NolayoutRoute: typeof NolayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_nolayout': {
      id: '/_nolayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof NolayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_nolayout/public-page': {
      id: '/_nolayout/public-page'
      path: '/public-page'
      fullPath: '/public-page'
      preLoaderRoute: typeof NolayoutPublicPageRouteImport
      parentRoute: typeof NolayoutRoute
    }
    '/_layout/unauthorised': {
      id: '/_layout/unauthorised'
      path: '/unauthorised'
      fullPath: '/unauthorised'
      preLoaderRoute: typeof LayoutUnauthorisedRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/timetables': {
      id: '/_layout/timetables'
      path: '/timetables'
      fullPath: '/timetables'
      preLoaderRoute: typeof LayoutTimetablesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/tickets': {
      id: '/_layout/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof LayoutTicketsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teacher-portal': {
      id: '/_layout/teacher-portal'
      path: '/teacher-portal'
      fullPath: '/teacher-portal'
      preLoaderRoute: typeof LayoutTeacherPortalRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/tabs': {
      id: '/_layout/tabs'
      path: '/tabs'
      fullPath: '/tabs'
      preLoaderRoute: typeof LayoutTabsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/rooms': {
      id: '/_layout/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof LayoutRoomsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/report-hub': {
      id: '/_layout/report-hub'
      path: '/report-hub'
      fullPath: '/report-hub'
      preLoaderRoute: typeof LayoutReportHubRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/parent-shop': {
      id: '/_layout/parent-shop'
      path: '/parent-shop'
      fullPath: '/parent-shop'
      preLoaderRoute: typeof LayoutParentShopRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/notifications': {
      id: '/_layout/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof LayoutNotificationsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/notices': {
      id: '/_layout/notices'
      path: '/notices'
      fullPath: '/notices'
      preLoaderRoute: typeof LayoutNoticesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/map': {
      id: '/_layout/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof LayoutMapRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/home': {
      id: '/_layout/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof LayoutHomeRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/feed': {
      id: '/_layout/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof LayoutFeedRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/book-a-room': {
      id: '/_layout/book-a-room'
      path: '/book-a-room'
      fullPath: '/book-a-room'
      preLoaderRoute: typeof LayoutBookARoomRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_nolayout/_auth': {
      id: '/_nolayout/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof NolayoutAuthRouteRouteImport
      parentRoute: typeof NolayoutRoute
    }
    '/_layout/tools': {
      id: '/_layout/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof LayoutToolsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students': {
      id: '/_layout/students'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof LayoutStudentsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/staff': {
      id: '/_layout/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof LayoutStaffRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/reports': {
      id: '/_layout/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof LayoutReportsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/referrals': {
      id: '/_layout/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof LayoutReferralsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/parents': {
      id: '/_layout/parents'
      path: '/parents'
      fullPath: '/parents'
      preLoaderRoute: typeof LayoutParentsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/me': {
      id: '/_layout/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof LayoutMeRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/communication': {
      id: '/_layout/communication'
      path: '/communication'
      fullPath: '/communication'
      preLoaderRoute: typeof LayoutCommunicationRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/cars': {
      id: '/_layout/cars'
      path: '/cars'
      fullPath: '/cars'
      preLoaderRoute: typeof LayoutCarsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/calendar': {
      id: '/_layout/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof LayoutCalendarRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/assets': {
      id: '/_layout/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof LayoutAssetsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin': {
      id: '/_layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof LayoutAdminRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/_teacher-portal': {
      id: '/_layout/_teacher-portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutTeacherPortalRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_nolayout/induction/': {
      id: '/_nolayout/induction/'
      path: '/induction'
      fullPath: '/induction/'
      preLoaderRoute: typeof NolayoutInductionIndexRouteImport
      parentRoute: typeof NolayoutRoute
    }
    '/_layout/tools/': {
      id: '/_layout/tools/'
      path: '/'
      fullPath: '/tools/'
      preLoaderRoute: typeof LayoutToolsIndexRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    '/_layout/students/': {
      id: '/_layout/students/'
      path: '/'
      fullPath: '/students/'
      preLoaderRoute: typeof LayoutStudentsIndexRouteImport
      parentRoute: typeof LayoutStudentsRouteRoute
    }
    '/_layout/staff/': {
      id: '/_layout/staff/'
      path: '/'
      fullPath: '/staff/'
      preLoaderRoute: typeof LayoutStaffIndexRouteImport
      parentRoute: typeof LayoutStaffRouteRoute
    }
    '/_layout/referrals/': {
      id: '/_layout/referrals/'
      path: '/'
      fullPath: '/referrals/'
      preLoaderRoute: typeof LayoutReferralsIndexRouteImport
      parentRoute: typeof LayoutReferralsRouteRoute
    }
    '/_layout/parents-evening/': {
      id: '/_layout/parents-evening/'
      path: '/parents-evening'
      fullPath: '/parents-evening/'
      preLoaderRoute: typeof LayoutParentsEveningIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/me/': {
      id: '/_layout/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof LayoutMeIndexRouteImport
      parentRoute: typeof LayoutMeRouteRoute
    }
    '/_layout/communication/': {
      id: '/_layout/communication/'
      path: '/'
      fullPath: '/communication/'
      preLoaderRoute: typeof LayoutCommunicationIndexRouteImport
      parentRoute: typeof LayoutCommunicationRouteRoute
    }
    '/_layout/calendar/': {
      id: '/_layout/calendar/'
      path: '/'
      fullPath: '/calendar/'
      preLoaderRoute: typeof LayoutCalendarIndexRouteImport
      parentRoute: typeof LayoutCalendarRouteRoute
    }
    '/_layout/assets/': {
      id: '/_layout/assets/'
      path: '/'
      fullPath: '/assets/'
      preLoaderRoute: typeof LayoutAssetsIndexRouteImport
      parentRoute: typeof LayoutAssetsRouteRoute
    }
    '/_layout/admin/': {
      id: '/_layout/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof LayoutAdminIndexRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_nolayout/_auth/sign-in': {
      id: '/_nolayout/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof NolayoutAuthSignInRouteImport
      parentRoute: typeof NolayoutAuthRouteRoute
    }
    '/_nolayout/_auth/register': {
      id: '/_nolayout/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof NolayoutAuthRegisterRouteImport
      parentRoute: typeof NolayoutAuthRouteRoute
    }
    '/_layout/tools/soundboard': {
      id: '/_layout/tools/soundboard'
      path: '/soundboard'
      fullPath: '/tools/soundboard'
      preLoaderRoute: typeof LayoutToolsSoundboardRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    '/_layout/tools/sortathon': {
      id: '/_layout/tools/sortathon'
      path: '/sortathon'
      fullPath: '/tools/sortathon'
      preLoaderRoute: typeof LayoutToolsSortathonRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    '/_layout/tools/send-teams-message': {
      id: '/_layout/tools/send-teams-message'
      path: '/send-teams-message'
      fullPath: '/tools/send-teams-message'
      preLoaderRoute: typeof LayoutToolsSendTeamsMessageRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    '/_layout/tools/qr-code-maker': {
      id: '/_layout/tools/qr-code-maker'
      path: '/qr-code-maker'
      fullPath: '/tools/qr-code-maker'
      preLoaderRoute: typeof LayoutToolsQrCodeMakerRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    '/_layout/timetables/$type': {
      id: '/_layout/timetables/$type'
      path: '/$type'
      fullPath: '/timetables/$type'
      preLoaderRoute: typeof LayoutTimetablesTypeRouteImport
      parentRoute: typeof LayoutTimetablesRoute
    }
    '/_layout/students/my': {
      id: '/_layout/students/my'
      path: '/my'
      fullPath: '/students/my'
      preLoaderRoute: typeof LayoutStudentsMyRouteImport
      parentRoute: typeof LayoutStudentsRouteRoute
    }
    '/_layout/students/lists': {
      id: '/_layout/students/lists'
      path: '/lists'
      fullPath: '/students/lists'
      preLoaderRoute: typeof LayoutStudentsListsRouteImport
      parentRoute: typeof LayoutStudentsRouteRoute
    }
    '/_layout/students/finder': {
      id: '/_layout/students/finder'
      path: '/finder'
      fullPath: '/students/finder'
      preLoaderRoute: typeof LayoutStudentsFinderRouteImport
      parentRoute: typeof LayoutStudentsRouteRoute
    }
    '/_layout/student-futures/destinations': {
      id: '/_layout/student-futures/destinations'
      path: '/student-futures/destinations'
      fullPath: '/student-futures/destinations'
      preLoaderRoute: typeof LayoutStudentFuturesDestinationsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/staff/staff-directory': {
      id: '/_layout/staff/staff-directory'
      path: '/staff-directory'
      fullPath: '/staff/staff-directory'
      preLoaderRoute: typeof LayoutStaffStaffDirectoryRouteImport
      parentRoute: typeof LayoutStaffRouteRoute
    }
    '/_layout/staff/on-site': {
      id: '/_layout/staff/on-site'
      path: '/on-site'
      fullPath: '/staff/on-site'
      preLoaderRoute: typeof LayoutStaffOnSiteRouteImport
      parentRoute: typeof LayoutStaffRouteRoute
    }
    '/_layout/staff/finder': {
      id: '/_layout/staff/finder'
      path: '/finder'
      fullPath: '/staff/finder'
      preLoaderRoute: typeof LayoutStaffFinderRouteImport
      parentRoute: typeof LayoutStaffRouteRoute
    }
    '/_layout/reports/destinations': {
      id: '/_layout/reports/destinations'
      path: '/destinations'
      fullPath: '/reports/destinations'
      preLoaderRoute: typeof LayoutReportsDestinationsRouteImport
      parentRoute: typeof LayoutReportsRouteRoute
    }
    '/_layout/referrals/study-support': {
      id: '/_layout/referrals/study-support'
      path: '/study-support'
      fullPath: '/referrals/study-support'
      preLoaderRoute: typeof LayoutReferralsStudySupportRouteImport
      parentRoute: typeof LayoutReferralsRouteRoute
    }
    '/_layout/referrals/exam-access-arrangements': {
      id: '/_layout/referrals/exam-access-arrangements'
      path: '/exam-access-arrangements'
      fullPath: '/referrals/exam-access-arrangements'
      preLoaderRoute: typeof LayoutReferralsExamAccessArrangementsRouteImport
      parentRoute: typeof LayoutReferralsRouteRoute
    }
    '/_layout/parents/all': {
      id: '/_layout/parents/all'
      path: '/all'
      fullPath: '/parents/all'
      preLoaderRoute: typeof LayoutParentsAllRouteImport
      parentRoute: typeof LayoutParentsRouteRoute
    }
    '/_layout/parents-evening/meet': {
      id: '/_layout/parents-evening/meet'
      path: '/parents-evening/meet'
      fullPath: '/parents-evening/meet'
      preLoaderRoute: typeof LayoutParentsEveningMeetRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/parents-evening/book': {
      id: '/_layout/parents-evening/book'
      path: '/parents-evening/book'
      fullPath: '/parents-evening/book'
      preLoaderRoute: typeof LayoutParentsEveningBookRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/me/$tab': {
      id: '/_layout/me/$tab'
      path: '/$tab'
      fullPath: '/me/$tab'
      preLoaderRoute: typeof LayoutMeTabRouteImport
      parentRoute: typeof LayoutMeRouteRoute
    }
    '/_layout/documents/{-$folderId}': {
      id: '/_layout/documents/{-$folderId}'
      path: '/documents/{-$folderId}'
      fullPath: '/documents/{-$folderId}'
      preLoaderRoute: typeof LayoutDocumentsChar123FolderIdChar125RouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/communication/feed': {
      id: '/_layout/communication/feed'
      path: '/feed'
      fullPath: '/communication/feed'
      preLoaderRoute: typeof LayoutCommunicationFeedRouteImport
      parentRoute: typeof LayoutCommunicationRouteRoute
    }
    '/_layout/communication/email': {
      id: '/_layout/communication/email'
      path: '/email'
      fullPath: '/communication/email'
      preLoaderRoute: typeof LayoutCommunicationEmailRouteImport
      parentRoute: typeof LayoutCommunicationRouteRoute
    }
    '/_layout/communication/campaigns': {
      id: '/_layout/communication/campaigns'
      path: '/campaigns'
      fullPath: '/communication/campaigns'
      preLoaderRoute: typeof LayoutCommunicationCampaignsRouteImport
      parentRoute: typeof LayoutCommunicationRouteRoute
    }
    '/_layout/cars/search': {
      id: '/_layout/cars/search'
      path: '/search'
      fullPath: '/cars/search'
      preLoaderRoute: typeof LayoutCarsSearchRouteImport
      parentRoute: typeof LayoutCarsRouteRoute
    }
    '/_layout/cars/all': {
      id: '/_layout/cars/all'
      path: '/all'
      fullPath: '/cars/all'
      preLoaderRoute: typeof LayoutCarsAllRouteImport
      parentRoute: typeof LayoutCarsRouteRoute
    }
    '/_layout/calendar/_view': {
      id: '/_layout/calendar/_view'
      path: ''
      fullPath: '/calendar'
      preLoaderRoute: typeof LayoutCalendarViewRouteImport
      parentRoute: typeof LayoutCalendarRouteRoute
    }
    '/_layout/assets/projector-types': {
      id: '/_layout/assets/projector-types'
      path: '/projector-types'
      fullPath: '/assets/projector-types'
      preLoaderRoute: typeof LayoutAssetsProjectorTypesRouteImport
      parentRoute: typeof LayoutAssetsRouteRoute
    }
    '/_layout/assets/printers': {
      id: '/_layout/assets/printers'
      path: '/printers'
      fullPath: '/assets/printers'
      preLoaderRoute: typeof LayoutAssetsPrintersRouteImport
      parentRoute: typeof LayoutAssetsRouteRoute
    }
    '/_layout/assets/monitors': {
      id: '/_layout/assets/monitors'
      path: '/monitors'
      fullPath: '/assets/monitors'
      preLoaderRoute: typeof LayoutAssetsMonitorsRouteImport
      parentRoute: typeof LayoutAssetsRouteRoute
    }
    '/_layout/assets/computers': {
      id: '/_layout/assets/computers'
      path: '/computers'
      fullPath: '/assets/computers'
      preLoaderRoute: typeof LayoutAssetsComputersRouteImport
      parentRoute: typeof LayoutAssetsRouteRoute
    }
    '/_layout/assets/card-printer': {
      id: '/_layout/assets/card-printer'
      path: '/card-printer'
      fullPath: '/assets/card-printer'
      preLoaderRoute: typeof LayoutAssetsCardPrinterRouteImport
      parentRoute: typeof LayoutAssetsRouteRoute
    }
    '/_layout/admin/teams-app-installations': {
      id: '/_layout/admin/teams-app-installations'
      path: '/teams-app-installations'
      fullPath: '/admin/teams-app-installations'
      preLoaderRoute: typeof LayoutAdminTeamsAppInstallationsRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/admin/student-lists': {
      id: '/_layout/admin/student-lists'
      path: '/student-lists'
      fullPath: '/admin/student-lists'
      preLoaderRoute: typeof LayoutAdminStudentListsRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/admin/roles': {
      id: '/_layout/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof LayoutAdminRolesRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/admin/permissions': {
      id: '/_layout/admin/permissions'
      path: '/permissions'
      fullPath: '/admin/permissions'
      preLoaderRoute: typeof LayoutAdminPermissionsRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/admin/connected-users': {
      id: '/_layout/admin/connected-users'
      path: '/connected-users'
      fullPath: '/admin/connected-users'
      preLoaderRoute: typeof LayoutAdminConnectedUsersRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/admin/calendar': {
      id: '/_layout/admin/calendar'
      path: '/calendar'
      fullPath: '/admin/calendar'
      preLoaderRoute: typeof LayoutAdminCalendarRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/admin/banners': {
      id: '/_layout/admin/banners'
      path: '/banners'
      fullPath: '/admin/banners'
      preLoaderRoute: typeof LayoutAdminBannersRouteImport
      parentRoute: typeof LayoutAdminRouteRoute
    }
    '/_layout/_teacher-portal/watchlists': {
      id: '/_layout/_teacher-portal/watchlists'
      path: '/watchlists'
      fullPath: '/watchlists'
      preLoaderRoute: typeof LayoutTeacherPortalWatchlistsRouteImport
      parentRoute: typeof LayoutTeacherPortalRouteRoute
    }
    '/_layout/_teacher-portal/courses': {
      id: '/_layout/_teacher-portal/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof LayoutTeacherPortalCoursesRouteImport
      parentRoute: typeof LayoutTeacherPortalRouteRoute
    }
    '/_layout/_teacher-portal/action-plans': {
      id: '/_layout/_teacher-portal/action-plans'
      path: '/action-plans'
      fullPath: '/action-plans'
      preLoaderRoute: typeof LayoutTeacherPortalActionPlansRouteImport
      parentRoute: typeof LayoutTeacherPortalRouteRoute
    }
    '/_layout/tools/teams-administration': {
      id: '/_layout/tools/teams-administration'
      path: '/teams-administration'
      fullPath: '/tools/teams-administration'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationRouteRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    '/_layout/students/$studentNo': {
      id: '/_layout/students/$studentNo'
      path: '/$studentNo'
      fullPath: '/students/$studentNo'
      preLoaderRoute: typeof LayoutStudentsStudentNoRouteRouteImport
      parentRoute: typeof LayoutStudentsRouteRoute
    }
    '/_layout/staff/$initials': {
      id: '/_layout/staff/$initials'
      path: '/$initials'
      fullPath: '/staff/$initials'
      preLoaderRoute: typeof LayoutStaffInitialsRouteRouteImport
      parentRoute: typeof LayoutStaffRouteRoute
    }
    '/_layout/referrals/wellbeing': {
      id: '/_layout/referrals/wellbeing'
      path: '/wellbeing'
      fullPath: '/referrals/wellbeing'
      preLoaderRoute: typeof LayoutReferralsWellbeingRouteRouteImport
      parentRoute: typeof LayoutReferralsRouteRoute
    }
    '/_layout/parents/$parentId': {
      id: '/_layout/parents/$parentId'
      path: '/$parentId'
      fullPath: '/parents/$parentId'
      preLoaderRoute: typeof LayoutParentsParentIdRouteRouteImport
      parentRoute: typeof LayoutParentsRouteRoute
    }
    '/_layout/communication/notifications': {
      id: '/_layout/communication/notifications'
      path: '/notifications'
      fullPath: '/communication/notifications'
      preLoaderRoute: typeof LayoutCommunicationNotificationsRouteRouteImport
      parentRoute: typeof LayoutCommunicationRouteRoute
    }
    '/_layout/calendar/events': {
      id: '/_layout/calendar/events'
      path: '/events'
      fullPath: '/calendar/events'
      preLoaderRoute: typeof LayoutCalendarEventsRouteRouteImport
      parentRoute: typeof LayoutCalendarRouteRoute
    }
    '/_layout/_teacher-portal/groups': {
      id: '/_layout/_teacher-portal/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalRouteRoute
    }
    '/_layout/tools/teams-administration/': {
      id: '/_layout/tools/teams-administration/'
      path: '/'
      fullPath: '/tools/teams-administration/'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationIndexRouteImport
      parentRoute: typeof LayoutToolsTeamsAdministrationRouteRoute
    }
    '/_layout/students/$studentNo/': {
      id: '/_layout/students/$studentNo/'
      path: '/'
      fullPath: '/students/$studentNo/'
      preLoaderRoute: typeof LayoutStudentsStudentNoIndexRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/staff/$initials/': {
      id: '/_layout/staff/$initials/'
      path: '/'
      fullPath: '/staff/$initials/'
      preLoaderRoute: typeof LayoutStaffInitialsIndexRouteImport
      parentRoute: typeof LayoutStaffInitialsRouteRoute
    }
    '/_layout/referrals/wellbeing/': {
      id: '/_layout/referrals/wellbeing/'
      path: '/'
      fullPath: '/referrals/wellbeing/'
      preLoaderRoute: typeof LayoutReferralsWellbeingIndexRouteImport
      parentRoute: typeof LayoutReferralsWellbeingRouteRoute
    }
    '/_layout/parents/$parentId/': {
      id: '/_layout/parents/$parentId/'
      path: '/'
      fullPath: '/parents/$parentId/'
      preLoaderRoute: typeof LayoutParentsParentIdIndexRouteImport
      parentRoute: typeof LayoutParentsParentIdRouteRoute
    }
    '/_layout/assets/card-printer/': {
      id: '/_layout/assets/card-printer/'
      path: '/'
      fullPath: '/assets/card-printer/'
      preLoaderRoute: typeof LayoutAssetsCardPrinterIndexRouteImport
      parentRoute: typeof LayoutAssetsCardPrinterRoute
    }
    '/_layout/timetables/$type/$identifier': {
      id: '/_layout/timetables/$type/$identifier'
      path: '/$identifier'
      fullPath: '/timetables/$type/$identifier'
      preLoaderRoute: typeof LayoutTimetablesTypeIdentifierRouteImport
      parentRoute: typeof LayoutTimetablesTypeRoute
    }
    '/_layout/students/$studentNo/timetable': {
      id: '/_layout/students/$studentNo/timetable'
      path: '/timetable'
      fullPath: '/students/$studentNo/timetable'
      preLoaderRoute: typeof LayoutStudentsStudentNoTimetableRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/support': {
      id: '/_layout/students/$studentNo/support'
      path: '/support'
      fullPath: '/students/$studentNo/support'
      preLoaderRoute: typeof LayoutStudentsStudentNoSupportRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/summary': {
      id: '/_layout/students/$studentNo/summary'
      path: '/summary'
      fullPath: '/students/$studentNo/summary'
      preLoaderRoute: typeof LayoutStudentsStudentNoSummaryRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/student-agreements': {
      id: '/_layout/students/$studentNo/student-agreements'
      path: '/student-agreements'
      fullPath: '/students/$studentNo/student-agreements'
      preLoaderRoute: typeof LayoutStudentsStudentNoStudentAgreementsRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/reviews': {
      id: '/_layout/students/$studentNo/reviews'
      path: '/reviews'
      fullPath: '/students/$studentNo/reviews'
      preLoaderRoute: typeof LayoutStudentsStudentNoReviewsRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/photo': {
      id: '/_layout/students/$studentNo/photo'
      path: '/photo'
      fullPath: '/students/$studentNo/photo'
      preLoaderRoute: typeof LayoutStudentsStudentNoPhotoRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/parents': {
      id: '/_layout/students/$studentNo/parents'
      path: '/parents'
      fullPath: '/students/$studentNo/parents'
      preLoaderRoute: typeof LayoutStudentsStudentNoParentsRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/markbook': {
      id: '/_layout/students/$studentNo/markbook'
      path: '/markbook'
      fullPath: '/students/$studentNo/markbook'
      preLoaderRoute: typeof LayoutStudentsStudentNoMarkbookRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/gcse': {
      id: '/_layout/students/$studentNo/gcse'
      path: '/gcse'
      fullPath: '/students/$studentNo/gcse'
      preLoaderRoute: typeof LayoutStudentsStudentNoGcseRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/documents': {
      id: '/_layout/students/$studentNo/documents'
      path: '/documents'
      fullPath: '/students/$studentNo/documents'
      preLoaderRoute: typeof LayoutStudentsStudentNoDocumentsRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/details': {
      id: '/_layout/students/$studentNo/details'
      path: '/details'
      fullPath: '/students/$studentNo/details'
      preLoaderRoute: typeof LayoutStudentsStudentNoDetailsRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/staff/$initials/timetable': {
      id: '/_layout/staff/$initials/timetable'
      path: '/timetable'
      fullPath: '/staff/$initials/timetable'
      preLoaderRoute: typeof LayoutStaffInitialsTimetableRouteImport
      parentRoute: typeof LayoutStaffInitialsRouteRoute
    }
    '/_layout/staff/$initials/roles': {
      id: '/_layout/staff/$initials/roles'
      path: '/roles'
      fullPath: '/staff/$initials/roles'
      preLoaderRoute: typeof LayoutStaffInitialsRolesRouteImport
      parentRoute: typeof LayoutStaffInitialsRouteRoute
    }
    '/_layout/staff/$initials/photo': {
      id: '/_layout/staff/$initials/photo'
      path: '/photo'
      fullPath: '/staff/$initials/photo'
      preLoaderRoute: typeof LayoutStaffInitialsPhotoRouteImport
      parentRoute: typeof LayoutStaffInitialsRouteRoute
    }
    '/_layout/reports/sar/pastoral': {
      id: '/_layout/reports/sar/pastoral'
      path: '/sar/pastoral'
      fullPath: '/reports/sar/pastoral'
      preLoaderRoute: typeof LayoutReportsSarPastoralRouteImport
      parentRoute: typeof LayoutReportsRouteRoute
    }
    '/_layout/reports/sar/curriculum': {
      id: '/_layout/reports/sar/curriculum'
      path: '/sar/curriculum'
      fullPath: '/reports/sar/curriculum'
      preLoaderRoute: typeof LayoutReportsSarCurriculumRouteImport
      parentRoute: typeof LayoutReportsRouteRoute
    }
    '/_layout/referrals/wellbeing/my': {
      id: '/_layout/referrals/wellbeing/my'
      path: '/my'
      fullPath: '/referrals/wellbeing/my'
      preLoaderRoute: typeof LayoutReferralsWellbeingMyRouteImport
      parentRoute: typeof LayoutReferralsWellbeingRouteRoute
    }
    '/_layout/referrals/wellbeing/create': {
      id: '/_layout/referrals/wellbeing/create'
      path: '/create'
      fullPath: '/referrals/wellbeing/create'
      preLoaderRoute: typeof LayoutReferralsWellbeingCreateRouteImport
      parentRoute: typeof LayoutReferralsWellbeingRouteRoute
    }
    '/_layout/referrals/wellbeing/assigned': {
      id: '/_layout/referrals/wellbeing/assigned'
      path: '/assigned'
      fullPath: '/referrals/wellbeing/assigned'
      preLoaderRoute: typeof LayoutReferralsWellbeingAssignedRouteImport
      parentRoute: typeof LayoutReferralsWellbeingRouteRoute
    }
    '/_layout/parents/$parentId/contact-info': {
      id: '/_layout/parents/$parentId/contact-info'
      path: '/contact-info'
      fullPath: '/parents/$parentId/contact-info'
      preLoaderRoute: typeof LayoutParentsParentIdContactInfoRouteImport
      parentRoute: typeof LayoutParentsParentIdRouteRoute
    }
    '/_layout/communication/notifications/teams-notifications': {
      id: '/_layout/communication/notifications/teams-notifications'
      path: '/teams-notifications'
      fullPath: '/communication/notifications/teams-notifications'
      preLoaderRoute: typeof LayoutCommunicationNotificationsTeamsNotificationsRouteImport
      parentRoute: typeof LayoutCommunicationNotificationsRouteRoute
    }
    '/_layout/communication/notifications/portal-notifications': {
      id: '/_layout/communication/notifications/portal-notifications'
      path: '/portal-notifications'
      fullPath: '/communication/notifications/portal-notifications'
      preLoaderRoute: typeof LayoutCommunicationNotificationsPortalNotificationsRouteImport
      parentRoute: typeof LayoutCommunicationNotificationsRouteRoute
    }
    '/_layout/calendar/events/new': {
      id: '/_layout/calendar/events/new'
      path: '/new'
      fullPath: '/calendar/events/new'
      preLoaderRoute: typeof LayoutCalendarEventsNewRouteImport
      parentRoute: typeof LayoutCalendarEventsRouteRoute
    }
    '/_layout/calendar/events/$eventId': {
      id: '/_layout/calendar/events/$eventId'
      path: '/$eventId'
      fullPath: '/calendar/events/$eventId'
      preLoaderRoute: typeof LayoutCalendarEventsEventIdRouteImport
      parentRoute: typeof LayoutCalendarEventsRouteRoute
    }
    '/_layout/assets/card-printer/printers': {
      id: '/_layout/assets/card-printer/printers'
      path: '/printers'
      fullPath: '/assets/card-printer/printers'
      preLoaderRoute: typeof LayoutAssetsCardPrinterPrintersRouteImport
      parentRoute: typeof LayoutAssetsCardPrinterRoute
    }
    '/_layout/assets/card-printer/printed-cards': {
      id: '/_layout/assets/card-printer/printed-cards'
      path: '/printed-cards'
      fullPath: '/assets/card-printer/printed-cards'
      preLoaderRoute: typeof LayoutAssetsCardPrinterPrintedCardsRouteImport
      parentRoute: typeof LayoutAssetsCardPrinterRoute
    }
    '/_layout/assets/card-printer/print-jobs': {
      id: '/_layout/assets/card-printer/print-jobs'
      path: '/print-jobs'
      fullPath: '/assets/card-printer/print-jobs'
      preLoaderRoute: typeof LayoutAssetsCardPrinterPrintJobsRouteImport
      parentRoute: typeof LayoutAssetsCardPrinterRoute
    }
    '/_layout/tools/teams-administration/teams': {
      id: '/_layout/tools/teams-administration/teams'
      path: '/teams'
      fullPath: '/tools/teams-administration/teams'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationTeamsRouteRouteImport
      parentRoute: typeof LayoutToolsTeamsAdministrationRouteRoute
    }
    '/_layout/students/$studentNo/conversations': {
      id: '/_layout/students/$studentNo/conversations'
      path: '/conversations'
      fullPath: '/students/$studentNo/conversations'
      preLoaderRoute: typeof LayoutStudentsStudentNoConversationsRouteRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/attendance': {
      id: '/_layout/students/$studentNo/attendance'
      path: '/attendance'
      fullPath: '/students/$studentNo/attendance'
      preLoaderRoute: typeof LayoutStudentsStudentNoAttendanceRouteRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/students/$studentNo/action-plans': {
      id: '/_layout/students/$studentNo/action-plans'
      path: '/action-plans'
      fullPath: '/students/$studentNo/action-plans'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansRouteRouteImport
      parentRoute: typeof LayoutStudentsStudentNoRouteRoute
    }
    '/_layout/referrals/wellbeing/manage': {
      id: '/_layout/referrals/wellbeing/manage'
      path: '/manage'
      fullPath: '/referrals/wellbeing/manage'
      preLoaderRoute: typeof LayoutReferralsWellbeingManageRouteRouteImport
      parentRoute: typeof LayoutReferralsWellbeingRouteRoute
    }
    '/_layout/cars/student/$carId': {
      id: '/_layout/cars/student/$carId'
      path: '/student/$carId'
      fullPath: '/cars/student/$carId'
      preLoaderRoute: typeof LayoutCarsStudentCarIdRouteRouteImport
      parentRoute: typeof LayoutCarsRouteRoute
    }
    '/_layout/cars/staff/$carId': {
      id: '/_layout/cars/staff/$carId'
      path: '/staff/$carId'
      fullPath: '/cars/staff/$carId'
      preLoaderRoute: typeof LayoutCarsStaffCarIdRouteRouteImport
      parentRoute: typeof LayoutCarsRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes': {
      id: '/_layout/_teacher-portal/groups/classes'
      path: '/classes'
      fullPath: '/groups/classes'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/tools/teams-administration/teams/': {
      id: '/_layout/tools/teams-administration/teams/'
      path: '/'
      fullPath: '/tools/teams-administration/teams/'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationTeamsIndexRouteImport
      parentRoute: typeof LayoutToolsTeamsAdministrationTeamsRouteRoute
    }
    '/_layout/students/$studentNo/conversations/': {
      id: '/_layout/students/$studentNo/conversations/'
      path: '/'
      fullPath: '/students/$studentNo/conversations/'
      preLoaderRoute: typeof LayoutStudentsStudentNoConversationsIndexRouteImport
      parentRoute: typeof LayoutStudentsStudentNoConversationsRouteRoute
    }
    '/_layout/students/$studentNo/attendance/': {
      id: '/_layout/students/$studentNo/attendance/'
      path: '/'
      fullPath: '/students/$studentNo/attendance/'
      preLoaderRoute: typeof LayoutStudentsStudentNoAttendanceIndexRouteImport
      parentRoute: typeof LayoutStudentsStudentNoAttendanceRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/': {
      id: '/_layout/students/$studentNo/action-plans/'
      path: '/'
      fullPath: '/students/$studentNo/action-plans/'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansIndexRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansRouteRoute
    }
    '/_layout/cars/student/$carId/': {
      id: '/_layout/cars/student/$carId/'
      path: '/'
      fullPath: '/cars/student/$carId/'
      preLoaderRoute: typeof LayoutCarsStudentCarIdIndexRouteImport
      parentRoute: typeof LayoutCarsStudentCarIdRouteRoute
    }
    '/_layout/cars/staff/$carId/': {
      id: '/_layout/cars/staff/$carId/'
      path: '/'
      fullPath: '/cars/staff/$carId/'
      preLoaderRoute: typeof LayoutCarsStaffCarIdIndexRouteImport
      parentRoute: typeof LayoutCarsStaffCarIdRouteRoute
    }
    '/_layout/students/$studentNo/conversations/$conversationId': {
      id: '/_layout/students/$studentNo/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/students/$studentNo/conversations/$conversationId'
      preLoaderRoute: typeof LayoutStudentsStudentNoConversationsConversationIdRouteImport
      parentRoute: typeof LayoutStudentsStudentNoConversationsRouteRoute
    }
    '/_layout/students/$studentNo/attendance/punctuality': {
      id: '/_layout/students/$studentNo/attendance/punctuality'
      path: '/punctuality'
      fullPath: '/students/$studentNo/attendance/punctuality'
      preLoaderRoute: typeof LayoutStudentsStudentNoAttendancePunctualityRouteImport
      parentRoute: typeof LayoutStudentsStudentNoAttendanceRouteRoute
    }
    '/_layout/students/$studentNo/attendance/absences': {
      id: '/_layout/students/$studentNo/attendance/absences'
      path: '/absences'
      fullPath: '/students/$studentNo/attendance/absences'
      preLoaderRoute: typeof LayoutStudentsStudentNoAttendanceAbsencesRouteImport
      parentRoute: typeof LayoutStudentsStudentNoAttendanceRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/referrals': {
      id: '/_layout/students/$studentNo/action-plans/referrals'
      path: '/referrals'
      fullPath: '/students/$studentNo/action-plans/referrals'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansReferralsRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansRouteRoute
    }
    '/_layout/referrals/wellbeing/my/$referralId': {
      id: '/_layout/referrals/wellbeing/my/$referralId'
      path: '/$referralId'
      fullPath: '/referrals/wellbeing/my/$referralId'
      preLoaderRoute: typeof LayoutReferralsWellbeingMyReferralIdRouteImport
      parentRoute: typeof LayoutReferralsWellbeingMyRoute
    }
    '/_layout/referrals/wellbeing/manage/$referralId': {
      id: '/_layout/referrals/wellbeing/manage/$referralId'
      path: '/$referralId'
      fullPath: '/referrals/wellbeing/manage/$referralId'
      preLoaderRoute: typeof LayoutReferralsWellbeingManageReferralIdRouteImport
      parentRoute: typeof LayoutReferralsWellbeingManageRouteRoute
    }
    '/_layout/referrals/wellbeing/assigned/$category': {
      id: '/_layout/referrals/wellbeing/assigned/$category'
      path: '/$category'
      fullPath: '/referrals/wellbeing/assigned/$category'
      preLoaderRoute: typeof LayoutReferralsWellbeingAssignedCategoryRouteImport
      parentRoute: typeof LayoutReferralsWellbeingAssignedRoute
    }
    '/_layout/cars/student/$carId/dvla': {
      id: '/_layout/cars/student/$carId/dvla'
      path: '/dvla'
      fullPath: '/cars/student/$carId/dvla'
      preLoaderRoute: typeof LayoutCarsStudentCarIdDvlaRouteImport
      parentRoute: typeof LayoutCarsStudentCarIdRouteRoute
    }
    '/_layout/cars/staff/$carId/dvla': {
      id: '/_layout/cars/staff/$carId/dvla'
      path: '/dvla'
      fullPath: '/cars/staff/$carId/dvla'
      preLoaderRoute: typeof LayoutCarsStaffCarIdDvlaRouteImport
      parentRoute: typeof LayoutCarsStaffCarIdRouteRoute
    }
    '/_layout/calendar/events_/$eventId/edit': {
      id: '/_layout/calendar/events_/$eventId/edit'
      path: '/events/$eventId/edit'
      fullPath: '/calendar/events/$eventId/edit'
      preLoaderRoute: typeof LayoutCalendarEventsEventIdEditRouteImport
      parentRoute: typeof LayoutCalendarRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/college': {
      id: '/_layout/_teacher-portal/groups/my/college'
      path: '/my/college'
      fullPath: '/groups/my/college'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyCollegeRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/classes': {
      id: '/_layout/_teacher-portal/groups/my/classes'
      path: '/my/classes'
      fullPath: '/groups/my/classes'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyClassesRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/all/subjects': {
      id: '/_layout/_teacher-portal/groups/all/subjects'
      path: '/all/subjects'
      fullPath: '/groups/all/subjects'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsAllSubjectsRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/all/faculties': {
      id: '/_layout/_teacher-portal/groups/all/faculties'
      path: '/all/faculties'
      fullPath: '/groups/all/faculties'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsAllFacultiesRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/all/departments': {
      id: '/_layout/_teacher-portal/groups/all/departments'
      path: '/all/departments'
      fullPath: '/groups/all/departments'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsAllDepartmentsRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/all/courses': {
      id: '/_layout/_teacher-portal/groups/all/courses'
      path: '/all/courses'
      fullPath: '/groups/all/courses'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsAllCoursesRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/all/classes': {
      id: '/_layout/_teacher-portal/groups/all/classes'
      path: '/all/classes'
      fullPath: '/groups/all/classes'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsAllClassesRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/tools/teams-administration/teams/$teamId': {
      id: '/_layout/tools/teams-administration/teams/$teamId'
      path: '/$teamId'
      fullPath: '/tools/teams-administration/teams/$teamId'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteImport
      parentRoute: typeof LayoutToolsTeamsAdministrationTeamsRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/academic-support': {
      id: '/_layout/students/$studentNo/action-plans/academic-support'
      path: '/academic-support'
      fullPath: '/students/$studentNo/action-plans/academic-support'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/$type': {
      id: '/_layout/students/$studentNo/action-plans/$type'
      path: '/$type'
      fullPath: '/students/$studentNo/action-plans/$type'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansTypeRouteRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty': {
      id: '/_layout/_teacher-portal/groups/my/faculty'
      path: '/my/faculty'
      fullPath: '/groups/my/faculty'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/department': {
      id: '/_layout/_teacher-portal/groups/my/department'
      path: '/my/department'
      fullPath: '/groups/my/department'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyDepartmentRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId': {
      id: '/_layout/_teacher-portal/groups/classes/$classId'
      path: '/$classId'
      fullPath: '/groups/classes/$classId'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesRouteRoute
    }
    '/_layout/tools/teams-administration/teams/$teamId/': {
      id: '/_layout/tools/teams-administration/teams/$teamId/'
      path: '/'
      fullPath: '/tools/teams-administration/teams/$teamId/'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdIndexRouteImport
      parentRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/academic-support/': {
      id: '/_layout/students/$studentNo/action-plans/academic-support/'
      path: '/'
      fullPath: '/students/$studentNo/action-plans/academic-support/'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportIndexRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/$type/': {
      id: '/_layout/students/$studentNo/action-plans/$type/'
      path: '/'
      fullPath: '/students/$studentNo/action-plans/$type/'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansTypeIndexRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansTypeRouteRoute
    }
    '/_layout/_teacher-portal/groups/subject/$subjectId/': {
      id: '/_layout/_teacher-portal/groups/subject/$subjectId/'
      path: '/subject/$subjectId'
      fullPath: '/groups/subject/$subjectId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsSubjectSubjectIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/': {
      id: '/_layout/_teacher-portal/groups/my/faculty/'
      path: '/'
      fullPath: '/groups/my/faculty/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/department/': {
      id: '/_layout/_teacher-portal/groups/my/department/'
      path: '/'
      fullPath: '/groups/my/department/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyDepartmentIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyDepartmentRouteRoute
    }
    '/_layout/_teacher-portal/groups/faculty/$facultyId/': {
      id: '/_layout/_teacher-portal/groups/faculty/$facultyId/'
      path: '/faculty/$facultyId'
      fullPath: '/groups/faculty/$facultyId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsFacultyFacultyIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/department/$departmentId/': {
      id: '/_layout/_teacher-portal/groups/department/$departmentId/'
      path: '/department/$departmentId'
      fullPath: '/groups/department/$departmentId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/course/$courseId/': {
      id: '/_layout/_teacher-portal/groups/course/$courseId/'
      path: '/course/$courseId'
      fullPath: '/groups/course/$courseId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsCourseCourseIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/'
      path: '/'
      fullPath: '/groups/classes/$classId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug': {
      id: '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug'
      path: '/$subjectSlug'
      fullPath: '/students/$studentNo/action-plans/academic-support/$subjectSlug'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute
    }
    '/_layout/referrals/wellbeing/assigned/$category/$assignmentId': {
      id: '/_layout/referrals/wellbeing/assigned/$category/$assignmentId'
      path: '/$assignmentId'
      fullPath: '/referrals/wellbeing/assigned/$category/$assignmentId'
      preLoaderRoute: typeof LayoutReferralsWellbeingAssignedCategoryAssignmentIdRouteImport
      parentRoute: typeof LayoutReferralsWellbeingAssignedCategoryRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/support': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/support'
      path: '/support'
      fullPath: '/groups/classes/$classId/support'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdSupportRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/references': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/references'
      path: '/references'
      fullPath: '/groups/classes/$classId/references'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdReferencesRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/orbit': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/orbit'
      path: '/orbit'
      fullPath: '/groups/classes/$classId/orbit'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdOrbitRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/gallery': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/gallery'
      path: '/gallery'
      fullPath: '/groups/classes/$classId/gallery'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdGalleryRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/classroom-adjustments': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/classroom-adjustments'
      path: '/classroom-adjustments'
      fullPath: '/groups/classes/$classId/classroom-adjustments'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/attendance': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/attendance'
      path: '/attendance'
      fullPath: '/groups/classes/$classId/attendance'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdAttendanceRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/classes/$classId/access-arrangements': {
      id: '/_layout/_teacher-portal/groups/classes/$classId/access-arrangements'
      path: '/access-arrangements'
      fullPath: '/groups/classes/$classId/access-arrangements'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/$departmentId': {
      id: '/_layout/_teacher-portal/groups/my/faculty/$departmentId'
      path: '/$departmentId'
      fullPath: '/groups/my/faculty/$departmentId'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/department/$subjectId': {
      id: '/_layout/_teacher-portal/groups/my/department/$subjectId'
      path: '/$subjectId'
      fullPath: '/groups/my/department/$subjectId'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyDepartmentRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/$departmentId/': {
      id: '/_layout/_teacher-portal/groups/my/faculty/$departmentId/'
      path: '/'
      fullPath: '/groups/my/faculty/$departmentId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/department/$subjectId/': {
      id: '/_layout/_teacher-portal/groups/my/department/$subjectId/'
      path: '/'
      fullPath: '/groups/my/department/$subjectId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute
    }
    '/_layout/tools/teams-administration/teams/$teamId/channels/$channelId': {
      id: '/_layout/tools/teams-administration/teams/$teamId/channels/$channelId'
      path: '/channels/$channelId'
      fullPath: '/tools/teams-administration/teams/$teamId/channels/$channelId'
      preLoaderRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRouteImport
      parentRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId': {
      id: '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId'
      path: '/$subjectId'
      fullPath: '/groups/my/faculty/$departmentId/$subjectId'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId': {
      id: '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId'
      path: '/$courseId'
      fullPath: '/groups/my/department/$subjectId/$courseId'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/': {
      id: '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/'
      path: '/'
      fullPath: '/groups/my/faculty/$departmentId/$subjectId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId/': {
      id: '/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId/'
      path: '/'
      fullPath: '/groups/my/department/$subjectId/$courseId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRoute
    }
    '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId': {
      id: '/_layout/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId'
      path: '/target/$targetId'
      fullPath: '/students/$studentNo/action-plans/academic-support/$subjectSlug/target/$targetId'
      preLoaderRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRouteImport
      parentRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId': {
      id: '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId'
      path: '/$courseId'
      fullPath: '/groups/my/faculty/$departmentId/$subjectId/$courseId'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute
    }
    '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/': {
      id: '/_layout/_teacher-portal/groups/my/faculty/$departmentId/$subjectId/$courseId/'
      path: '/'
      fullPath: '/groups/my/faculty/$departmentId/$subjectId/$courseId/'
      preLoaderRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRouteImport
      parentRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRoute
    }
  }
}

interface LayoutTeacherPortalGroupsClassesClassIdRouteRouteChildren {
  LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute: typeof LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute
  LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute: typeof LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute
  LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute: typeof LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute
  LayoutTeacherPortalGroupsClassesClassIdGalleryRoute: typeof LayoutTeacherPortalGroupsClassesClassIdGalleryRoute
  LayoutTeacherPortalGroupsClassesClassIdOrbitRoute: typeof LayoutTeacherPortalGroupsClassesClassIdOrbitRoute
  LayoutTeacherPortalGroupsClassesClassIdReferencesRoute: typeof LayoutTeacherPortalGroupsClassesClassIdReferencesRoute
  LayoutTeacherPortalGroupsClassesClassIdSupportRoute: typeof LayoutTeacherPortalGroupsClassesClassIdSupportRoute
  LayoutTeacherPortalGroupsClassesClassIdIndexRoute: typeof LayoutTeacherPortalGroupsClassesClassIdIndexRoute
}

const LayoutTeacherPortalGroupsClassesClassIdRouteRouteChildren: LayoutTeacherPortalGroupsClassesClassIdRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute:
      LayoutTeacherPortalGroupsClassesClassIdAccessArrangementsRoute,
    LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute:
      LayoutTeacherPortalGroupsClassesClassIdAttendanceRoute,
    LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute:
      LayoutTeacherPortalGroupsClassesClassIdClassroomAdjustmentsRoute,
    LayoutTeacherPortalGroupsClassesClassIdGalleryRoute:
      LayoutTeacherPortalGroupsClassesClassIdGalleryRoute,
    LayoutTeacherPortalGroupsClassesClassIdOrbitRoute:
      LayoutTeacherPortalGroupsClassesClassIdOrbitRoute,
    LayoutTeacherPortalGroupsClassesClassIdReferencesRoute:
      LayoutTeacherPortalGroupsClassesClassIdReferencesRoute,
    LayoutTeacherPortalGroupsClassesClassIdSupportRoute:
      LayoutTeacherPortalGroupsClassesClassIdSupportRoute,
    LayoutTeacherPortalGroupsClassesClassIdIndexRoute:
      LayoutTeacherPortalGroupsClassesClassIdIndexRoute,
  }

const LayoutTeacherPortalGroupsClassesClassIdRouteRouteWithChildren =
  LayoutTeacherPortalGroupsClassesClassIdRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsClassesClassIdRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsClassesRouteRouteChildren {
  LayoutTeacherPortalGroupsClassesClassIdRouteRoute: typeof LayoutTeacherPortalGroupsClassesClassIdRouteRouteWithChildren
}

const LayoutTeacherPortalGroupsClassesRouteRouteChildren: LayoutTeacherPortalGroupsClassesRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsClassesClassIdRouteRoute:
      LayoutTeacherPortalGroupsClassesClassIdRouteRouteWithChildren,
  }

const LayoutTeacherPortalGroupsClassesRouteRouteWithChildren =
  LayoutTeacherPortalGroupsClassesRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsClassesRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteChildren {
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute
}

const LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteChildren: LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute:
      LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdIndexRoute,
  }

const LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteChildren {
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute
}

const LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteChildren: LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRoute:
      LayoutTeacherPortalGroupsMyDepartmentSubjectIdCourseIdRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute:
      LayoutTeacherPortalGroupsMyDepartmentSubjectIdIndexRoute,
  }

const LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyDepartmentRouteRouteChildren {
  LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute: typeof LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyDepartmentIndexRoute: typeof LayoutTeacherPortalGroupsMyDepartmentIndexRoute
}

const LayoutTeacherPortalGroupsMyDepartmentRouteRouteChildren: LayoutTeacherPortalGroupsMyDepartmentRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRoute:
      LayoutTeacherPortalGroupsMyDepartmentSubjectIdRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyDepartmentIndexRoute:
      LayoutTeacherPortalGroupsMyDepartmentIndexRoute,
  }

const LayoutTeacherPortalGroupsMyDepartmentRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyDepartmentRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyDepartmentRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteChildren {
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute
}

const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteChildren: LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute:
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdIndexRoute,
  }

const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteChildren {
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute
}

const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteChildren: LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRoute:
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdCourseIdRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute:
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdIndexRoute,
  }

const LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteChildren {
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute
}

const LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteChildren: LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRoute:
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdSubjectIdRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute:
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdIndexRoute,
  }

const LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsMyFacultyRouteRouteChildren {
  LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute: typeof LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyFacultyIndexRoute: typeof LayoutTeacherPortalGroupsMyFacultyIndexRoute
}

const LayoutTeacherPortalGroupsMyFacultyRouteRouteChildren: LayoutTeacherPortalGroupsMyFacultyRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRoute:
      LayoutTeacherPortalGroupsMyFacultyDepartmentIdRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyFacultyIndexRoute:
      LayoutTeacherPortalGroupsMyFacultyIndexRoute,
  }

const LayoutTeacherPortalGroupsMyFacultyRouteRouteWithChildren =
  LayoutTeacherPortalGroupsMyFacultyRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsMyFacultyRouteRouteChildren,
  )

interface LayoutTeacherPortalGroupsRouteRouteChildren {
  LayoutTeacherPortalGroupsClassesRouteRoute: typeof LayoutTeacherPortalGroupsClassesRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyDepartmentRouteRoute: typeof LayoutTeacherPortalGroupsMyDepartmentRouteRouteWithChildren
  LayoutTeacherPortalGroupsMyFacultyRouteRoute: typeof LayoutTeacherPortalGroupsMyFacultyRouteRouteWithChildren
  LayoutTeacherPortalGroupsAllClassesRoute: typeof LayoutTeacherPortalGroupsAllClassesRoute
  LayoutTeacherPortalGroupsAllCoursesRoute: typeof LayoutTeacherPortalGroupsAllCoursesRoute
  LayoutTeacherPortalGroupsAllDepartmentsRoute: typeof LayoutTeacherPortalGroupsAllDepartmentsRoute
  LayoutTeacherPortalGroupsAllFacultiesRoute: typeof LayoutTeacherPortalGroupsAllFacultiesRoute
  LayoutTeacherPortalGroupsAllSubjectsRoute: typeof LayoutTeacherPortalGroupsAllSubjectsRoute
  LayoutTeacherPortalGroupsMyClassesRoute: typeof LayoutTeacherPortalGroupsMyClassesRoute
  LayoutTeacherPortalGroupsMyCollegeRoute: typeof LayoutTeacherPortalGroupsMyCollegeRoute
  LayoutTeacherPortalGroupsCourseCourseIdIndexRoute: typeof LayoutTeacherPortalGroupsCourseCourseIdIndexRoute
  LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute: typeof LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute
  LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute: typeof LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute
  LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute: typeof LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute
}

const LayoutTeacherPortalGroupsRouteRouteChildren: LayoutTeacherPortalGroupsRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsClassesRouteRoute:
      LayoutTeacherPortalGroupsClassesRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyDepartmentRouteRoute:
      LayoutTeacherPortalGroupsMyDepartmentRouteRouteWithChildren,
    LayoutTeacherPortalGroupsMyFacultyRouteRoute:
      LayoutTeacherPortalGroupsMyFacultyRouteRouteWithChildren,
    LayoutTeacherPortalGroupsAllClassesRoute:
      LayoutTeacherPortalGroupsAllClassesRoute,
    LayoutTeacherPortalGroupsAllCoursesRoute:
      LayoutTeacherPortalGroupsAllCoursesRoute,
    LayoutTeacherPortalGroupsAllDepartmentsRoute:
      LayoutTeacherPortalGroupsAllDepartmentsRoute,
    LayoutTeacherPortalGroupsAllFacultiesRoute:
      LayoutTeacherPortalGroupsAllFacultiesRoute,
    LayoutTeacherPortalGroupsAllSubjectsRoute:
      LayoutTeacherPortalGroupsAllSubjectsRoute,
    LayoutTeacherPortalGroupsMyClassesRoute:
      LayoutTeacherPortalGroupsMyClassesRoute,
    LayoutTeacherPortalGroupsMyCollegeRoute:
      LayoutTeacherPortalGroupsMyCollegeRoute,
    LayoutTeacherPortalGroupsCourseCourseIdIndexRoute:
      LayoutTeacherPortalGroupsCourseCourseIdIndexRoute,
    LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute:
      LayoutTeacherPortalGroupsDepartmentDepartmentIdIndexRoute,
    LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute:
      LayoutTeacherPortalGroupsFacultyFacultyIdIndexRoute,
    LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute:
      LayoutTeacherPortalGroupsSubjectSubjectIdIndexRoute,
  }

const LayoutTeacherPortalGroupsRouteRouteWithChildren =
  LayoutTeacherPortalGroupsRouteRoute._addFileChildren(
    LayoutTeacherPortalGroupsRouteRouteChildren,
  )

interface LayoutTeacherPortalRouteRouteChildren {
  LayoutTeacherPortalGroupsRouteRoute: typeof LayoutTeacherPortalGroupsRouteRouteWithChildren
  LayoutTeacherPortalActionPlansRoute: typeof LayoutTeacherPortalActionPlansRoute
  LayoutTeacherPortalCoursesRoute: typeof LayoutTeacherPortalCoursesRoute
  LayoutTeacherPortalWatchlistsRoute: typeof LayoutTeacherPortalWatchlistsRoute
}

const LayoutTeacherPortalRouteRouteChildren: LayoutTeacherPortalRouteRouteChildren =
  {
    LayoutTeacherPortalGroupsRouteRoute:
      LayoutTeacherPortalGroupsRouteRouteWithChildren,
    LayoutTeacherPortalActionPlansRoute: LayoutTeacherPortalActionPlansRoute,
    LayoutTeacherPortalCoursesRoute: LayoutTeacherPortalCoursesRoute,
    LayoutTeacherPortalWatchlistsRoute: LayoutTeacherPortalWatchlistsRoute,
  }

const LayoutTeacherPortalRouteRouteWithChildren =
  LayoutTeacherPortalRouteRoute._addFileChildren(
    LayoutTeacherPortalRouteRouteChildren,
  )

interface LayoutAdminRouteRouteChildren {
  LayoutAdminBannersRoute: typeof LayoutAdminBannersRoute
  LayoutAdminCalendarRoute: typeof LayoutAdminCalendarRoute
  LayoutAdminConnectedUsersRoute: typeof LayoutAdminConnectedUsersRoute
  LayoutAdminPermissionsRoute: typeof LayoutAdminPermissionsRoute
  LayoutAdminRolesRoute: typeof LayoutAdminRolesRoute
  LayoutAdminStudentListsRoute: typeof LayoutAdminStudentListsRoute
  LayoutAdminTeamsAppInstallationsRoute: typeof LayoutAdminTeamsAppInstallationsRoute
  LayoutAdminIndexRoute: typeof LayoutAdminIndexRoute
}

const LayoutAdminRouteRouteChildren: LayoutAdminRouteRouteChildren = {
  LayoutAdminBannersRoute: LayoutAdminBannersRoute,
  LayoutAdminCalendarRoute: LayoutAdminCalendarRoute,
  LayoutAdminConnectedUsersRoute: LayoutAdminConnectedUsersRoute,
  LayoutAdminPermissionsRoute: LayoutAdminPermissionsRoute,
  LayoutAdminRolesRoute: LayoutAdminRolesRoute,
  LayoutAdminStudentListsRoute: LayoutAdminStudentListsRoute,
  LayoutAdminTeamsAppInstallationsRoute: LayoutAdminTeamsAppInstallationsRoute,
  LayoutAdminIndexRoute: LayoutAdminIndexRoute,
}

const LayoutAdminRouteRouteWithChildren =
  LayoutAdminRouteRoute._addFileChildren(LayoutAdminRouteRouteChildren)

interface LayoutAssetsCardPrinterRouteChildren {
  LayoutAssetsCardPrinterPrintJobsRoute: typeof LayoutAssetsCardPrinterPrintJobsRoute
  LayoutAssetsCardPrinterPrintedCardsRoute: typeof LayoutAssetsCardPrinterPrintedCardsRoute
  LayoutAssetsCardPrinterPrintersRoute: typeof LayoutAssetsCardPrinterPrintersRoute
  LayoutAssetsCardPrinterIndexRoute: typeof LayoutAssetsCardPrinterIndexRoute
}

const LayoutAssetsCardPrinterRouteChildren: LayoutAssetsCardPrinterRouteChildren =
  {
    LayoutAssetsCardPrinterPrintJobsRoute:
      LayoutAssetsCardPrinterPrintJobsRoute,
    LayoutAssetsCardPrinterPrintedCardsRoute:
      LayoutAssetsCardPrinterPrintedCardsRoute,
    LayoutAssetsCardPrinterPrintersRoute: LayoutAssetsCardPrinterPrintersRoute,
    LayoutAssetsCardPrinterIndexRoute: LayoutAssetsCardPrinterIndexRoute,
  }

const LayoutAssetsCardPrinterRouteWithChildren =
  LayoutAssetsCardPrinterRoute._addFileChildren(
    LayoutAssetsCardPrinterRouteChildren,
  )

interface LayoutAssetsRouteRouteChildren {
  LayoutAssetsCardPrinterRoute: typeof LayoutAssetsCardPrinterRouteWithChildren
  LayoutAssetsComputersRoute: typeof LayoutAssetsComputersRoute
  LayoutAssetsMonitorsRoute: typeof LayoutAssetsMonitorsRoute
  LayoutAssetsPrintersRoute: typeof LayoutAssetsPrintersRoute
  LayoutAssetsProjectorTypesRoute: typeof LayoutAssetsProjectorTypesRoute
  LayoutAssetsIndexRoute: typeof LayoutAssetsIndexRoute
}

const LayoutAssetsRouteRouteChildren: LayoutAssetsRouteRouteChildren = {
  LayoutAssetsCardPrinterRoute: LayoutAssetsCardPrinterRouteWithChildren,
  LayoutAssetsComputersRoute: LayoutAssetsComputersRoute,
  LayoutAssetsMonitorsRoute: LayoutAssetsMonitorsRoute,
  LayoutAssetsPrintersRoute: LayoutAssetsPrintersRoute,
  LayoutAssetsProjectorTypesRoute: LayoutAssetsProjectorTypesRoute,
  LayoutAssetsIndexRoute: LayoutAssetsIndexRoute,
}

const LayoutAssetsRouteRouteWithChildren =
  LayoutAssetsRouteRoute._addFileChildren(LayoutAssetsRouteRouteChildren)

interface LayoutCalendarEventsRouteRouteChildren {
  LayoutCalendarEventsEventIdRoute: typeof LayoutCalendarEventsEventIdRoute
  LayoutCalendarEventsNewRoute: typeof LayoutCalendarEventsNewRoute
}

const LayoutCalendarEventsRouteRouteChildren: LayoutCalendarEventsRouteRouteChildren =
  {
    LayoutCalendarEventsEventIdRoute: LayoutCalendarEventsEventIdRoute,
    LayoutCalendarEventsNewRoute: LayoutCalendarEventsNewRoute,
  }

const LayoutCalendarEventsRouteRouteWithChildren =
  LayoutCalendarEventsRouteRoute._addFileChildren(
    LayoutCalendarEventsRouteRouteChildren,
  )

interface LayoutCalendarRouteRouteChildren {
  LayoutCalendarEventsRouteRoute: typeof LayoutCalendarEventsRouteRouteWithChildren
  LayoutCalendarViewRoute: typeof LayoutCalendarViewRoute
  LayoutCalendarIndexRoute: typeof LayoutCalendarIndexRoute
  LayoutCalendarEventsEventIdEditRoute: typeof LayoutCalendarEventsEventIdEditRoute
}

const LayoutCalendarRouteRouteChildren: LayoutCalendarRouteRouteChildren = {
  LayoutCalendarEventsRouteRoute: LayoutCalendarEventsRouteRouteWithChildren,
  LayoutCalendarViewRoute: LayoutCalendarViewRoute,
  LayoutCalendarIndexRoute: LayoutCalendarIndexRoute,
  LayoutCalendarEventsEventIdEditRoute: LayoutCalendarEventsEventIdEditRoute,
}

const LayoutCalendarRouteRouteWithChildren =
  LayoutCalendarRouteRoute._addFileChildren(LayoutCalendarRouteRouteChildren)

interface LayoutCarsStaffCarIdRouteRouteChildren {
  LayoutCarsStaffCarIdDvlaRoute: typeof LayoutCarsStaffCarIdDvlaRoute
  LayoutCarsStaffCarIdIndexRoute: typeof LayoutCarsStaffCarIdIndexRoute
}

const LayoutCarsStaffCarIdRouteRouteChildren: LayoutCarsStaffCarIdRouteRouteChildren =
  {
    LayoutCarsStaffCarIdDvlaRoute: LayoutCarsStaffCarIdDvlaRoute,
    LayoutCarsStaffCarIdIndexRoute: LayoutCarsStaffCarIdIndexRoute,
  }

const LayoutCarsStaffCarIdRouteRouteWithChildren =
  LayoutCarsStaffCarIdRouteRoute._addFileChildren(
    LayoutCarsStaffCarIdRouteRouteChildren,
  )

interface LayoutCarsStudentCarIdRouteRouteChildren {
  LayoutCarsStudentCarIdDvlaRoute: typeof LayoutCarsStudentCarIdDvlaRoute
  LayoutCarsStudentCarIdIndexRoute: typeof LayoutCarsStudentCarIdIndexRoute
}

const LayoutCarsStudentCarIdRouteRouteChildren: LayoutCarsStudentCarIdRouteRouteChildren =
  {
    LayoutCarsStudentCarIdDvlaRoute: LayoutCarsStudentCarIdDvlaRoute,
    LayoutCarsStudentCarIdIndexRoute: LayoutCarsStudentCarIdIndexRoute,
  }

const LayoutCarsStudentCarIdRouteRouteWithChildren =
  LayoutCarsStudentCarIdRouteRoute._addFileChildren(
    LayoutCarsStudentCarIdRouteRouteChildren,
  )

interface LayoutCarsRouteRouteChildren {
  LayoutCarsAllRoute: typeof LayoutCarsAllRoute
  LayoutCarsSearchRoute: typeof LayoutCarsSearchRoute
  LayoutCarsStaffCarIdRouteRoute: typeof LayoutCarsStaffCarIdRouteRouteWithChildren
  LayoutCarsStudentCarIdRouteRoute: typeof LayoutCarsStudentCarIdRouteRouteWithChildren
}

const LayoutCarsRouteRouteChildren: LayoutCarsRouteRouteChildren = {
  LayoutCarsAllRoute: LayoutCarsAllRoute,
  LayoutCarsSearchRoute: LayoutCarsSearchRoute,
  LayoutCarsStaffCarIdRouteRoute: LayoutCarsStaffCarIdRouteRouteWithChildren,
  LayoutCarsStudentCarIdRouteRoute:
    LayoutCarsStudentCarIdRouteRouteWithChildren,
}

const LayoutCarsRouteRouteWithChildren = LayoutCarsRouteRoute._addFileChildren(
  LayoutCarsRouteRouteChildren,
)

interface LayoutCommunicationNotificationsRouteRouteChildren {
  LayoutCommunicationNotificationsPortalNotificationsRoute: typeof LayoutCommunicationNotificationsPortalNotificationsRoute
  LayoutCommunicationNotificationsTeamsNotificationsRoute: typeof LayoutCommunicationNotificationsTeamsNotificationsRoute
}

const LayoutCommunicationNotificationsRouteRouteChildren: LayoutCommunicationNotificationsRouteRouteChildren =
  {
    LayoutCommunicationNotificationsPortalNotificationsRoute:
      LayoutCommunicationNotificationsPortalNotificationsRoute,
    LayoutCommunicationNotificationsTeamsNotificationsRoute:
      LayoutCommunicationNotificationsTeamsNotificationsRoute,
  }

const LayoutCommunicationNotificationsRouteRouteWithChildren =
  LayoutCommunicationNotificationsRouteRoute._addFileChildren(
    LayoutCommunicationNotificationsRouteRouteChildren,
  )

interface LayoutCommunicationRouteRouteChildren {
  LayoutCommunicationNotificationsRouteRoute: typeof LayoutCommunicationNotificationsRouteRouteWithChildren
  LayoutCommunicationCampaignsRoute: typeof LayoutCommunicationCampaignsRoute
  LayoutCommunicationEmailRoute: typeof LayoutCommunicationEmailRoute
  LayoutCommunicationFeedRoute: typeof LayoutCommunicationFeedRoute
  LayoutCommunicationIndexRoute: typeof LayoutCommunicationIndexRoute
}

const LayoutCommunicationRouteRouteChildren: LayoutCommunicationRouteRouteChildren =
  {
    LayoutCommunicationNotificationsRouteRoute:
      LayoutCommunicationNotificationsRouteRouteWithChildren,
    LayoutCommunicationCampaignsRoute: LayoutCommunicationCampaignsRoute,
    LayoutCommunicationEmailRoute: LayoutCommunicationEmailRoute,
    LayoutCommunicationFeedRoute: LayoutCommunicationFeedRoute,
    LayoutCommunicationIndexRoute: LayoutCommunicationIndexRoute,
  }

const LayoutCommunicationRouteRouteWithChildren =
  LayoutCommunicationRouteRoute._addFileChildren(
    LayoutCommunicationRouteRouteChildren,
  )

interface LayoutMeRouteRouteChildren {
  LayoutMeTabRoute: typeof LayoutMeTabRoute
  LayoutMeIndexRoute: typeof LayoutMeIndexRoute
}

const LayoutMeRouteRouteChildren: LayoutMeRouteRouteChildren = {
  LayoutMeTabRoute: LayoutMeTabRoute,
  LayoutMeIndexRoute: LayoutMeIndexRoute,
}

const LayoutMeRouteRouteWithChildren = LayoutMeRouteRoute._addFileChildren(
  LayoutMeRouteRouteChildren,
)

interface LayoutParentsParentIdRouteRouteChildren {
  LayoutParentsParentIdContactInfoRoute: typeof LayoutParentsParentIdContactInfoRoute
  LayoutParentsParentIdIndexRoute: typeof LayoutParentsParentIdIndexRoute
}

const LayoutParentsParentIdRouteRouteChildren: LayoutParentsParentIdRouteRouteChildren =
  {
    LayoutParentsParentIdContactInfoRoute:
      LayoutParentsParentIdContactInfoRoute,
    LayoutParentsParentIdIndexRoute: LayoutParentsParentIdIndexRoute,
  }

const LayoutParentsParentIdRouteRouteWithChildren =
  LayoutParentsParentIdRouteRoute._addFileChildren(
    LayoutParentsParentIdRouteRouteChildren,
  )

interface LayoutParentsRouteRouteChildren {
  LayoutParentsParentIdRouteRoute: typeof LayoutParentsParentIdRouteRouteWithChildren
  LayoutParentsAllRoute: typeof LayoutParentsAllRoute
}

const LayoutParentsRouteRouteChildren: LayoutParentsRouteRouteChildren = {
  LayoutParentsParentIdRouteRoute: LayoutParentsParentIdRouteRouteWithChildren,
  LayoutParentsAllRoute: LayoutParentsAllRoute,
}

const LayoutParentsRouteRouteWithChildren =
  LayoutParentsRouteRoute._addFileChildren(LayoutParentsRouteRouteChildren)

interface LayoutReferralsWellbeingManageRouteRouteChildren {
  LayoutReferralsWellbeingManageReferralIdRoute: typeof LayoutReferralsWellbeingManageReferralIdRoute
}

const LayoutReferralsWellbeingManageRouteRouteChildren: LayoutReferralsWellbeingManageRouteRouteChildren =
  {
    LayoutReferralsWellbeingManageReferralIdRoute:
      LayoutReferralsWellbeingManageReferralIdRoute,
  }

const LayoutReferralsWellbeingManageRouteRouteWithChildren =
  LayoutReferralsWellbeingManageRouteRoute._addFileChildren(
    LayoutReferralsWellbeingManageRouteRouteChildren,
  )

interface LayoutReferralsWellbeingAssignedCategoryRouteChildren {
  LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute: typeof LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute
}

const LayoutReferralsWellbeingAssignedCategoryRouteChildren: LayoutReferralsWellbeingAssignedCategoryRouteChildren =
  {
    LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute:
      LayoutReferralsWellbeingAssignedCategoryAssignmentIdRoute,
  }

const LayoutReferralsWellbeingAssignedCategoryRouteWithChildren =
  LayoutReferralsWellbeingAssignedCategoryRoute._addFileChildren(
    LayoutReferralsWellbeingAssignedCategoryRouteChildren,
  )

interface LayoutReferralsWellbeingAssignedRouteChildren {
  LayoutReferralsWellbeingAssignedCategoryRoute: typeof LayoutReferralsWellbeingAssignedCategoryRouteWithChildren
}

const LayoutReferralsWellbeingAssignedRouteChildren: LayoutReferralsWellbeingAssignedRouteChildren =
  {
    LayoutReferralsWellbeingAssignedCategoryRoute:
      LayoutReferralsWellbeingAssignedCategoryRouteWithChildren,
  }

const LayoutReferralsWellbeingAssignedRouteWithChildren =
  LayoutReferralsWellbeingAssignedRoute._addFileChildren(
    LayoutReferralsWellbeingAssignedRouteChildren,
  )

interface LayoutReferralsWellbeingMyRouteChildren {
  LayoutReferralsWellbeingMyReferralIdRoute: typeof LayoutReferralsWellbeingMyReferralIdRoute
}

const LayoutReferralsWellbeingMyRouteChildren: LayoutReferralsWellbeingMyRouteChildren =
  {
    LayoutReferralsWellbeingMyReferralIdRoute:
      LayoutReferralsWellbeingMyReferralIdRoute,
  }

const LayoutReferralsWellbeingMyRouteWithChildren =
  LayoutReferralsWellbeingMyRoute._addFileChildren(
    LayoutReferralsWellbeingMyRouteChildren,
  )

interface LayoutReferralsWellbeingRouteRouteChildren {
  LayoutReferralsWellbeingManageRouteRoute: typeof LayoutReferralsWellbeingManageRouteRouteWithChildren
  LayoutReferralsWellbeingAssignedRoute: typeof LayoutReferralsWellbeingAssignedRouteWithChildren
  LayoutReferralsWellbeingCreateRoute: typeof LayoutReferralsWellbeingCreateRoute
  LayoutReferralsWellbeingMyRoute: typeof LayoutReferralsWellbeingMyRouteWithChildren
  LayoutReferralsWellbeingIndexRoute: typeof LayoutReferralsWellbeingIndexRoute
}

const LayoutReferralsWellbeingRouteRouteChildren: LayoutReferralsWellbeingRouteRouteChildren =
  {
    LayoutReferralsWellbeingManageRouteRoute:
      LayoutReferralsWellbeingManageRouteRouteWithChildren,
    LayoutReferralsWellbeingAssignedRoute:
      LayoutReferralsWellbeingAssignedRouteWithChildren,
    LayoutReferralsWellbeingCreateRoute: LayoutReferralsWellbeingCreateRoute,
    LayoutReferralsWellbeingMyRoute:
      LayoutReferralsWellbeingMyRouteWithChildren,
    LayoutReferralsWellbeingIndexRoute: LayoutReferralsWellbeingIndexRoute,
  }

const LayoutReferralsWellbeingRouteRouteWithChildren =
  LayoutReferralsWellbeingRouteRoute._addFileChildren(
    LayoutReferralsWellbeingRouteRouteChildren,
  )

interface LayoutReferralsRouteRouteChildren {
  LayoutReferralsWellbeingRouteRoute: typeof LayoutReferralsWellbeingRouteRouteWithChildren
  LayoutReferralsExamAccessArrangementsRoute: typeof LayoutReferralsExamAccessArrangementsRoute
  LayoutReferralsStudySupportRoute: typeof LayoutReferralsStudySupportRoute
  LayoutReferralsIndexRoute: typeof LayoutReferralsIndexRoute
}

const LayoutReferralsRouteRouteChildren: LayoutReferralsRouteRouteChildren = {
  LayoutReferralsWellbeingRouteRoute:
    LayoutReferralsWellbeingRouteRouteWithChildren,
  LayoutReferralsExamAccessArrangementsRoute:
    LayoutReferralsExamAccessArrangementsRoute,
  LayoutReferralsStudySupportRoute: LayoutReferralsStudySupportRoute,
  LayoutReferralsIndexRoute: LayoutReferralsIndexRoute,
}

const LayoutReferralsRouteRouteWithChildren =
  LayoutReferralsRouteRoute._addFileChildren(LayoutReferralsRouteRouteChildren)

interface LayoutReportsRouteRouteChildren {
  LayoutReportsDestinationsRoute: typeof LayoutReportsDestinationsRoute
  LayoutReportsSarCurriculumRoute: typeof LayoutReportsSarCurriculumRoute
  LayoutReportsSarPastoralRoute: typeof LayoutReportsSarPastoralRoute
}

const LayoutReportsRouteRouteChildren: LayoutReportsRouteRouteChildren = {
  LayoutReportsDestinationsRoute: LayoutReportsDestinationsRoute,
  LayoutReportsSarCurriculumRoute: LayoutReportsSarCurriculumRoute,
  LayoutReportsSarPastoralRoute: LayoutReportsSarPastoralRoute,
}

const LayoutReportsRouteRouteWithChildren =
  LayoutReportsRouteRoute._addFileChildren(LayoutReportsRouteRouteChildren)

interface LayoutStaffInitialsRouteRouteChildren {
  LayoutStaffInitialsPhotoRoute: typeof LayoutStaffInitialsPhotoRoute
  LayoutStaffInitialsRolesRoute: typeof LayoutStaffInitialsRolesRoute
  LayoutStaffInitialsTimetableRoute: typeof LayoutStaffInitialsTimetableRoute
  LayoutStaffInitialsIndexRoute: typeof LayoutStaffInitialsIndexRoute
}

const LayoutStaffInitialsRouteRouteChildren: LayoutStaffInitialsRouteRouteChildren =
  {
    LayoutStaffInitialsPhotoRoute: LayoutStaffInitialsPhotoRoute,
    LayoutStaffInitialsRolesRoute: LayoutStaffInitialsRolesRoute,
    LayoutStaffInitialsTimetableRoute: LayoutStaffInitialsTimetableRoute,
    LayoutStaffInitialsIndexRoute: LayoutStaffInitialsIndexRoute,
  }

const LayoutStaffInitialsRouteRouteWithChildren =
  LayoutStaffInitialsRouteRoute._addFileChildren(
    LayoutStaffInitialsRouteRouteChildren,
  )

interface LayoutStaffRouteRouteChildren {
  LayoutStaffInitialsRouteRoute: typeof LayoutStaffInitialsRouteRouteWithChildren
  LayoutStaffFinderRoute: typeof LayoutStaffFinderRoute
  LayoutStaffOnSiteRoute: typeof LayoutStaffOnSiteRoute
  LayoutStaffStaffDirectoryRoute: typeof LayoutStaffStaffDirectoryRoute
  LayoutStaffIndexRoute: typeof LayoutStaffIndexRoute
}

const LayoutStaffRouteRouteChildren: LayoutStaffRouteRouteChildren = {
  LayoutStaffInitialsRouteRoute: LayoutStaffInitialsRouteRouteWithChildren,
  LayoutStaffFinderRoute: LayoutStaffFinderRoute,
  LayoutStaffOnSiteRoute: LayoutStaffOnSiteRoute,
  LayoutStaffStaffDirectoryRoute: LayoutStaffStaffDirectoryRoute,
  LayoutStaffIndexRoute: LayoutStaffIndexRoute,
}

const LayoutStaffRouteRouteWithChildren =
  LayoutStaffRouteRoute._addFileChildren(LayoutStaffRouteRouteChildren)

interface LayoutStudentsStudentNoActionPlansTypeRouteRouteChildren {
  LayoutStudentsStudentNoActionPlansTypeIndexRoute: typeof LayoutStudentsStudentNoActionPlansTypeIndexRoute
}

const LayoutStudentsStudentNoActionPlansTypeRouteRouteChildren: LayoutStudentsStudentNoActionPlansTypeRouteRouteChildren =
  {
    LayoutStudentsStudentNoActionPlansTypeIndexRoute:
      LayoutStudentsStudentNoActionPlansTypeIndexRoute,
  }

const LayoutStudentsStudentNoActionPlansTypeRouteRouteWithChildren =
  LayoutStudentsStudentNoActionPlansTypeRouteRoute._addFileChildren(
    LayoutStudentsStudentNoActionPlansTypeRouteRouteChildren,
  )

interface LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteChildren {
  LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute
}

const LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteChildren: LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteChildren =
  {
    LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute:
      LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugTargetTargetIdRoute,
  }

const LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteWithChildren =
  LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRoute._addFileChildren(
    LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteChildren,
  )

interface LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteChildren {
  LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteWithChildren
  LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute
}

const LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteChildren: LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteChildren =
  {
    LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRoute:
      LayoutStudentsStudentNoActionPlansAcademicSupportSubjectSlugRouteWithChildren,
    LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute:
      LayoutStudentsStudentNoActionPlansAcademicSupportIndexRoute,
  }

const LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteWithChildren =
  LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute._addFileChildren(
    LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteChildren,
  )

interface LayoutStudentsStudentNoActionPlansRouteRouteChildren {
  LayoutStudentsStudentNoActionPlansTypeRouteRoute: typeof LayoutStudentsStudentNoActionPlansTypeRouteRouteWithChildren
  LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute: typeof LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteWithChildren
  LayoutStudentsStudentNoActionPlansReferralsRoute: typeof LayoutStudentsStudentNoActionPlansReferralsRoute
  LayoutStudentsStudentNoActionPlansIndexRoute: typeof LayoutStudentsStudentNoActionPlansIndexRoute
}

const LayoutStudentsStudentNoActionPlansRouteRouteChildren: LayoutStudentsStudentNoActionPlansRouteRouteChildren =
  {
    LayoutStudentsStudentNoActionPlansTypeRouteRoute:
      LayoutStudentsStudentNoActionPlansTypeRouteRouteWithChildren,
    LayoutStudentsStudentNoActionPlansAcademicSupportRouteRoute:
      LayoutStudentsStudentNoActionPlansAcademicSupportRouteRouteWithChildren,
    LayoutStudentsStudentNoActionPlansReferralsRoute:
      LayoutStudentsStudentNoActionPlansReferralsRoute,
    LayoutStudentsStudentNoActionPlansIndexRoute:
      LayoutStudentsStudentNoActionPlansIndexRoute,
  }

const LayoutStudentsStudentNoActionPlansRouteRouteWithChildren =
  LayoutStudentsStudentNoActionPlansRouteRoute._addFileChildren(
    LayoutStudentsStudentNoActionPlansRouteRouteChildren,
  )

interface LayoutStudentsStudentNoAttendanceRouteRouteChildren {
  LayoutStudentsStudentNoAttendanceAbsencesRoute: typeof LayoutStudentsStudentNoAttendanceAbsencesRoute
  LayoutStudentsStudentNoAttendancePunctualityRoute: typeof LayoutStudentsStudentNoAttendancePunctualityRoute
  LayoutStudentsStudentNoAttendanceIndexRoute: typeof LayoutStudentsStudentNoAttendanceIndexRoute
}

const LayoutStudentsStudentNoAttendanceRouteRouteChildren: LayoutStudentsStudentNoAttendanceRouteRouteChildren =
  {
    LayoutStudentsStudentNoAttendanceAbsencesRoute:
      LayoutStudentsStudentNoAttendanceAbsencesRoute,
    LayoutStudentsStudentNoAttendancePunctualityRoute:
      LayoutStudentsStudentNoAttendancePunctualityRoute,
    LayoutStudentsStudentNoAttendanceIndexRoute:
      LayoutStudentsStudentNoAttendanceIndexRoute,
  }

const LayoutStudentsStudentNoAttendanceRouteRouteWithChildren =
  LayoutStudentsStudentNoAttendanceRouteRoute._addFileChildren(
    LayoutStudentsStudentNoAttendanceRouteRouteChildren,
  )

interface LayoutStudentsStudentNoConversationsRouteRouteChildren {
  LayoutStudentsStudentNoConversationsConversationIdRoute: typeof LayoutStudentsStudentNoConversationsConversationIdRoute
  LayoutStudentsStudentNoConversationsIndexRoute: typeof LayoutStudentsStudentNoConversationsIndexRoute
}

const LayoutStudentsStudentNoConversationsRouteRouteChildren: LayoutStudentsStudentNoConversationsRouteRouteChildren =
  {
    LayoutStudentsStudentNoConversationsConversationIdRoute:
      LayoutStudentsStudentNoConversationsConversationIdRoute,
    LayoutStudentsStudentNoConversationsIndexRoute:
      LayoutStudentsStudentNoConversationsIndexRoute,
  }

const LayoutStudentsStudentNoConversationsRouteRouteWithChildren =
  LayoutStudentsStudentNoConversationsRouteRoute._addFileChildren(
    LayoutStudentsStudentNoConversationsRouteRouteChildren,
  )

interface LayoutStudentsStudentNoRouteRouteChildren {
  LayoutStudentsStudentNoActionPlansRouteRoute: typeof LayoutStudentsStudentNoActionPlansRouteRouteWithChildren
  LayoutStudentsStudentNoAttendanceRouteRoute: typeof LayoutStudentsStudentNoAttendanceRouteRouteWithChildren
  LayoutStudentsStudentNoConversationsRouteRoute: typeof LayoutStudentsStudentNoConversationsRouteRouteWithChildren
  LayoutStudentsStudentNoDetailsRoute: typeof LayoutStudentsStudentNoDetailsRoute
  LayoutStudentsStudentNoDocumentsRoute: typeof LayoutStudentsStudentNoDocumentsRoute
  LayoutStudentsStudentNoGcseRoute: typeof LayoutStudentsStudentNoGcseRoute
  LayoutStudentsStudentNoMarkbookRoute: typeof LayoutStudentsStudentNoMarkbookRoute
  LayoutStudentsStudentNoParentsRoute: typeof LayoutStudentsStudentNoParentsRoute
  LayoutStudentsStudentNoPhotoRoute: typeof LayoutStudentsStudentNoPhotoRoute
  LayoutStudentsStudentNoReviewsRoute: typeof LayoutStudentsStudentNoReviewsRoute
  LayoutStudentsStudentNoStudentAgreementsRoute: typeof LayoutStudentsStudentNoStudentAgreementsRoute
  LayoutStudentsStudentNoSummaryRoute: typeof LayoutStudentsStudentNoSummaryRoute
  LayoutStudentsStudentNoSupportRoute: typeof LayoutStudentsStudentNoSupportRoute
  LayoutStudentsStudentNoTimetableRoute: typeof LayoutStudentsStudentNoTimetableRoute
  LayoutStudentsStudentNoIndexRoute: typeof LayoutStudentsStudentNoIndexRoute
}

const LayoutStudentsStudentNoRouteRouteChildren: LayoutStudentsStudentNoRouteRouteChildren =
  {
    LayoutStudentsStudentNoActionPlansRouteRoute:
      LayoutStudentsStudentNoActionPlansRouteRouteWithChildren,
    LayoutStudentsStudentNoAttendanceRouteRoute:
      LayoutStudentsStudentNoAttendanceRouteRouteWithChildren,
    LayoutStudentsStudentNoConversationsRouteRoute:
      LayoutStudentsStudentNoConversationsRouteRouteWithChildren,
    LayoutStudentsStudentNoDetailsRoute: LayoutStudentsStudentNoDetailsRoute,
    LayoutStudentsStudentNoDocumentsRoute:
      LayoutStudentsStudentNoDocumentsRoute,
    LayoutStudentsStudentNoGcseRoute: LayoutStudentsStudentNoGcseRoute,
    LayoutStudentsStudentNoMarkbookRoute: LayoutStudentsStudentNoMarkbookRoute,
    LayoutStudentsStudentNoParentsRoute: LayoutStudentsStudentNoParentsRoute,
    LayoutStudentsStudentNoPhotoRoute: LayoutStudentsStudentNoPhotoRoute,
    LayoutStudentsStudentNoReviewsRoute: LayoutStudentsStudentNoReviewsRoute,
    LayoutStudentsStudentNoStudentAgreementsRoute:
      LayoutStudentsStudentNoStudentAgreementsRoute,
    LayoutStudentsStudentNoSummaryRoute: LayoutStudentsStudentNoSummaryRoute,
    LayoutStudentsStudentNoSupportRoute: LayoutStudentsStudentNoSupportRoute,
    LayoutStudentsStudentNoTimetableRoute:
      LayoutStudentsStudentNoTimetableRoute,
    LayoutStudentsStudentNoIndexRoute: LayoutStudentsStudentNoIndexRoute,
  }

const LayoutStudentsStudentNoRouteRouteWithChildren =
  LayoutStudentsStudentNoRouteRoute._addFileChildren(
    LayoutStudentsStudentNoRouteRouteChildren,
  )

interface LayoutStudentsRouteRouteChildren {
  LayoutStudentsStudentNoRouteRoute: typeof LayoutStudentsStudentNoRouteRouteWithChildren
  LayoutStudentsFinderRoute: typeof LayoutStudentsFinderRoute
  LayoutStudentsListsRoute: typeof LayoutStudentsListsRoute
  LayoutStudentsMyRoute: typeof LayoutStudentsMyRoute
  LayoutStudentsIndexRoute: typeof LayoutStudentsIndexRoute
}

const LayoutStudentsRouteRouteChildren: LayoutStudentsRouteRouteChildren = {
  LayoutStudentsStudentNoRouteRoute:
    LayoutStudentsStudentNoRouteRouteWithChildren,
  LayoutStudentsFinderRoute: LayoutStudentsFinderRoute,
  LayoutStudentsListsRoute: LayoutStudentsListsRoute,
  LayoutStudentsMyRoute: LayoutStudentsMyRoute,
  LayoutStudentsIndexRoute: LayoutStudentsIndexRoute,
}

const LayoutStudentsRouteRouteWithChildren =
  LayoutStudentsRouteRoute._addFileChildren(LayoutStudentsRouteRouteChildren)

interface LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteChildren {
  LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute
  LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute
}

const LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteChildren: LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteChildren =
  {
    LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute:
      LayoutToolsTeamsAdministrationTeamsTeamIdIndexRoute,
    LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute:
      LayoutToolsTeamsAdministrationTeamsTeamIdChannelsChannelIdRoute,
  }

const LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteWithChildren =
  LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute._addFileChildren(
    LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteChildren,
  )

interface LayoutToolsTeamsAdministrationTeamsRouteRouteChildren {
  LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute: typeof LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteWithChildren
  LayoutToolsTeamsAdministrationTeamsIndexRoute: typeof LayoutToolsTeamsAdministrationTeamsIndexRoute
}

const LayoutToolsTeamsAdministrationTeamsRouteRouteChildren: LayoutToolsTeamsAdministrationTeamsRouteRouteChildren =
  {
    LayoutToolsTeamsAdministrationTeamsTeamIdRouteRoute:
      LayoutToolsTeamsAdministrationTeamsTeamIdRouteRouteWithChildren,
    LayoutToolsTeamsAdministrationTeamsIndexRoute:
      LayoutToolsTeamsAdministrationTeamsIndexRoute,
  }

const LayoutToolsTeamsAdministrationTeamsRouteRouteWithChildren =
  LayoutToolsTeamsAdministrationTeamsRouteRoute._addFileChildren(
    LayoutToolsTeamsAdministrationTeamsRouteRouteChildren,
  )

interface LayoutToolsTeamsAdministrationRouteRouteChildren {
  LayoutToolsTeamsAdministrationTeamsRouteRoute: typeof LayoutToolsTeamsAdministrationTeamsRouteRouteWithChildren
  LayoutToolsTeamsAdministrationIndexRoute: typeof LayoutToolsTeamsAdministrationIndexRoute
}

const LayoutToolsTeamsAdministrationRouteRouteChildren: LayoutToolsTeamsAdministrationRouteRouteChildren =
  {
    LayoutToolsTeamsAdministrationTeamsRouteRoute:
      LayoutToolsTeamsAdministrationTeamsRouteRouteWithChildren,
    LayoutToolsTeamsAdministrationIndexRoute:
      LayoutToolsTeamsAdministrationIndexRoute,
  }

const LayoutToolsTeamsAdministrationRouteRouteWithChildren =
  LayoutToolsTeamsAdministrationRouteRoute._addFileChildren(
    LayoutToolsTeamsAdministrationRouteRouteChildren,
  )

interface LayoutToolsRouteRouteChildren {
  LayoutToolsTeamsAdministrationRouteRoute: typeof LayoutToolsTeamsAdministrationRouteRouteWithChildren
  LayoutToolsQrCodeMakerRoute: typeof LayoutToolsQrCodeMakerRoute
  LayoutToolsSendTeamsMessageRoute: typeof LayoutToolsSendTeamsMessageRoute
  LayoutToolsSortathonRoute: typeof LayoutToolsSortathonRoute
  LayoutToolsSoundboardRoute: typeof LayoutToolsSoundboardRoute
  LayoutToolsIndexRoute: typeof LayoutToolsIndexRoute
}

const LayoutToolsRouteRouteChildren: LayoutToolsRouteRouteChildren = {
  LayoutToolsTeamsAdministrationRouteRoute:
    LayoutToolsTeamsAdministrationRouteRouteWithChildren,
  LayoutToolsQrCodeMakerRoute: LayoutToolsQrCodeMakerRoute,
  LayoutToolsSendTeamsMessageRoute: LayoutToolsSendTeamsMessageRoute,
  LayoutToolsSortathonRoute: LayoutToolsSortathonRoute,
  LayoutToolsSoundboardRoute: LayoutToolsSoundboardRoute,
  LayoutToolsIndexRoute: LayoutToolsIndexRoute,
}

const LayoutToolsRouteRouteWithChildren =
  LayoutToolsRouteRoute._addFileChildren(LayoutToolsRouteRouteChildren)

interface LayoutTimetablesTypeRouteChildren {
  LayoutTimetablesTypeIdentifierRoute: typeof LayoutTimetablesTypeIdentifierRoute
}

const LayoutTimetablesTypeRouteChildren: LayoutTimetablesTypeRouteChildren = {
  LayoutTimetablesTypeIdentifierRoute: LayoutTimetablesTypeIdentifierRoute,
}

const LayoutTimetablesTypeRouteWithChildren =
  LayoutTimetablesTypeRoute._addFileChildren(LayoutTimetablesTypeRouteChildren)

interface LayoutTimetablesRouteChildren {
  LayoutTimetablesTypeRoute: typeof LayoutTimetablesTypeRouteWithChildren
}

const LayoutTimetablesRouteChildren: LayoutTimetablesRouteChildren = {
  LayoutTimetablesTypeRoute: LayoutTimetablesTypeRouteWithChildren,
}

const LayoutTimetablesRouteWithChildren =
  LayoutTimetablesRoute._addFileChildren(LayoutTimetablesRouteChildren)

interface LayoutRouteChildren {
  LayoutTeacherPortalRouteRoute: typeof LayoutTeacherPortalRouteRouteWithChildren
  LayoutAdminRouteRoute: typeof LayoutAdminRouteRouteWithChildren
  LayoutAssetsRouteRoute: typeof LayoutAssetsRouteRouteWithChildren
  LayoutCalendarRouteRoute: typeof LayoutCalendarRouteRouteWithChildren
  LayoutCarsRouteRoute: typeof LayoutCarsRouteRouteWithChildren
  LayoutCommunicationRouteRoute: typeof LayoutCommunicationRouteRouteWithChildren
  LayoutMeRouteRoute: typeof LayoutMeRouteRouteWithChildren
  LayoutParentsRouteRoute: typeof LayoutParentsRouteRouteWithChildren
  LayoutReferralsRouteRoute: typeof LayoutReferralsRouteRouteWithChildren
  LayoutReportsRouteRoute: typeof LayoutReportsRouteRouteWithChildren
  LayoutStaffRouteRoute: typeof LayoutStaffRouteRouteWithChildren
  LayoutStudentsRouteRoute: typeof LayoutStudentsRouteRouteWithChildren
  LayoutToolsRouteRoute: typeof LayoutToolsRouteRouteWithChildren
  LayoutBookARoomRoute: typeof LayoutBookARoomRoute
  LayoutFeedRoute: typeof LayoutFeedRoute
  LayoutHomeRoute: typeof LayoutHomeRoute
  LayoutMapRoute: typeof LayoutMapRoute
  LayoutNoticesRoute: typeof LayoutNoticesRoute
  LayoutNotificationsRoute: typeof LayoutNotificationsRoute
  LayoutParentShopRoute: typeof LayoutParentShopRoute
  LayoutReportHubRoute: typeof LayoutReportHubRoute
  LayoutRoomsRoute: typeof LayoutRoomsRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutTabsRoute: typeof LayoutTabsRoute
  LayoutTeacherPortalRoute: typeof LayoutTeacherPortalRoute
  LayoutTicketsRoute: typeof LayoutTicketsRoute
  LayoutTimetablesRoute: typeof LayoutTimetablesRouteWithChildren
  LayoutUnauthorisedRoute: typeof LayoutUnauthorisedRoute
  LayoutDocumentsChar123FolderIdChar125Route: typeof LayoutDocumentsChar123FolderIdChar125Route
  LayoutParentsEveningBookRoute: typeof LayoutParentsEveningBookRoute
  LayoutParentsEveningMeetRoute: typeof LayoutParentsEveningMeetRoute
  LayoutStudentFuturesDestinationsRoute: typeof LayoutStudentFuturesDestinationsRoute
  LayoutParentsEveningIndexRoute: typeof LayoutParentsEveningIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutTeacherPortalRouteRoute: LayoutTeacherPortalRouteRouteWithChildren,
  LayoutAdminRouteRoute: LayoutAdminRouteRouteWithChildren,
  LayoutAssetsRouteRoute: LayoutAssetsRouteRouteWithChildren,
  LayoutCalendarRouteRoute: LayoutCalendarRouteRouteWithChildren,
  LayoutCarsRouteRoute: LayoutCarsRouteRouteWithChildren,
  LayoutCommunicationRouteRoute: LayoutCommunicationRouteRouteWithChildren,
  LayoutMeRouteRoute: LayoutMeRouteRouteWithChildren,
  LayoutParentsRouteRoute: LayoutParentsRouteRouteWithChildren,
  LayoutReferralsRouteRoute: LayoutReferralsRouteRouteWithChildren,
  LayoutReportsRouteRoute: LayoutReportsRouteRouteWithChildren,
  LayoutStaffRouteRoute: LayoutStaffRouteRouteWithChildren,
  LayoutStudentsRouteRoute: LayoutStudentsRouteRouteWithChildren,
  LayoutToolsRouteRoute: LayoutToolsRouteRouteWithChildren,
  LayoutBookARoomRoute: LayoutBookARoomRoute,
  LayoutFeedRoute: LayoutFeedRoute,
  LayoutHomeRoute: LayoutHomeRoute,
  LayoutMapRoute: LayoutMapRoute,
  LayoutNoticesRoute: LayoutNoticesRoute,
  LayoutNotificationsRoute: LayoutNotificationsRoute,
  LayoutParentShopRoute: LayoutParentShopRoute,
  LayoutReportHubRoute: LayoutReportHubRoute,
  LayoutRoomsRoute: LayoutRoomsRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutTabsRoute: LayoutTabsRoute,
  LayoutTeacherPortalRoute: LayoutTeacherPortalRoute,
  LayoutTicketsRoute: LayoutTicketsRoute,
  LayoutTimetablesRoute: LayoutTimetablesRouteWithChildren,
  LayoutUnauthorisedRoute: LayoutUnauthorisedRoute,
  LayoutDocumentsChar123FolderIdChar125Route:
    LayoutDocumentsChar123FolderIdChar125Route,
  LayoutParentsEveningBookRoute: LayoutParentsEveningBookRoute,
  LayoutParentsEveningMeetRoute: LayoutParentsEveningMeetRoute,
  LayoutStudentFuturesDestinationsRoute: LayoutStudentFuturesDestinationsRoute,
  LayoutParentsEveningIndexRoute: LayoutParentsEveningIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface NolayoutAuthRouteRouteChildren {
  NolayoutAuthRegisterRoute: typeof NolayoutAuthRegisterRoute
  NolayoutAuthSignInRoute: typeof NolayoutAuthSignInRoute
}

const NolayoutAuthRouteRouteChildren: NolayoutAuthRouteRouteChildren = {
  NolayoutAuthRegisterRoute: NolayoutAuthRegisterRoute,
  NolayoutAuthSignInRoute: NolayoutAuthSignInRoute,
}

const NolayoutAuthRouteRouteWithChildren =
  NolayoutAuthRouteRoute._addFileChildren(NolayoutAuthRouteRouteChildren)

interface NolayoutRouteChildren {
  NolayoutAuthRouteRoute: typeof NolayoutAuthRouteRouteWithChildren
  NolayoutPublicPageRoute: typeof NolayoutPublicPageRoute
  NolayoutInductionIndexRoute: typeof NolayoutInductionIndexRoute
}

const NolayoutRouteChildren: NolayoutRouteChildren = {
  NolayoutAuthRouteRoute: NolayoutAuthRouteRouteWithChildren,
  NolayoutPublicPageRoute: NolayoutPublicPageRoute,
  NolayoutInductionIndexRoute: NolayoutInductionIndexRoute,
}

const NolayoutRouteWithChildren = NolayoutRoute._addFileChildren(
  NolayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  NolayoutRoute: NolayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
